/*! shopify_app_compiler 2026-06-29 */
var requirejs, require, define;

!function(global, setTimeout) {
    var req, s, head, baseElement, dataMain, src, interactiveScript, currentlyAddingScript, mainScript, subPath, version = "2.3.6", commentRegExp = /\/\*[\s\S]*?\*\/|([^:"'=]|^)\/\/.*$/gm, cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g, jsSuffixRegExp = /\.js$/, currDirRegExp = /^\.\//, op = Object.prototype, ostring = op.toString, hasOwn = op.hasOwnProperty, isBrowser = !("undefined" == typeof window || "undefined" == typeof navigator || !window.document), isWebWorker = !isBrowser && "undefined" != typeof importScripts, readyRegExp = isBrowser && "PLAYSTATION 3" === navigator.platform ? /^complete$/ : /^(complete|loaded)$/, defContextName = "_", isOpera = "undefined" != typeof opera && "[object Opera]" === opera.toString(), contexts = {}, cfg = {}, globalDefQueue = [], useInteractive = !1;
    function commentReplace(e, t) {
        return t || "";
    }
    function isFunction(e) {
        return "[object Function]" === ostring.call(e);
    }
    function isArray(e) {
        return "[object Array]" === ostring.call(e);
    }
    function each(e, t) {
        var i;
        if (e) for (i = 0; i < e.length && (!e[i] || !t(e[i], i, e)); i += 1);
    }
    function eachReverse(e, t) {
        var i;
        if (e) for (i = e.length - 1; -1 < i && (!e[i] || !t(e[i], i, e)); i -= 1);
    }
    function hasProp(e, t) {
        return hasOwn.call(e, t);
    }
    function getOwn(e, t) {
        return hasProp(e, t) && e[t];
    }
    function eachProp(e, t) {
        var i;
        for (i in e) if (hasProp(e, i) && t(e[i], i)) break;
    }
    function mixin(i, e, r, n) {
        return e && eachProp(e, function(e, t) {
            !r && hasProp(i, t) || (!n || "object" != typeof e || !e || isArray(e) || isFunction(e) || e instanceof RegExp ? i[t] = e : (i[t] || (i[t] = {}), 
            mixin(i[t], e, r, n)));
        }), i;
    }
    function bind(e, t) {
        return function() {
            return t.apply(e, arguments);
        };
    }
    function scripts() {
        return document.getElementsByTagName("script");
    }
    function defaultOnError(e) {
        throw e;
    }
    function getGlobal(e) {
        if (!e) return e;
        var t = global;
        return each(e.split("."), function(e) {
            t = t[e];
        }), t;
    }
    function makeError(e, t, i, r) {
        var n = new Error(t + "\nhttps://requirejs.org/docs/errors.html#" + e);
        return n.requireType = e, n.requireModules = r, i && (n.originalError = i), 
        n;
    }
    if (void 0 === define) {
        if (void 0 !== requirejs) {
            if (isFunction(requirejs)) return;
            cfg = requirejs, requirejs = void 0;
        }
        void 0 === require || isFunction(require) || (cfg = require, require = void 0), 
        req = requirejs = function(e, t, i, r) {
            var n, o, a = defContextName;
            return isArray(e) || "string" == typeof e || (o = e, isArray(t) ? (e = t, 
            t = i, i = r) : e = []), o && o.context && (a = o.context), (n = getOwn(contexts, a)) || (n = contexts[a] = req.s.newContext(a)), 
            o && n.configure(o), n.require(e, t, i);
        }, req.config = function(e) {
            return req(e);
        }, req.nextTick = void 0 !== setTimeout ? function(e) {
            setTimeout(e, 4);
        } : function(e) {
            e();
        }, require || (require = req), req.version = version, req.jsExtRegExp = /^\/|:|\?|\.js$/, 
        req.isBrowser = isBrowser, s = req.s = {
            contexts: contexts,
            newContext: newContext
        }, req({}), each([ "toUrl", "undef", "defined", "specified" ], function(t) {
            req[t] = function() {
                var e = contexts[defContextName];
                return e.require[t].apply(e, arguments);
            };
        }), isBrowser && (head = s.head = document.getElementsByTagName("head")[0], 
        baseElement = document.getElementsByTagName("base")[0], baseElement && (head = s.head = baseElement.parentNode)), 
        req.onError = defaultOnError, req.createNode = function(e, t, i) {
            var r = e.xhtml ? document.createElementNS("http://www.w3.org/1999/xhtml", "html:script") : document.createElement("script");
            return r.type = e.scriptType || "text/javascript", r.charset = "utf-8", 
            r.async = !0, r;
        }, req.load = function(t, i, r) {
            var e, n = t && t.config || {};
            if (isBrowser) return (e = req.createNode(n, i, r)).setAttribute("data-requirecontext", t.contextName), 
            e.setAttribute("data-requiremodule", i), !e.attachEvent || e.attachEvent.toString && e.attachEvent.toString().indexOf("[native code") < 0 || isOpera ? (e.addEventListener("load", t.onScriptLoad, !1), 
            e.addEventListener("error", t.onScriptError, !1)) : (useInteractive = !0, 
            e.attachEvent("onreadystatechange", t.onScriptLoad)), e.src = r, n.onNodeCreated && n.onNodeCreated(e, n, i, r), 
            currentlyAddingScript = e, baseElement ? head.insertBefore(e, baseElement) : head.appendChild(e), 
            currentlyAddingScript = null, e;
            if (isWebWorker) try {
                setTimeout(function() {}, 0), importScripts(r), t.completeLoad(i);
            } catch (e) {
                t.onError(makeError("importscripts", "importScripts failed for " + i + " at " + r, e, [ i ]));
            }
        }, isBrowser && !cfg.skipDataMain && eachReverse(scripts(), function(e) {
            if (head || (head = e.parentNode), dataMain = e.getAttribute("data-main")) return mainScript = dataMain, 
            cfg.baseUrl || -1 !== mainScript.indexOf("!") || (mainScript = (src = mainScript.split("/")).pop(), 
            subPath = src.length ? src.join("/") + "/" : "./", cfg.baseUrl = subPath), 
            mainScript = mainScript.replace(jsSuffixRegExp, ""), req.jsExtRegExp.test(mainScript) && (mainScript = dataMain), 
            cfg.deps = cfg.deps ? cfg.deps.concat(mainScript) : [ mainScript ], 
            !0;
        }), define = function(e, i, t) {
            var r, n;
            "string" != typeof e && (t = i, i = e, e = null), isArray(i) || (t = i, 
            i = null), !i && isFunction(t) && (i = [], t.length && (t.toString().replace(commentRegExp, commentReplace).replace(cjsRequireRegExp, function(e, t) {
                i.push(t);
            }), i = (1 === t.length ? [ "require" ] : [ "require", "exports", "module" ]).concat(i))), 
            useInteractive && (r = currentlyAddingScript || getInteractiveScript()) && (e || (e = r.getAttribute("data-requiremodule")), 
            n = contexts[r.getAttribute("data-requirecontext")]), n ? (n.defQueue.push([ e, i, t ]), 
            n.defQueueMap[e] = !0) : globalDefQueue.push([ e, i, t ]);
        }, define.amd = {
            jQuery: !0
        }, req.exec = function(text) {
            return eval(text);
        }, req(cfg);
    }
    function newContext(u) {
        var i, e, l, c, d, g = {
            waitSeconds: 7,
            baseUrl: "./",
            paths: {},
            bundles: {},
            pkgs: {},
            shim: {},
            config: {}
        }, p = {}, f = {}, r = {}, h = [], m = {}, n = {}, v = {}, x = 1, b = 1;
        function q(e, t, i) {
            var r, n, o, a, s, u, c, d, p, f, l = t && t.split("/"), h = g.map, m = h && h["*"];
            if (e && (u = (e = e.split("/")).length - 1, g.nodeIdCompat && jsSuffixRegExp.test(e[u]) && (e[u] = e[u].replace(jsSuffixRegExp, "")), 
            "." === e[0].charAt(0) && l && (e = l.slice(0, l.length - 1).concat(e)), 
            function(e) {
                var t, i;
                for (t = 0; t < e.length; t++) if ("." === (i = e[t])) e.splice(t, 1), 
                t -= 1; else if (".." === i) {
                    if (0 === t || 1 === t && ".." === e[2] || ".." === e[t - 1]) continue;
                    0 < t && (e.splice(t - 1, 2), t -= 2);
                }
            }(e), e = e.join("/")), i && h && (l || m)) {
                e: for (o = (n = e.split("/")).length; 0 < o; o -= 1) {
                    if (s = n.slice(0, o).join("/"), l) for (a = l.length; 0 < a; a -= 1) if ((r = getOwn(h, l.slice(0, a).join("/"))) && (r = getOwn(r, s))) {
                        c = r, d = o;
                        break e;
                    }
                    !p && m && getOwn(m, s) && (p = getOwn(m, s), f = o);
                }
                !c && p && (c = p, d = f), c && (n.splice(0, d, c), e = n.join("/"));
            }
            return getOwn(g.pkgs, e) || e;
        }
        function E(t) {
            isBrowser && each(scripts(), function(e) {
                if (e.getAttribute("data-requiremodule") === t && e.getAttribute("data-requirecontext") === l.contextName) return e.parentNode.removeChild(e), 
                !0;
            });
        }
        function w(e) {
            var t = getOwn(g.paths, e);
            if (t && isArray(t) && 1 < t.length) return t.shift(), l.require.undef(e), 
            l.makeRequire(null, {
                skipMap: !0
            })([ e ]), !0;
        }
        function y(e) {
            var t, i = e ? e.indexOf("!") : -1;
            return -1 < i && (t = e.substring(0, i), e = e.substring(i + 1, e.length)), 
            [ t, e ];
        }
        function S(e, t, i, r) {
            var n, o, a, s, u = null, c = t ? t.name : null, d = e, p = !0, f = "";
            return e || (p = !1, e = "_@r" + (x += 1)), u = (s = y(e))[0], e = s[1], 
            u && (u = q(u, c, r), o = getOwn(m, u)), e && (u ? f = i ? e : o && o.normalize ? o.normalize(e, function(e) {
                return q(e, c, r);
            }) : -1 === e.indexOf("!") ? q(e, c, r) : e : (u = (s = y(f = q(e, c, r)))[0], 
            f = s[1], i = !0, n = l.nameToUrl(f))), {
                prefix: u,
                name: f,
                parentMap: t,
                unnormalized: !!(a = !u || o || i ? "" : "_unnormalized" + (b += 1)),
                url: n,
                originalName: d,
                isDefine: p,
                id: (u ? u + "!" + f : f) + a
            };
        }
        function k(e) {
            var t = e.id, i = getOwn(p, t);
            return i || (i = p[t] = new l.Module(e)), i;
        }
        function M(e, t, i) {
            var r = e.id, n = getOwn(p, r);
            !hasProp(m, r) || n && !n.defineEmitComplete ? (n = k(e)).error && "error" === t ? i(n.error) : n.on(t, i) : "defined" === t && i(m[r]);
        }
        function O(i, e) {
            var t = i.requireModules, r = !1;
            e ? e(i) : (each(t, function(e) {
                var t = getOwn(p, e);
                t && (t.error = i, t.events.error && (r = !0, t.emit("error", i)));
            }), r || req.onError(i));
        }
        function j() {
            globalDefQueue.length && (each(globalDefQueue, function(e) {
                var t = e[0];
                "string" == typeof t && (l.defQueueMap[t] = !0), h.push(e);
            }), globalDefQueue = []);
        }
        function P(e) {
            delete p[e], delete f[e];
        }
        function R() {
            var e, r, t = 1e3 * g.waitSeconds, n = t && l.startTime + t < new Date().getTime(), o = [], a = [], s = !1, u = !0;
            if (!i) {
                if (i = !0, eachProp(f, function(e) {
                    var t = e.map, i = t.id;
                    if (e.enabled && (t.isDefine || a.push(e), !e.error)) if (!e.inited && n) w(i) ? s = r = !0 : (o.push(i), 
                    E(i)); else if (!e.inited && e.fetched && t.isDefine && (s = !0, 
                    !t.prefix)) return u = !1;
                }), n && o.length) return (e = makeError("timeout", "Load timeout for modules: " + o, null, o)).contextName = l.contextName, 
                O(e);
                u && each(a, function(e) {
                    !function n(o, a, s) {
                        var e = o.map.id;
                        o.error ? o.emit("error", o.error) : (a[e] = !0, each(o.depMaps, function(e, t) {
                            var i = e.id, r = getOwn(p, i);
                            !r || o.depMatched[t] || s[i] || (getOwn(a, i) ? (o.defineDep(t, m[i]), 
                            o.check()) : n(r, a, s));
                        }), s[e] = !0);
                    }(e, {}, {});
                }), n && !r || !s || !isBrowser && !isWebWorker || d || (d = setTimeout(function() {
                    d = 0, R();
                }, 50)), i = !1;
            }
        }
        function a(e) {
            hasProp(m, e[0]) || k(S(e[0], null, !0)).init(e[1], e[2]);
        }
        function o(e, t, i, r) {
            e.detachEvent && !isOpera ? r && e.detachEvent(r, t) : e.removeEventListener(i, t, !1);
        }
        function s(e) {
            var t = e.currentTarget || e.srcElement;
            return o(t, l.onScriptLoad, "load", "onreadystatechange"), o(t, l.onScriptError, "error"), 
            {
                node: t,
                id: t && t.getAttribute("data-requiremodule")
            };
        }
        function T() {
            var e;
            for (j(); h.length; ) {
                if (null === (e = h.shift())[0]) return O(makeError("mismatch", "Mismatched anonymous define() module: " + e[e.length - 1]));
                a(e);
            }
            l.defQueueMap = {};
        }
        return c = {
            require: function(e) {
                return e.require ? e.require : e.require = l.makeRequire(e.map);
            },
            exports: function(e) {
                if (e.usingExports = !0, e.map.isDefine) return e.exports ? m[e.map.id] = e.exports : e.exports = m[e.map.id] = {};
            },
            module: function(e) {
                return e.module ? e.module : e.module = {
                    id: e.map.id,
                    uri: e.map.url,
                    config: function() {
                        return getOwn(g.config, e.map.id) || {};
                    },
                    exports: e.exports || (e.exports = {})
                };
            }
        }, (e = function(e) {
            this.events = getOwn(r, e.id) || {}, this.map = e, this.shim = getOwn(g.shim, e.id), 
            this.depExports = [], this.depMaps = [], this.depMatched = [], this.pluginMaps = {}, 
            this.depCount = 0;
        }).prototype = {
            init: function(e, t, i, r) {
                r = r || {}, this.inited || (this.factory = t, i ? this.on("error", i) : this.events.error && (i = bind(this, function(e) {
                    this.emit("error", e);
                })), this.depMaps = e && e.slice(0), this.errback = i, this.inited = !0, 
                this.ignore = r.ignore, r.enabled || this.enabled ? this.enable() : this.check());
            },
            defineDep: function(e, t) {
                this.depMatched[e] || (this.depMatched[e] = !0, this.depCount -= 1, 
                this.depExports[e] = t);
            },
            fetch: function() {
                if (!this.fetched) {
                    this.fetched = !0, l.startTime = new Date().getTime();
                    var e = this.map;
                    if (!this.shim) return e.prefix ? this.callPlugin() : this.load();
                    l.makeRequire(this.map, {
                        enableBuildCallback: !0
                    })(this.shim.deps || [], bind(this, function() {
                        return e.prefix ? this.callPlugin() : this.load();
                    }));
                }
            },
            load: function() {
                var e = this.map.url;
                n[e] || (n[e] = !0, l.load(this.map.id, e));
            },
            check: function() {
                if (this.enabled && !this.enabling) {
                    var t, e, i = this.map.id, r = this.depExports, n = this.exports, o = this.factory;
                    if (this.inited) {
                        if (this.error) this.emit("error", this.error); else if (!this.defining) {
                            if (this.defining = !0, this.depCount < 1 && !this.defined) {
                                if (isFunction(o)) {
                                    if (this.events.error && this.map.isDefine || req.onError !== defaultOnError) try {
                                        n = l.execCb(i, o, r, n);
                                    } catch (e) {
                                        t = e;
                                    } else n = l.execCb(i, o, r, n);
                                    if (this.map.isDefine && void 0 === n && ((e = this.module) ? n = e.exports : this.usingExports && (n = this.exports)), 
                                    t) return t.requireMap = this.map, t.requireModules = this.map.isDefine ? [ this.map.id ] : null, 
                                    t.requireType = this.map.isDefine ? "define" : "require", 
                                    O(this.error = t);
                                } else n = o;
                                if (this.exports = n, this.map.isDefine && !this.ignore && (m[i] = n, 
                                req.onResourceLoad)) {
                                    var a = [];
                                    each(this.depMaps, function(e) {
                                        a.push(e.normalizedMap || e);
                                    }), req.onResourceLoad(l, this.map, a);
                                }
                                P(i), this.defined = !0;
                            }
                            this.defining = !1, this.defined && !this.defineEmitted && (this.defineEmitted = !0, 
                            this.emit("defined", this.exports), this.defineEmitComplete = !0);
                        }
                    } else hasProp(l.defQueueMap, i) || this.fetch();
                }
            },
            callPlugin: function() {
                var u = this.map, c = u.id, e = S(u.prefix);
                this.depMaps.push(e), M(e, "defined", bind(this, function(e) {
                    var o, t, i, r = getOwn(v, this.map.id), n = this.map.name, a = this.map.parentMap ? this.map.parentMap.name : null, s = l.makeRequire(u.parentMap, {
                        enableBuildCallback: !0
                    });
                    return this.map.unnormalized ? (e.normalize && (n = e.normalize(n, function(e) {
                        return q(e, a, !0);
                    }) || ""), M(t = S(u.prefix + "!" + n, this.map.parentMap, !0), "defined", bind(this, function(e) {
                        this.map.normalizedMap = t, this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0,
                            ignore: !0
                        });
                    })), void ((i = getOwn(p, t.id)) && (this.depMaps.push(t), this.events.error && i.on("error", bind(this, function(e) {
                        this.emit("error", e);
                    })), i.enable()))) : r ? (this.map.url = l.nameToUrl(r), void this.load()) : ((o = bind(this, function(e) {
                        this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0
                        });
                    })).error = bind(this, function(e) {
                        this.inited = !0, (this.error = e).requireModules = [ c ], 
                        eachProp(p, function(e) {
                            0 === e.map.id.indexOf(c + "_unnormalized") && P(e.map.id);
                        }), O(e);
                    }), o.fromText = bind(this, function(e, t) {
                        var i = u.name, r = S(i), n = useInteractive;
                        t && (e = t), n && (useInteractive = !1), k(r), hasProp(g.config, c) && (g.config[i] = g.config[c]);
                        try {
                            req.exec(e);
                        } catch (e) {
                            return O(makeError("fromtexteval", "fromText eval for " + c + " failed: " + e, e, [ c ]));
                        }
                        n && (useInteractive = !0), this.depMaps.push(r), l.completeLoad(i), 
                        s([ i ], o);
                    }), void e.load(u.name, s, o, g));
                })), l.enable(e, this), this.pluginMaps[e.id] = e;
            },
            enable: function() {
                (f[this.map.id] = this).enabled = !0, this.enabling = !0, each(this.depMaps, bind(this, function(e, t) {
                    var i, r, n;
                    if ("string" == typeof e) {
                        if (e = S(e, this.map.isDefine ? this.map : this.map.parentMap, !1, !this.skipMap), 
                        this.depMaps[t] = e, n = getOwn(c, e.id)) return void (this.depExports[t] = n(this));
                        this.depCount += 1, M(e, "defined", bind(this, function(e) {
                            this.undefed || (this.defineDep(t, e), this.check());
                        })), this.errback ? M(e, "error", bind(this, this.errback)) : this.events.error && M(e, "error", bind(this, function(e) {
                            this.emit("error", e);
                        }));
                    }
                    i = e.id, r = p[i], hasProp(c, i) || !r || r.enabled || l.enable(e, this);
                })), eachProp(this.pluginMaps, bind(this, function(e) {
                    var t = getOwn(p, e.id);
                    t && !t.enabled && l.enable(e, this);
                })), this.enabling = !1, this.check();
            },
            on: function(e, t) {
                var i = this.events[e];
                i || (i = this.events[e] = []), i.push(t);
            },
            emit: function(e, t) {
                each(this.events[e], function(e) {
                    e(t);
                }), "error" === e && delete this.events[e];
            }
        }, (l = {
            config: g,
            contextName: u,
            registry: p,
            defined: m,
            urlFetched: n,
            defQueue: h,
            defQueueMap: {},
            Module: e,
            makeModuleMap: S,
            nextTick: req.nextTick,
            onError: O,
            configure: function(e) {
                if (e.baseUrl && "/" !== e.baseUrl.charAt(e.baseUrl.length - 1) && (e.baseUrl += "/"), 
                "string" == typeof e.urlArgs) {
                    var i = e.urlArgs;
                    e.urlArgs = function(e, t) {
                        return (-1 === t.indexOf("?") ? "?" : "&") + i;
                    };
                }
                var r = g.shim, n = {
                    paths: !0,
                    bundles: !0,
                    config: !0,
                    map: !0
                };
                eachProp(e, function(e, t) {
                    n[t] ? (g[t] || (g[t] = {}), mixin(g[t], e, !0, !0)) : g[t] = e;
                }), e.bundles && eachProp(e.bundles, function(e, t) {
                    each(e, function(e) {
                        e !== t && (v[e] = t);
                    });
                }), e.shim && (eachProp(e.shim, function(e, t) {
                    isArray(e) && (e = {
                        deps: e
                    }), !e.exports && !e.init || e.exportsFn || (e.exportsFn = l.makeShimExports(e)), 
                    r[t] = e;
                }), g.shim = r), e.packages && each(e.packages, function(e) {
                    var t;
                    t = (e = "string" == typeof e ? {
                        name: e
                    } : e).name, e.location && (g.paths[t] = e.location), g.pkgs[t] = e.name + "/" + (e.main || "main").replace(currDirRegExp, "").replace(jsSuffixRegExp, "");
                }), eachProp(p, function(e, t) {
                    e.inited || e.map.unnormalized || (e.map = S(t, null, !0));
                }), (e.deps || e.callback) && l.require(e.deps || [], e.callback);
            },
            makeShimExports: function(t) {
                return function() {
                    var e;
                    return t.init && (e = t.init.apply(global, arguments)), e || t.exports && getGlobal(t.exports);
                };
            },
            makeRequire: function(o, a) {
                function s(e, t, i) {
                    var r, n;
                    return a.enableBuildCallback && t && isFunction(t) && (t.__requireJsBuild = !0), 
                    "string" == typeof e ? isFunction(t) ? O(makeError("requireargs", "Invalid require call"), i) : o && hasProp(c, e) ? c[e](p[o.id]) : req.get ? req.get(l, e, o, s) : (r = S(e, o, !1, !0).id, 
                    hasProp(m, r) ? m[r] : O(makeError("notloaded", 'Module name "' + r + '" has not been loaded yet for context: ' + u + (o ? "" : ". Use require([])")))) : (T(), 
                    l.nextTick(function() {
                        T(), (n = k(S(null, o))).skipMap = a.skipMap, n.init(e, t, i, {
                            enabled: !0
                        }), R();
                    }), s);
                }
                return a = a || {}, mixin(s, {
                    isBrowser: isBrowser,
                    toUrl: function(e) {
                        var t, i = e.lastIndexOf("."), r = e.split("/")[0];
                        return -1 !== i && (!("." === r || ".." === r) || 1 < i) && (t = e.substring(i, e.length), 
                        e = e.substring(0, i)), l.nameToUrl(q(e, o && o.id, !0), t, !0);
                    },
                    defined: function(e) {
                        return hasProp(m, S(e, o, !1, !0).id);
                    },
                    specified: function(e) {
                        return e = S(e, o, !1, !0).id, hasProp(m, e) || hasProp(p, e);
                    }
                }), o || (s.undef = function(i) {
                    j();
                    var e = S(i, o, !0), t = getOwn(p, i);
                    t.undefed = !0, E(i), delete m[i], delete n[e.url], delete r[i], 
                    eachReverse(h, function(e, t) {
                        e[0] === i && h.splice(t, 1);
                    }), delete l.defQueueMap[i], t && (t.events.defined && (r[i] = t.events), 
                    P(i));
                }), s;
            },
            enable: function(e) {
                getOwn(p, e.id) && k(e).enable();
            },
            completeLoad: function(e) {
                var t, i, r, n = getOwn(g.shim, e) || {}, o = n.exports;
                for (j(); h.length; ) {
                    if (null === (i = h.shift())[0]) {
                        if (i[0] = e, t) break;
                        t = !0;
                    } else i[0] === e && (t = !0);
                    a(i);
                }
                if (l.defQueueMap = {}, r = getOwn(p, e), !t && !hasProp(m, e) && r && !r.inited) {
                    if (!(!g.enforceDefine || o && getGlobal(o))) return w(e) ? void 0 : O(makeError("nodefine", "No define call for " + e, null, [ e ]));
                    a([ e, n.deps || [], n.exportsFn ]);
                }
                R();
            },
            nameToUrl: function(e, t, i) {
                var r, n, o, a, s, u, c = getOwn(g.pkgs, e);
                if (c && (e = c), u = getOwn(v, e)) return l.nameToUrl(u, t, i);
                if (req.jsExtRegExp.test(e)) a = e + (t || ""); else {
                    for (r = g.paths, o = (n = e.split("/")).length; 0 < o; o -= 1) if (s = getOwn(r, n.slice(0, o).join("/"))) {
                        isArray(s) && (s = s[0]), n.splice(0, o, s);
                        break;
                    }
                    a = n.join("/"), a = ("/" === (a += t || (/^data\:|^blob\:|\?/.test(a) || i ? "" : ".js")).charAt(0) || a.match(/^[\w\+\.\-]+:/) ? "" : g.baseUrl) + a;
                }
                return g.urlArgs && !/^blob\:/.test(a) ? a + g.urlArgs(e, a) : a;
            },
            load: function(e, t) {
                req.load(l, e, t);
            },
            execCb: function(e, t, i, r) {
                return t.apply(r, i);
            },
            onScriptLoad: function(e) {
                if ("load" === e.type || readyRegExp.test((e.currentTarget || e.srcElement).readyState)) {
                    interactiveScript = null;
                    var t = s(e);
                    l.completeLoad(t.id);
                }
            },
            onScriptError: function(e) {
                var i = s(e);
                if (!w(i.id)) {
                    var r = [];
                    return eachProp(p, function(e, t) {
                        0 !== t.indexOf("_@r") && each(e.depMaps, function(e) {
                            if (e.id === i.id) return r.push(t), !0;
                        });
                    }), O(makeError("scripterror", 'Script error for "' + i.id + (r.length ? '", needed by: ' + r.join(", ") : '"'), e, [ i.id ]));
                }
            }
        }).require = l.makeRequire(), l;
    }
    function getInteractiveScript() {
        return interactiveScript && "interactive" === interactiveScript.readyState || eachReverse(scripts(), function(e) {
            if ("interactive" === e.readyState) return interactiveScript = e;
        }), interactiveScript;
    }
}(this, "undefined" == typeof setTimeout ? void 0 : setTimeout);

var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || {
            __proto__: []
        } instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, 
        new __());
    };
}();

var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var __generator = this && this.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        throw: verb(1),
        return: verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([ n, v ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 
            0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [ op[0] & 2, t.value ];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;

              case 4:
                _.label++;
                return {
                    value: op[1],
                    done: false
                };

              case 5:
                _.label++;
                y = op[1];
                op = [ 0 ];
                continue;

              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;

              default:
                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                }
                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                }
                if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                }
                if (t[2]) _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [ 6, e ];
            y = 0;
        } finally {
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

define("core/shopify-app/st-modules/_general-methods/dom-loaded", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDOMLoaded = void 0;
    var StDOMLoaded = function() {
        function StDOMLoaded() {
            var _this = this;
            this.className = "DOMLoaded";
            this.domLoaded = false;
            this.domLoadedCallbacks = [];
            this.readyStateChange = function() {
                if (document.readyState === "interactive") {
                    _this.domLoaded = true;
                    _this.fireDOMLoadedCallbacks();
                }
            };
            this.fireDOMLoadedCallbacks = function() {
                for (var i = 0; i < _this.domLoadedCallbacks.length; i++) {
                    _this.domLoadedCallbacks[i]();
                }
            };
            this.subscribeDOMLoaded = function(cb) {
                if (_this.domLoaded) {
                    cb();
                } else {
                    _this.domLoadedCallbacks.push(cb);
                }
            };
        }
        StDOMLoaded.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        StDOMLoaded.prototype.initDOMLoaded = function() {
            if (!StDOMLoaded.initStarted) {
                StDOMLoaded.initStarted = true;
                if (document.readyState === "interactive" || document.readyState === "complete") {
                    this.domLoaded = true;
                    this.fireDOMLoadedCallbacks();
                } else {
                    document.addEventListener("readystatechange", this.readyStateChange, false);
                }
            }
        };
        StDOMLoaded.initStarted = false;
        return StDOMLoaded;
    }();
    exports.StDOMLoaded = StDOMLoaded;
});

define("core/connector-app/_shared/routes.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.endpointData = void 0;
    exports.endpointData = {
        webalias: {
            repSite: "||-API-ROOT-||/webalias/sca/repSite",
            savePromoCode: "||-API-ROOT-||/webalias/sca/savePromoCode",
            getPromoCode: "||-API-ROOT-||/webalias/sca/getPromoCode",
            isPromoCodeEligible: "||-API-ROOT-||/webalias/sca/isPromoCodeEligible"
        },
        customer: {
            import: "||-API-ROOT-||/customer/gar/import",
            updatePersonalInfo: "||-API-ROOT-||/customer/sca/updatePersonalInfo",
            updateWebAlias: "||-API-ROOT-||/customer/sca/updateWebAlias",
            updateSponsor: "||-API-ROOT-||/customer/sca/updateSponsor"
        },
        auth: {
            sso: "||-API-ROOT-||/auth/sca/sso",
            "get-jwt": "||-API-ROOT-||/auth/sca/get-jwt",
            "refresh-jwt": "||-API-ROOT-||/auth/sca/refresh-jwt"
        },
        order: {},
        enrollment: {
            "validate-data": "||-API-ROOT-||/enrollment/sca/validate-data",
            submit: "||-API-ROOT-||/enrollment/sca/submit",
            newAccountCheckAndCreate: "||-API-ROOT-||/enrollment/sca/newAccountCheckAndCreate"
        },
        searchSponsor: {
            getSponsorInfo: "||-API-ROOT-||/searchSponsor/sca/getSponsorInfo",
            getSponsorByPersonalInfo: "||-API-ROOT-||/searchSponsor/sca/getSponsorByPersonalInfo"
        }
    };
});

define("core/shopify-app/st-modules/_static/static", [ "require", "exports", "core/connector-app/_shared/routes.config" ], function(require, exports, routes_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StStatic = void 0;
    var StStatic = function() {
        function StStatic() {
            var _this = this;
            this.className = "Static";
            this.shopConfig = window.stAppConfig;
            this.apiRoot = this.shopConfig.apiRoot;
            this.init = function() {};
            this.setup = function() {};
            this.obtainStaticEndpoints = function() {
                return _this.endpoint;
            };
            this.obtainMainScope = function() {
                return window.stApp;
            };
            this.obtainCart = function() {
                return window.shopifyCartData;
            };
            this.injectRootToEndpoints = function(endpoints) {
                for (var controllerKey in endpoints) {
                    for (var endpoint in endpoints[controllerKey]) {
                        endpoints[controllerKey][endpoint] = endpoints[controllerKey][endpoint].replace(/\|\|-API-ROOT-\|\|/g, _this.apiRoot);
                    }
                }
                return endpoints;
            };
            this.endpoint = this.injectRootToEndpoints(routes_config_1.endpointData);
        }
        StStatic.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        return StStatic;
    }();
    exports.StStatic = StStatic;
});

define("core/connector-app/_shared/models/auth/auth.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.ETokenType = void 0;
    var ETokenType;
    (function(ETokenType) {
        ETokenType["Access"] = "Access";
        ETokenType["Refresh"] = "Refresh";
    })(ETokenType = exports.ETokenType || (exports.ETokenType = {}));
});

define("core/shopify-app/st-modules/_general-methods/ajax", [ "require", "exports", "core/connector-app/_shared/models/auth/auth.request.model", "core/shopify-app/st-modules/_static/static" ], function(require, exports, auth_request_model_1, static_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAjax = void 0;
    var StAjax = function() {
        function StAjax() {
            this.refreshingToken = false;
        }
        StAjax.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        StAjax.prototype.setupFormatting = function(objectToQueryStringFn) {
            this.objectToQueryString = objectToQueryStringFn;
        };
        StAjax.prototype.determineContentType = function(contentType) {
            var output = {
                type: "application/x-www-form-urlencoded",
                prepFn: this.objectToQueryString
            };
            switch (contentType) {
              case "form":
                output.type = "application/x-www-form-urlencoded";
                output.prepFn = this.objectToQueryString;
                break;

              case "json":
                output.type = "application/json";
                output.prepFn = JSON.stringify;
                break;
            }
            return output;
        };
        StAjax.prototype.tokenExists = function() {
            return !!window.localStorage.getItem(auth_request_model_1.ETokenType.Refresh);
        };
        StAjax.prototype.removeTokensFromStorage = function() {
            var token = window.localStorage.getItem(auth_request_model_1.ETokenType.Access);
            if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_1.ETokenType.Access);
            token = window.localStorage.getItem(auth_request_model_1.ETokenType.Refresh);
            if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_1.ETokenType.Refresh);
        };
        StAjax.prototype.attachTokenToHeader = function(request, tokenType) {
            var token = window.localStorage.getItem(tokenType);
            if (!!token && token.length > 0) request.setRequestHeader("Authorization", token);
        };
        StAjax.prototype.send = function(options, refresh) {
            var _a;
            var fnReference = this;
            if (typeof options == "object") {
                var defaultOptions = {
                    endpoint: "",
                    method: "POST",
                    contentType: "json",
                    data: {},
                    callback: function() {},
                    callbackParams: [],
                    retried: (_a = options.retried) !== null && _a !== void 0 ? _a : false
                };
                var completeOptions_1 = __assign(__assign({}, defaultOptions), options);
                var contentTypeData = this.determineContentType(completeOptions_1.contentType);
                var requestMethod = completeOptions_1.method.toUpperCase();
                var allowedMethods = [ "POST", "GET", "PUT", "DELETE" ];
                completeOptions_1.method = allowedMethods.indexOf(requestMethod) >= 0 ? requestMethod : "POST";
                var request_1 = new XMLHttpRequest();
                request_1.open(completeOptions_1.method, completeOptions_1.endpoint, true);
                request_1.withCredentials = true;
                request_1.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                request_1.setRequestHeader("Content-Type", contentTypeData.type);
                request_1.setRequestHeader("credentials", "include");
                var tokenType = !!refresh ? auth_request_model_1.ETokenType.Refresh : auth_request_model_1.ETokenType.Access;
                this.attachTokenToHeader(request_1, tokenType);
                var _this_1 = this;
                request_1.onreadystatechange = function() {
                    if (request_1.readyState === 4) {
                        if (request_1.status === 401 && !completeOptions_1.retried) {
                            options.retried = true;
                            if (_this_1.refreshingToken) {
                                setTimeout(function() {
                                    if (_this_1.tokenExists()) {
                                        _this_1.send(options);
                                    } else {}
                                }, 3e3);
                            } else {
                                _this_1.refreshTokenAndRetry(options);
                            }
                        } else {
                            completeOptions_1.callbackParams.unshift(request_1);
                            completeOptions_1.callback.apply(fnReference, completeOptions_1.callbackParams);
                        }
                    }
                };
                request_1.send(contentTypeData.prepFn(completeOptions_1.data));
                return request_1;
            }
        };
        StAjax.prototype.refreshTokenAndRetry = function(options) {
            this.refreshingToken = true;
            var refreshToken = window.localStorage.getItem(auth_request_model_1.ETokenType.Refresh);
            if (refreshToken == undefined || refreshToken.length === 0) {
                console.error("Authentication required.");
                return;
            }
            var _this = this;
            this.send({
                endpoint: static_1.StStatic.Instance().obtainStaticEndpoints()["auth"]["refresh-jwt"],
                method: "POST",
                contentType: "json",
                data: {},
                callback: function(response) {
                    try {
                        if (response.status == 200) {
                            var accessToken = JSON.parse(response.response).data.accessToken;
                            window.localStorage.setItem(auth_request_model_1.ETokenType.Access, accessToken);
                            _this.refreshingToken = false;
                            _this.send(options);
                        } else if (response.status == 401) {
                            _this.removeTokensFromStorage();
                            _this.tryGetTokens(options);
                            throw new Error("Authentication required.");
                        }
                    } catch (error) {
                        console.error(error);
                        _this.refreshingToken = false;
                    }
                }
            }, true);
        };
        StAjax.prototype.tryGetTokens = function(options) {
            if (this.shouldRequestToken()) {
                this.getTokens({
                    id: "".concat(window.customerShopifyId),
                    email: window.customerShopifyEmail
                }, options);
            }
        };
        StAjax.prototype.shouldRequestToken = function() {
            return window.localStorage.getItem(auth_request_model_1.ETokenType.Refresh) === null && !!window.customerShopifyId && !!window.customerShopifyEmail;
        };
        StAjax.prototype.getTokens = function(userInfo, options) {
            var _this = this;
            this.send({
                endpoint: window.stAppConfig.apiRoot + "/auth/sca/get-jwt",
                method: "POST",
                contentType: "json",
                data: userInfo,
                callback: function(response) {
                    try {
                        if (response.status == 200) {
                            var res = JSON.parse(response.response);
                            window.localStorage.setItem(auth_request_model_1.ETokenType.Refresh.toString(), res.data.refreshToken);
                            window.localStorage.setItem(auth_request_model_1.ETokenType.Access, res.data.accessToken);
                            if (options !== undefined) {
                                _this.send(options);
                            }
                        }
                    } catch (error) {
                        console.error(error);
                    }
                }
            });
        };
        StAjax.prototype.getWebAlias = function() {
            var params = new URLSearchParams(window.location.search);
            return params.get("als") || params.get("ref") || localStorage.getItem("repId") || localStorage.getItem("webAlias") || "";
        };
        return StAjax;
    }();
    exports.StAjax = StAjax;
});

define("core/shopify-app/st-modules/_di-container/st.module.interface", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/_di-container/di.container.public", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, dom_loaded_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.DiContainerPublic = void 0;
    var DiContainerPublic = function() {
        function DiContainerPublic() {
            this.className = "DI";
            this.subscribeDOMLoaded = function(cb) {
                dom_loaded_1.StDOMLoaded.Instance().subscribeDOMLoaded(cb);
            };
            this.init = function() {};
            this.setup = function() {};
        }
        return DiContainerPublic;
    }();
    exports.DiContainerPublic = DiContainerPublic;
});

define("core/shopify-app/st-modules/_di-container/st.module", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/ajax", "core/shopify-app/st-modules/_static/static", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, ajax_1, static_2, dom_loaded_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StModule = void 0;
    var StModule = function() {
        function StModule(args) {
            var _this = this;
            this.dependency = [];
            this.init = function() {};
            this.setup = function() {
                if (!_this.setupFlag) {
                    if (_this.hasOwnProperty("init")) {
                        console.log("Init : ", _this.className);
                        _this.setupFlag = true;
                        _this.init();
                        _this.dependency.forEach(function(dependency) {
                            dependency.setup();
                        });
                    }
                }
            };
            this.dependency = args && args.length > 0 ? __spreadArray([], args, true) : [];
            this.Static = static_2.StStatic.Instance();
            this.endpoint = this.Static.obtainStaticEndpoints();
            this.cart = this.Static.obtainCart();
            this.ajax = ajax_1.StAjax.Instance();
            this.subscribeDOMLoaded = dom_loaded_2.StDOMLoaded.Instance().subscribeDOMLoaded;
            this.setupFlag = false;
        }
        return StModule;
    }();
    exports.StModule = StModule;
});

define("core/shopify-app/st-modules/_di-container/di.container.setup", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, dom_loaded_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDIContainerSetup = void 0;
    var StDIContainerSetup = function() {
        function StDIContainerSetup(appName, StAppDIConfig) {
            var _this = this;
            this.className = "DI";
            this.getModules = function(appName) {
                return _this.StAppDIConfig.Instance.hierarchy(appName);
            };
            if (!window.stApp) window.stApp = {};
            this.StAppDIConfig = StAppDIConfig;
            this.init(appName);
        }
        StDIContainerSetup.prototype.init = function(appName) {
            document.querySelector("body").classList.add("st_app-".concat(appName));
            this.mainServices = this.getModules(appName);
            this.mainServices.forEach(function(service) {
                if (service.className) {
                    window.stApp[service.className] = service;
                    service.setup();
                } else {
                    console.error("Instance has no className: ", service);
                }
            });
            dom_loaded_3.StDOMLoaded.Instance().initDOMLoaded();
        };
        return StDIContainerSetup;
    }();
    exports.StDIContainerSetup = StDIContainerSetup;
});

define("_features.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.promoAppliedTag = exports.appliedPromoCodeMetafieldKey = exports.promoCodeMinLength = exports.corpRepDID = exports.enrollmentItemSku = exports.useCommissionEngineIdInRewardCode = exports.rewardItemCollectionId = exports.rewardDiscountMinimum = exports.rewardCodePrefix = exports.rewardAmount = exports.rewardType = exports.shareRefCodeFunctionality = exports.discountUsageLimit = exports.discountCollectionSpend = exports.discountMinimumRequirement = exports.discountSegmentConditionTag = exports.discountNamePrefix = exports.discountAmount = exports.discountType = exports.enrollmentParams = exports.reasonForRefundWhenReturnMoney = exports.availableRechargeUsage = exports.sponsorGenealogyTimeout = exports.downgradeRepresentativeByDesignWebhook = exports.cronJobReSyncOrders = exports.repDiscountWithPromoCode = exports.searchSponsorsMinNumOfResult = exports.searchSponsorsFetchAttemptsLimit = exports.members = exports.representative = exports.commissionEngine = exports.autoshipItems = exports.productVolumesConfig = exports.EProductPriceType = exports.ECustomerType = exports.defaultCorporationImage = exports.additionalRepInfo = exports.confirmSponsorPage = exports.activeLastSponsorFeature = exports.canGoUnderCorporateSite = exports.lockedRepresentativeSite = exports.repIdParam = exports.webAliasParam = exports.aliasQueryParam = exports.corporationName = exports.defaultWebAlias = void 0;
    exports.defaultWebAlias = "11628";
    exports.corporationName = "BodyWise";
    exports.aliasQueryParam = "als";
    exports.webAliasParam = "ref";
    exports.repIdParam = "repId";
    exports.lockedRepresentativeSite = false;
    exports.canGoUnderCorporateSite = true;
    exports.activeLastSponsorFeature = true;
    exports.confirmSponsorPage = false;
    exports.additionalRepInfo = false;
    exports.defaultCorporationImage = "https://codemancystudio.com/cdm_template/wp-content/uploads/2018/03/cdm-logo-blacksmall.png";
    var ECustomerType;
    (function(ECustomerType) {
        ECustomerType["retail"] = "customer";
        ECustomerType["representative"] = "representative";
        ECustomerType["consultant"] = "consultant";
        ECustomerType["members"] = "members";
        ECustomerType["guest"] = "guest";
        ECustomerType["noType"] = "";
    })(ECustomerType = exports.ECustomerType || (exports.ECustomerType = {}));
    var EProductPriceType;
    (function(EProductPriceType) {
        EProductPriceType["retail"] = "retail";
        EProductPriceType["representative"] = "representative";
        EProductPriceType["noSpecificType"] = "";
    })(EProductPriceType = exports.EProductPriceType || (exports.EProductPriceType = {}));
    exports.productVolumesConfig = {
        cv: true,
        qv: true,
        bv: false,
        cvMetafieldKey: "cvolume",
        qvMetafieldKey: "qvolume",
        bvMetafieldKey: "bvolume",
        Volume: "cv",
        Volume2: "qv",
        Volume3: "bv",
        calculatePriceAsVolume: false,
        generalPriceVolumePercentage: 1,
        retailVolumeAndPricePercentage: 1,
        representativeVolumeAndPricePercentage: 1
    };
    exports.autoshipItems = [ "AUTOSHIP-1", "AUTOSHIP-2", "consultant-kit", "enrollment-bundle" ];
    exports.commissionEngine = "ByDesign";
    exports.representative = "representative";
    exports.members = "members";
    exports.searchSponsorsFetchAttemptsLimit = 3;
    exports.searchSponsorsMinNumOfResult = 3;
    exports.repDiscountWithPromoCode = true;
    exports.cronJobReSyncOrders = false;
    exports.downgradeRepresentativeByDesignWebhook = true;
    exports.sponsorGenealogyTimeout = 6e5;
    exports.availableRechargeUsage = false;
    exports.reasonForRefundWhenReturnMoney = "refundmoney";
    exports.enrollmentParams = [ "SSN", "dateOfBirth", "day", "email", "firstName", "lastName", "month", "optionalKitRecurring", "optionalKits", "phoneNumber", "requiredKitRecurring", "requiredKits", "shopifyId", "sponsorWebAlias", "sponsorsWebAlias", "ref", "year" ];
    exports.discountType = "fixed_amount";
    exports.discountAmount = 10;
    exports.discountNamePrefix = "Core_";
    exports.discountSegmentConditionTag = "no_order";
    exports.discountMinimumRequirement = "1.00";
    exports.discountCollectionSpend = 405622423800;
    exports.discountUsageLimit = 10;
    exports.shareRefCodeFunctionality = false;
    exports.rewardType = "fixed_amount";
    exports.rewardAmount = 20;
    exports.rewardCodePrefix = "RewardedFrom-";
    exports.rewardDiscountMinimum = 1;
    exports.rewardItemCollectionId = 405622423800;
    exports.useCommissionEngineIdInRewardCode = true;
    exports.enrollmentItemSku = "200";
    exports.corpRepDID = "11628";
    exports.promoCodeMinLength = 5;
    exports.appliedPromoCodeMetafieldKey = "appliedPromoCode";
    exports.promoAppliedTag = "promo-applied";
});

define("core/shopify-app/st-modules/_guards/guards", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, _features_config_1, st_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGuards = void 0;
    var StGuards = function(_super) {
        __extends(StGuards, _super);
        function StGuards() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Guards";
            _this.redirectUrl = "/";
            _this.dashboardPath = "/pages/account";
            _this.enrollmentPath = "/pages/enrollment";
            _this.confirmSponsorPath = "/pages/confirm-sponsor";
            _this.landingAfterSsoPath = "/pages/landing-after-sso";
            _this.shopifyAuthPath = "/customer_authentication";
            _this.accountSelector = ".st_account-login-link_JS";
            _this.enrollmentSelector = ".st_enrollment-login-link_JS";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    console.log("[StGuards] DOM Loaded. Beginning guards execution...");
                    console.log('[StGuards] State Check - Pathname: "'.concat(window.location.pathname, '", IsLoggedIn: ').concat(_this.isLoggedIn(), ", IsSynced: ").concat(_this.isCustomerAlreadySynced()));
                    _this.preventShopifyNativeAccountDashboardNavigation();
                    _this.setLinks(_this.accountSelector, _this.dashboardPath);
                    _this.setLinks(_this.enrollmentSelector, _this.enrollmentPath);
                    if (_this.isAuthFlowPage()) {
                        console.log("[StGuards] Current page is an auth flow page. Skipping further guard evaluations.");
                        return;
                    }
                    _this.preventDashboardAccessForGuests();
                    _this.preventEnrollmentAccessForGuests();
                    _this.redirectLoggedInUnsyncedCustomer();
                    _this.preventEnrollmentAccessForNonRetail();
                });
            };
            _this.preventDashboardAccessForGuests = function() {
                if (window.location.pathname !== _this.dashboardPath) return;
                console.log("[StGuards] Evaluating: preventDashboardAccessForGuests");
                if (_this.isLoggedIn()) {
                    console.log("[StGuards] Access Granted: User is logged in.");
                    return;
                }
                var url = _this.getSsoFlowUrl(_this.dashboardPath);
                if (_this.isCurrentUrl(url)) {
                    console.log("[StGuards] Already on target SSO URL, preventing infinite loop.");
                    return;
                }
                console.warn("[StGuards] Access Denied: Guest accessing dashboard. Redirecting to: ".concat(url));
                window.location.href = url;
            };
            _this.preventEnrollmentAccessForGuests = function() {
                if (window.location.pathname !== _this.enrollmentPath) return;
                console.log("[StGuards] Evaluating: preventEnrollmentAccessForGuests");
                if (_this.isLoggedIn()) {
                    console.log("[StGuards] Access Granted: User is logged in.");
                    return;
                }
                var url = _this.getSsoFlowUrl(_this.enrollmentPath);
                if (_this.isCurrentUrl(url)) {
                    console.log("[StGuards] Already on target SSO URL, preventing infinite loop.");
                    return;
                }
                console.warn("[StGuards] Access Denied: Guest accessing enrollment. Redirecting to: ".concat(url));
                window.location.href = url;
            };
            _this.preventEnrollmentAccessForNonRetail = function() {
                if (window.location.pathname !== _this.enrollmentPath) return;
                if (!_this.isLoggedIn()) return;
                if (!_this.isCustomerAlreadySynced()) return;
                console.log("[StGuards] Evaluating: preventEnrollmentAccessForNonRetail");
                var isRetailCustomer = window.isRetailCustomer === "true";
                console.log("[StGuards] isRetailCustomer flag value: ".concat(isRetailCustomer));
                if (isRetailCustomer) {
                    console.log("[StGuards] Access Granted: User is a retail customer.");
                    return;
                }
                console.warn("[StGuards] Access Denied: Non-retail customer attempting enrollment. Redirecting to Dashboard: ".concat(_this.dashboardPath));
                window.location.href = _this.dashboardPath;
            };
            _this.redirectLoggedInUnsyncedCustomer = function() {
                if (!_this.isLoggedIn()) return;
                if (_this.isCustomerAlreadySynced()) return;
                if (_this.isAuthFlowPage()) return;
                console.log("[StGuards] Evaluating: redirectLoggedInUnsyncedCustomer");
                var finalRedirectUrl = window.location.pathname === _this.enrollmentPath ? _this.enrollmentPath : _this.dashboardPath;
                var url = _this.getSyncFlowUrl(finalRedirectUrl);
                if (_this.isCurrentUrl(url)) {
                    console.log("[StGuards] Already on sync flow URL, preventing infinite loop.");
                    return;
                }
                console.warn("[StGuards] Redirecting logged-in, unsynced customer to sync flow URL: ".concat(url));
                window.location.href = url;
            };
            _this.setLinks = function(selector, finalRedirectUrl) {
                var links = document.querySelectorAll(selector);
                console.log('[StGuards] setLinks called for selector: "'.concat(selector, '". Found ').concat(links.length, " element(s)."));
                links.forEach(function(link, index) {
                    var targetUrl = "";
                    if (_this.isLoggedIn() && _this.isCustomerAlreadySynced()) {
                        targetUrl = finalRedirectUrl;
                    } else if (_this.isLoggedIn() && !_this.isCustomerAlreadySynced()) {
                        targetUrl = _this.getSyncFlowUrl(finalRedirectUrl);
                    } else {
                        targetUrl = _this.getSsoFlowUrl(finalRedirectUrl);
                    }
                    console.log("[StGuards] link[".concat(index, '] href updated from "').concat(link.href, '" to "').concat(targetUrl, '"'));
                    link.href = targetUrl;
                });
            };
            _this.preventShopifyNativeAccountDashboardNavigation = function() {
                console.log("[StGuards] Registering click interceptor for native Shopify account links.");
                document.addEventListener("click", _this.handleAccountDashboardClick, true);
            };
            _this.handleAccountDashboardClick = function(event) {
                var target = event.target;
                var link = target.closest("a[href]");
                if (!link) return;
                var url = new URL(link.href, window.location.origin);
                if (!_this.isShopifyAccountDashboardUrl(url)) return;
                console.warn("[StGuards] Intercepted click to native Shopify account URL: ".concat(link.href, ". Redirecting to: ").concat(_this.redirectUrl));
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                window.location.assign(_this.redirectUrl);
            };
            _this.isShopifyAccountDashboardUrl = function(url) {
                var pathname = url.pathname;
                if (pathname.startsWith(_this.shopifyAuthPath)) return false;
                var isNativeAccountUrl = pathname === "/account" || pathname.startsWith("/account/");
                if (isNativeAccountUrl) {
                    console.log('[StGuards] Match found: "'.concat(pathname, '" is a Shopify native account URL.'));
                }
                return isNativeAccountUrl;
            };
            _this.isAuthFlowPage = function() {
                var path = window.location.pathname;
                var result = path.startsWith(_this.shopifyAuthPath) || path.includes(_this.confirmSponsorPath) || path.includes(_this.landingAfterSsoPath);
                return result;
            };
            _this.getSsoFlowUrl = function(finalRedirectUrl) {
                var ssoUrl = _this.buildSsoUrl(_this.getSyncFlowUrl(finalRedirectUrl));
                console.log('[StGuards] Generated SSO Flow URL for "'.concat(finalRedirectUrl, '": ').concat(ssoUrl));
                return ssoUrl;
            };
            _this.buildSsoUrl = function(returnTo) {
                return "https://".concat(window.location.hostname, "/customer_authentication/login?return_to=").concat(encodeURIComponent(returnTo));
            };
            _this.getSyncFlowUrl = function(finalRedirectUrl) {
                var page = _features_config_1.confirmSponsorPage ? _this.confirmSponsorPath : _this.landingAfterSsoPath;
                var syncUrl = "".concat(page, "?r=").concat(encodeURIComponent(finalRedirectUrl));
                console.log("[StGuards] Generated Sync Flow URL (confirmSponsorPage config state is ".concat(_features_config_1.confirmSponsorPage, "): ").concat(syncUrl));
                return syncUrl;
            };
            _this.isCurrentUrl = function(url) {
                var nextUrl = new URL(url, window.location.origin);
                var match = window.location.pathname === nextUrl.pathname && window.location.search === nextUrl.search;
                return match;
            };
            _this.isLoggedIn = function() {
                var customerId = window.customerShopifyId;
                return !!customerId;
            };
            _this.isCustomerAlreadySynced = function() {
                var customer = window.commissionEngineCustomer;
                if (!customer) {
                    return false;
                }
                if (typeof customer === "string") {
                    try {
                        var parsed = JSON.parse(customer);
                        return !!(parsed === null || parsed === void 0 ? void 0 : parsed.personalId);
                    } catch (e) {
                        console.error("[StGuards] Failed to parse commissionEngineCustomer JSON string. Error:", e);
                        return false;
                    }
                }
                return !!(customer === null || customer === void 0 ? void 0 : customer.personalId);
            };
            console.log("[StGuards] Initialized class instance.");
            return _this;
        }
        return StGuards;
    }(st_module_1.StModule);
    exports.StGuards = StGuards;
});

define("core/shopify-app/st-modules/_general-methods/cookies/cookies", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCookies = void 0;
    var StCookies = function(_super) {
        __extends(StCookies, _super);
        function StCookies() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Cookies";
            _this_1.ONE_DAY_MS = 24 * 60 * 60 * 1e3;
            _this_1.repExpirationKey = "rep_expiresAt";
            _this_1.repKeys = [ "ref", "repId", "firstName", "lastName", "imageUrl" ];
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this.initCookieApi();
                    _this.onPrivacyBannerAction();
                });
            };
            _this_1.initCookieApi = function() {
                var wShopify = window.Shopify;
                if (!(wShopify === null || wShopify === void 0 ? void 0 : wShopify.loadFeatures)) {
                    console.warn("[Cookies] Shopify.loadFeatures is not available");
                    return;
                }
                try {
                    wShopify.loadFeatures([ {
                        name: "consent-tracking-api",
                        version: "0.1"
                    } ], function(error) {
                        if (error) {
                            console.warn("[Cookies] consent-tracking-api failed to load", error);
                            return;
                        }
                        _this_1.showPrivacyBanner();
                    });
                } catch (error) {
                    console.warn("[Cookies] initCookieApi failed", error);
                }
            };
            _this_1.showPrivacyBanner = function() {
                var _a;
                var wShopify = window.Shopify;
                if (!((_a = wShopify === null || wShopify === void 0 ? void 0 : wShopify.customerPrivacy) === null || _a === void 0 ? void 0 : _a.shouldShowGDPRBanner)) {
                    console.warn("[Cookies] Shopify.customerPrivacy is not available");
                    return;
                }
                var shouldShowBanner = wShopify.customerPrivacy.shouldShowGDPRBanner();
                var banner = document.querySelector(".st_privacy-bar_JS");
                if (!!banner && shouldShowBanner) {
                    banner.removeAttribute("hidden");
                }
            };
            _this_1.hidePrivacyBanner = function() {
                var banner = document.querySelector(".st_privacy-bar_JS");
                if (!!banner) {
                    banner.setAttribute("hidden", "");
                }
            };
            _this_1.onPrivacyBannerAction = function() {
                var _this = _this_1;
                var btns = document.querySelectorAll(".st_privacy-banner-btn_JS");
                btns.forEach(function(btn) {
                    btn.addEventListener("click", function() {
                        var action = btn.getAttribute("data-action");
                        var wShopify = window === null || window === void 0 ? void 0 : window.Shopify;
                        wShopify.customerPrivacy.setTrackingConsent(action === "accept", _this.hidePrivacyBanner);
                    });
                });
            };
            _this_1.getCookie = function(cookieKey) {
                var value = window.localStorage.getItem(cookieKey);
                if (!value) return "";
                if (_this_1.isRepKey(cookieKey) && _this_1.isRepExpired()) {
                    _this_1.clearRepData();
                    return "";
                }
                return value;
            };
            _this_1.setCookies = function(cookieKey, cookieValue, expireDays) {
                window.localStorage.setItem(cookieKey, cookieValue);
                if (expireDays && _this_1.isRepKey(cookieKey)) {
                    var expiresAt = Date.now() + expireDays * _this_1.ONE_DAY_MS;
                    window.localStorage.setItem(_this_1.repExpirationKey, expiresAt.toString());
                }
            };
            _this_1.clearCookie = function(cookieKey) {
                window.localStorage.removeItem(cookieKey);
                if (_this_1.isRepKey(cookieKey)) {
                    _this_1.clearRepData();
                }
            };
            _this_1.clearAllCookie = function() {
                window.localStorage.clear();
            };
            _this_1.isRepKey = function(key) {
                return _this_1.repKeys.includes(key);
            };
            _this_1.isRepExpired = function() {
                var expiresAt = window.localStorage.getItem(_this_1.repExpirationKey);
                return !!expiresAt && Date.now() > Number(expiresAt);
            };
            _this_1.clearRepData = function() {
                _this_1.repKeys.forEach(function(key) {
                    return window.localStorage.removeItem(key);
                });
                window.localStorage.removeItem(_this_1.repExpirationKey);
            };
            return _this_1;
        }
        return StCookies;
    }(st_module_2.StModule);
    exports.StCookies = StCookies;
});

define("core/shopify-app/st-modules/_general-methods/form/customer-type", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_3, _features_config_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCustomerType = void 0;
    var StCustomerType = function(_super) {
        __extends(StCustomerType, _super);
        function StCustomerType() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CustomerType";
            _this.init = function() {};
            _this.get = function() {
                var customerType;
                if (!!window.customerInfoMetafields.customerType) {
                    customerType = window.customerInfoMetafields.customerType;
                } else {
                    customerType = _features_config_2.ECustomerType.guest;
                }
                return customerType;
            };
            return _this;
        }
        return StCustomerType;
    }(st_module_3.StModule);
    exports.StCustomerType = StCustomerType;
});

define("core/shopify-app/st-modules/_general-methods/object-formatting", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StObjectFormatting = void 0;
    var StObjectFormatting = function(_super) {
        __extends(StObjectFormatting, _super);
        function StObjectFormatting() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ObjectFormatting";
            _this.convertObjectToQueryString = function(object) {
                var string = "", i = 0;
                for (var j in object) {
                    var s = encodeURIComponent(j) + "=" + encodeURIComponent(object[j]);
                    string += i > 0 ? "&" + s : s;
                    i++;
                }
                return "?" + string;
            };
            _this.convertQueryStringToObject = function(query) {
                query = typeof query != "string" ? "" : query.substr(query.indexOf("?") + 1);
                var query_string = {};
                if (query !== "") {
                    var vars = query.split("&");
                    for (var i = 0; i < vars.length; i++) {
                        var pair = vars[i].split("=");
                        var key = decodeURIComponent(pair[0]);
                        var value = decodeURIComponent(pair[1]);
                        if (typeof query_string[key] === "undefined") {
                            query_string[key] = decodeURIComponent(value);
                        } else if (typeof query_string[key] === "string") {
                            query_string[key] = [ query_string[key], decodeURIComponent(value) ];
                        } else {
                            query_string[key].push(decodeURIComponent(value));
                        }
                    }
                } else {
                    console.warn("Invalid query string supplied to convertQueryStringToObject.");
                }
                return query_string;
            };
            _this.ajax.setupFormatting(_this.convertObjectToQueryString);
            return _this;
        }
        return StObjectFormatting;
    }(st_module_4.StModule);
    exports.StObjectFormatting = StObjectFormatting;
});

define("core/shopify-app/st-modules/_general-methods/browser-history", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StBrowserHistory = void 0;
    var StBrowserHistory = function(_super) {
        __extends(StBrowserHistory, _super);
        function StBrowserHistory(objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "BrowserHistory";
            _this.pushHistory = function(rootURL, urlParams) {
                var serializedUrlParams = _this.objectFormatting.convertObjectToQueryString(urlParams);
                window.history.replaceState(urlParams, "", rootURL + serializedUrlParams);
            };
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StBrowserHistory;
    }(st_module_5.StModule);
    exports.StBrowserHistory = StBrowserHistory;
});

define("core/connector-app/_shared/models/webalias/webalias.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/_general-methods/general-methods", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGeneralMethods = void 0;
    var StGeneralMethods = function(_super) {
        __extends(StGeneralMethods, _super);
        function StGeneralMethods() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "GeneralMethods";
            _this.scrollTo = function(element, duration, offset) {
                if (offset === void 0) {
                    offset = 150;
                }
                var startingY = window.scrollY;
                var elementY = window.scrollY + element.getBoundingClientRect().top - offset;
                var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
                var diff = targetY - startingY;
                var easing = function(t) {
                    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
                };
                var start;
                if (!diff) return;
                window.requestAnimationFrame(function step(timestamp) {
                    if (!start) start = timestamp;
                    var time = timestamp - start;
                    var percent = Math.min(time / duration, 1);
                    percent = easing(percent);
                    window.scrollTo(0, startingY + diff * percent);
                    if (time < duration) {
                        window.requestAnimationFrame(step);
                    }
                });
            };
            return _this;
        }
        StGeneralMethods.prototype.getClosestByClass = function(el, cls) {
            var res = el;
            while ((res = res.parentElement) && !res.classList.contains(cls));
            return res;
        };
        StGeneralMethods.prototype.getClosestByTag = function(el, tagName) {
            var res = el;
            while ((res = res.parentElement) && !res.tagName === tagName);
            return res;
        };
        return StGeneralMethods;
    }(st_module_6.StModule);
    exports.StGeneralMethods = StGeneralMethods;
});

define("core/shopify-app/st-modules/webalias/webalias-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAliasClassConfig = void 0;
    var StWebAliasClassConfig = function(_super) {
        __extends(StWebAliasClassConfig, _super);
        function StWebAliasClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StWebAliasClassConfig";
            _this.classNameRepId = "st_representative-id_JS";
            _this.selectorRepId = "." + _this.classNameRepId;
            _this.classNameRepAlias = "st_representative-alias_JS";
            _this.selectorRepAlias = "." + _this.classNameRepAlias;
            _this.classNameRepFullName = "st_representative-fullname_JS";
            _this.selectorRepFullName = "." + _this.classNameRepFullName;
            _this.classNameRepInitials = "st_representative-initials_JS";
            _this.selectorRepInitials = "." + _this.classNameRepInitials;
            _this.classNameRepSite = "st_representative-site_JS";
            _this.selectorRepSite = "." + _this.classNameRepSite;
            _this.classNameRepBio = "st_representative-site-bio_JS";
            _this.selectorRepBio = "." + _this.classNameRepBio;
            _this.classNameRepAddress = "st_representative-address_JS";
            _this.selectorRepAddress = "." + _this.classNameRepAddress;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNamePersonalInfoRepFullName = "st_representative-info-fullname_JS";
            _this.selectorPersonalInfoRepFullName = "." + _this.classNamePersonalInfoRepFullName;
            return _this;
        }
        return StWebAliasClassConfig;
    }(st_module_7.StModule);
    exports.StWebAliasClassConfig = StWebAliasClassConfig;
});

define("core/shopify-app/st-modules/webalias/inject-representative-info", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, _features_config_3, st_module_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInjectRepresentativeInfo = void 0;
    var StInjectRepresentativeInfo = function(_super) {
        __extends(StInjectRepresentativeInfo, _super);
        function StInjectRepresentativeInfo(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "InjectRepresentativeInfo";
            _this.injectToFields = function(repInfo) {
                var repId = repInfo.repId, ref = repInfo.ref, firstName = repInfo.firstName, lastName = repInfo.lastName, imageUrl = repInfo.imageUrl;
                if (!!repId) {
                    _this.appendIdToField(repInfo.repId);
                }
                if (!!ref) {
                    _this.appendAlsToField(ref);
                    _this.appendRepSiteUrlToField(ref);
                }
                if (!!firstName || !!lastName) {
                    _this.appendRepFullNameToField(firstName, lastName, ref);
                }
                if (!!imageUrl && _features_config_3.additionalRepInfo) {
                    _this.appendRepBioToField(imageUrl);
                }
            };
            _this.injectSponsorInfoToField = function(firstName, lastName) {
                var repNameSelector = document.querySelector(_this.classConfig.selectorBusinessContentRepName);
                if (!!repNameSelector) {
                    repNameSelector.innerHTML = firstName + " " + lastName;
                }
                var personalInformationRep = document.querySelector(_this.classConfig.selectorPersonalInfoRepFullName);
                if (!!personalInformationRep) {
                    personalInformationRep.value = firstName + " " + lastName;
                }
            };
            _this.appendIdToField = function(id) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepId);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, id);
                }
            };
            _this.appendAlsToField = function(alias) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepAlias);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, alias);
                }
            };
            _this.appendRepSiteUrlToField = function(alias) {
                var repSiteFields = document.querySelectorAll(_this.classConfig.selectorRepSite);
                var repSite = window.location.origin + "/?ref=" + alias;
                if (repSiteFields.length > 0) {
                    _this.appendValueToFields(repSiteFields, repSite);
                }
            };
            _this.appendRepFullNameToField = function(repFirstName, repLastName, ref) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepFullName);
                var bannerWrapper = document.querySelector(".st_representative-banner--wrapper_JS");
                var isRepresentativeBanner = !!bannerWrapper && bannerWrapper.dataset.isRepresentative === "true";
                var fullName = _this.getReplicatedSiteDisplayName(repFirstName, ref);
                if (isRepresentativeBanner) {
                    fullName = repFirstName || _this.getCurrentRepresentativeBannerName(repFullNameFields);
                }
                if (repFullNameFields.length > 0) {
                    _this.appendValueToFields(repFullNameFields, fullName);
                }
            };
            _this.getCurrentRepresentativeBannerName = function(repFullNameFields) {
                if (repFullNameFields.length === 0) {
                    return "";
                }
                return repFullNameFields[0].innerText || "";
            };
            _this.appendRepBioToField = function(imageUrl) {
                var repImages = document.querySelectorAll(_this.classConfig.selectorRepBio);
                var imageString = 'BIO: <img class="" style="width: 50px; height: auto;" alt="representatve image" src="' + imageUrl + '">';
                if (repImages.length > 0) {
                    repImages.forEach(function(field) {
                        return field.innerHTML = imageString;
                    });
                }
            };
            _this.getFullName = function(repFirstName, repLastName, ref) {
                var fullName = "";
                if (!!repFirstName) {
                    fullName = repFirstName;
                    if (!!repLastName) {
                        fullName += " " + repLastName;
                    }
                }
                if (ref === _features_config_3.defaultWebAlias) {
                    fullName = _features_config_3.corporationName;
                }
                return fullName;
            };
            _this.getReplicatedSiteDisplayName = function(repFirstName, ref) {
                if (ref === _features_config_3.defaultWebAlias) {
                    return _features_config_3.corporationName;
                }
                return repFirstName || "";
            };
            _this.appendValueToFields = function(fields, value) {
                fields.forEach(function(field) {
                    if (field.tagName.toLowerCase() === "input") {
                        field.value = value;
                    } else if (field.tagName.toLowerCase() === "a") {
                        field.setAttribute("href", value);
                    } else {
                        field.innerHTML = value;
                    }
                });
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StInjectRepresentativeInfo;
    }(st_module_8.StModule);
    exports.StInjectRepresentativeInfo = StInjectRepresentativeInfo;
});

define("core/shopify-app/st-modules/cart/cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCart = void 0;
    var StCart = function(_super) {
        __extends(StCart, _super);
        function StCart() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Cart";
            _this.reloadSubscriber = [];
            _this.cartInterceptorEndpoints = [ "/cart/add.js", "/cart/update.js", "/cart/change.js", "/cart/clear.js", "/wallets/checkouts/" ];
            _this.shopifyCartApiEndpoints = {
                "get-cart": "/cart.js",
                "add-to-cart": "/cart/add.js",
                "clear-cart": "/cart/clear.js",
                "change-cart": "/cart/change.js",
                "update-cart": "/cart/update.js"
            };
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initCartSetup();
                    _this.cartFetchInterceptorInit();
                });
            };
            _this.cartFetchInterceptorInit = function() {
                var originalFetch = window.fetch;
                window.fetch = function() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return __awaiter(_this, void 0, void 0, function() {
                        var resource, config, response;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                resource = args[0], config = args[1];
                                return [ 4, originalFetch(resource, config) ];

                              case 1:
                                response = _a.sent();
                                if (this.isCartChangeRequest(response.url)) {
                                    this.getCart(this.handleChangeCartInterceptor);
                                }
                                if (this.isGetCartRequest(response.url)) {}
                                return [ 2, response ];
                            }
                        });
                    });
                };
            };
            _this.handleChangeCartInterceptor = function(cartObj) {
                try {
                    _this.setShopifyCartData(cartObj);
                    _this.fireAllCallbacks(cartObj);
                } catch (err) {
                    console.log("handleChangeCartInterceptor ---\x3e Error:", err);
                }
            };
            _this.initCartSetup = function() {
                _this.getCart(function(cartObj) {
                    _this.setShopifyCartData(cartObj);
                });
            };
            _this.fireAllCallbacks = function(cartObject) {
                _this.fireChangeCartCallbacks(cartObject);
                setTimeout(function() {
                    _this.fireRenderCartCallbacks();
                }, 1e3);
            };
            _this.subscribeChangeCart = function(callback) {
                _this.subCallbacks.push(callback);
            };
            _this.fireChangeCartCallbacks = function(cartObject) {
                if (_this.subCallbacks.length > 0) {
                    _this.subCallbacks.forEach(function(callback) {
                        callback(cartObject);
                    });
                }
            };
            _this.subscribeRenderCart = function(callback) {
                _this.subRenderCartCallbacks.push(callback);
            };
            _this.fireRenderCartCallbacks = function() {
                if (_this.subRenderCartCallbacks.length > 0) {
                    _this.subRenderCartCallbacks.forEach(function(callback) {
                        callback();
                    });
                }
            };
            _this.matchUrlSnippet = function(url, urlSnippetArr) {
                for (var i = 0; i < urlSnippetArr.length; i++) {
                    if (url.includes(urlSnippetArr[i])) {
                        return true;
                    }
                }
                return false;
            };
            _this.isGetCartRequest = function(url) {
                return url.endsWith("/cart.json");
            };
            _this.isCartChangeRequest = function(url) {
                return _this.matchUrlSnippet(url, _this.cartInterceptorEndpoints);
            };
            _this.setShopifyCartData = function(cartObj) {
                window.shopifyCartData = cartObj;
                _this.setCartInfo(cartObj);
            };
            _this.handleChangeCartResponseGeneric = function(res, handleFunc, cartRefresh) {
                if (handleFunc === void 0) {
                    handleFunc = function() {};
                }
                if (cartRefresh === void 0) {
                    cartRefresh = true;
                }
                try {
                    var cartRes_1 = JSON.parse(res.response);
                    _this.getCart(function(cartObj) {
                        _this.setShopifyCartData(cartObj);
                        if (cartRefresh) {
                            _this.requestCartRefresh(cartObj);
                        }
                        _this.fireAllCallbacks(cartObj);
                        handleFunc(cartRes_1);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGeneric ---\x3e Error: ", err);
                }
            };
            _this.getCart = function(responseHandle) {
                try {
                    _this.ajax.send({
                        endpoint: _this.shopifyCartApiEndpoints["get-cart"],
                        method: "GET",
                        contentType: "json",
                        callback: function(res) {
                            try {
                                var cartObj = JSON.parse(res.response);
                                responseHandle(cartObj);
                            } catch (err) {
                                console.log("Cart Api Error: ", err);
                            }
                        }
                    });
                } catch (err) {
                    console.log("Get Cart ---\x3e Error:", err);
                }
            };
            _this.clearCart = function(responseHandle) {
                try {
                    _this.ajax.send({
                        endpoint: _this.shopifyCartApiEndpoints["clear-cart"],
                        method: "POST",
                        contentType: "json",
                        callback: function(res) {
                            _this.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Clear Cart ---\x3e Error:", err);
                }
            };
            _this.changeCart = function(changeData, responseHandle, cartRefresh) {
                if (cartRefresh === void 0) {
                    cartRefresh = true;
                }
                try {
                    _this.ajax.send({
                        endpoint: _this.shopifyCartApiEndpoints["change-cart"],
                        method: "POST",
                        contentType: "json",
                        data: changeData,
                        callback: function(res) {
                            _this.handleChangeCartResponseGeneric(res, responseHandle, cartRefresh);
                        }
                    });
                } catch (err) {
                    console.log("Change Cart ---\x3e Error:", err);
                }
            };
            _this.updateCart = function(updateData, responseHandle) {
                try {
                    var data = Array.isArray(updateData) ? {
                        updates: updateData
                    } : updateData;
                    _this.ajax.send({
                        endpoint: _this.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: data,
                        callback: function(res) {
                            _this.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this.addCart = function(addData, responseHandle) {
                try {
                    var data = Array.isArray(addData) ? {
                        items: addData
                    } : addData;
                    _this.ajax.send({
                        endpoint: _this.shopifyCartApiEndpoints["add-to-cart"],
                        method: "POST",
                        contentType: "json",
                        data: data,
                        callback: function(res) {
                            _this.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Add To Cart ---\x3e Error:", err);
                }
            };
            _this.requestCartRefresh = function(cart) {
                var isCartPage = location.pathname === "/cart";
                if (isCartPage) {
                    _this.fireChangeCartCallbacks(cart);
                    return;
                }
                if (!isCartPage) {
                    _this.ajax.send({
                        endpoint: "".concat(window.Shopify.routes.root, "?section_id=cart-drawer"),
                        method: "GET",
                        callback: function(request) {
                            var cartDrawerTemplate = request.responseText;
                            _this.ajax.send({
                                endpoint: "".concat(window.Shopify.routes.root, "?section_id=variant-added"),
                                method: "GET",
                                callback: function(request) {
                                    var variantAddedTemplate = request.responseText;
                                    _this.triggerCartRefresh(cart, {
                                        "cart-drawer": cartDrawerTemplate,
                                        "variant-added": variantAddedTemplate
                                    });
                                }
                            });
                        }
                    });
                }
            };
            _this.triggerCartRefresh = function(cart, sections) {
                var addEvt = new CustomEvent("variant:add");
                var cartRefreshEvt = new CustomEvent("cart:refresh");
                var totalQuantity = cart.items.reduce(function(acc, item) {
                    return acc + item.quantity;
                }, 0);
                var cartChangeEvt = new CustomEvent("cart:change", {
                    detail: {
                        cart: __assign(__assign({}, cart), {
                            item_count: totalQuantity,
                            sections: sections
                        })
                    }
                });
                document.dispatchEvent(cartChangeEvt);
                document.dispatchEvent(cartRefreshEvt);
                document.dispatchEvent(addEvt);
            };
            _this.setCartInfo = function(shopifyCart) {
                _this.cart = __assign(__assign({}, _this.cart), shopifyCart);
            };
            _this.updateCartItemsProperties = function(alias, responseHandler) {
                _this.getCart(function(cartResponse) {
                    var attributes = cartResponse.attributes;
                    attributes = __assign(__assign({}, attributes), {
                        __ref: !!alias ? alias : ""
                    });
                    var updateAttributes = {
                        attributes: attributes
                    };
                    _this.updateCartAttributesOrNote(updateAttributes, function(cartRes) {
                        var items = cartRes.items;
                        _this.processCartItemsRecursive(items, 0, alias);
                        if (responseHandler) {
                            responseHandler();
                        }
                    });
                });
            };
            _this.updateCartAttributesOrNote = function(updateData, responseHandle) {
                try {
                    _this.ajax.send({
                        endpoint: _this.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: updateData,
                        callback: function(res) {
                            _this.handleChangeCartResponseGenericNoRefresh(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this.processCartItemsRecursive = function(cartItems, index, alias) {
                if (index < cartItems.length) {
                    var item = cartItems[index];
                    var propertiesData = item.properties;
                    if (propertiesData._ref !== alias) {
                        propertiesData = __assign(__assign({}, propertiesData), {
                            _ref: !!alias ? alias : ""
                        });
                        var updateData = {
                            id: "" + item.key,
                            quantity: item.quantity,
                            properties: propertiesData
                        };
                        _this.changeCart(updateData, function(cartRes) {
                            _this.processCartItemsRecursive(cartRes.items, index + 1, alias);
                        }, false);
                    } else {
                        _this.processCartItemsRecursive(cartItems, index + 1, alias);
                    }
                }
            };
            _this.handleChangeCartResponseGenericNoRefresh = function(res, handleFunc) {
                try {
                    var cartRes = JSON.parse(res.response);
                    handleFunc(cartRes);
                    _this.getCart(function(cartObj) {
                        _this.setShopifyCartData(cartObj);
                        _this.handleChangeCartInterceptor(cartObj);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGenericNoRefresh ---\x3e Error: ", err);
                }
            };
            _this.subscribeCartReload = function() {
                _this.reloadSubscriber.push(false);
                return _this.reloadSubscriber.length - 1;
            };
            _this.triggerCartReload = function(index) {
                var shouldRefresh = true;
                _this.reloadSubscriber[index] = true;
                for (var i = 0; i < _this.reloadSubscriber.length; i++) {
                    if (_this.reloadSubscriber[i] === false) {
                        shouldRefresh = false;
                        break;
                    }
                }
                if (shouldRefresh) window.location.reload();
            };
            _this.subCallbacks = [];
            _this.subRenderCartCallbacks = [];
            return _this;
        }
        Object.defineProperty(StCart.prototype, "getShopifyCartData", {
            get: function() {
                return window.shopifyCartData;
            },
            enumerable: false,
            configurable: true
        });
        return StCart;
    }(st_module_9.StModule);
    exports.StCart = StCart;
});

define("core/shopify-app/st-modules/search-sponsor/sponsor-search-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorClassConfig = void 0;
    var StSearchSponsorClassConfig = function(_super) {
        __extends(StSearchSponsorClassConfig, _super);
        function StSearchSponsorClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorClassConfig";
            _this.classNameSponsorId = "st_sponsor-id_JS";
            _this.selectorSponsorId = "." + _this.classNameSponsorId;
            _this.classNameSponsorAlias = "st_sponsor-alias_JS";
            _this.selectorSponsorAlias = "." + _this.classNameSponsorAlias;
            _this.classNameSponsorFullName = "st_sponsor-fullname_JS";
            _this.selectorSponsorFullName = "." + _this.classNameSponsorFullName;
            _this.classNameSponsorInitials = "st_sponsor-initials_JS";
            _this.selectorSponsorInitials = "." + _this.classNameSponsorInitials;
            _this.classNameSponsorAddress = "st_sponsor-address_JS";
            _this.selectorSponsorAddress = "." + _this.classNameSponsorAddress;
            _this.classNameSearchSponsorWrapperPage = "st_search-sponsor--wrapper_JS";
            _this.selectorSearchSponsorWrapperPage = "." + _this.classNameSearchSponsorWrapperPage;
            _this.classNameInputBoxPage = "st_search-sponsor--by-id_JS";
            _this.selectorInputBoxPage = "." + _this.classNameInputBoxPage;
            _this.classNameChangeSponsorWrapperlink = "st_change-sponsor--wrapper_JS";
            _this.selectorChangeSponsorWrapperLink = "." + _this.classNameChangeSponsorWrapperlink;
            _this.classNameChangeSponsorWrapper = "st_change-sponsor_JS";
            _this.selectorChangeSponsorWrapper = "." + _this.classNameChangeSponsorWrapper;
            _this.classNameSearchInput = "st_search-input_JS";
            _this.selectorSearchInput = "." + _this.classNameSearchInput;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classNameChooseSponsor = "st_choose-sponsor_JS";
            _this.selectorChooseSponsor = "." + _this.classNameChooseSponsor;
            _this.classNameSearchResult = "st_search-result_JS";
            _this.selectorSearchResult = "." + _this.classNameSearchResult;
            _this.classNameRepresentativeAlias = "st_representative-alias_JS";
            _this.selectorRepresentativeAlias = "." + _this.classNameRepresentativeAlias;
            _this.classNameRepresentativeFullName = "st_representative-fullname_JS";
            _this.selectorRepresentativeFullName = "." + _this.classNameRepresentativeFullName;
            _this.classNameSponsorData = "st_sponsor-data_JS";
            _this.selectorSponsorData = "." + _this.classNameSponsorData;
            _this.classNameSearchSponsor = "st_search-sponsors_JS";
            _this.selectorSearchSponsor = "." + _this.classNameSearchSponsor;
            _this.classNameFoundSponsor = "st_found-sponsors_JS";
            _this.selectorFoundSponsor = "." + _this.classNameFoundSponsor;
            _this.classNameSearchSponsorBy = "st_search-sponsor-by_JS";
            _this.selectorSearchSponsorBy = "." + _this.classNameSearchSponsorBy;
            _this.classNameRadioText = "st_radio-text";
            _this.selectorRadioText = "." + _this.classNameRadioText;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            return _this;
        }
        return StSearchSponsorClassConfig;
    }(st_module_10.StModule);
    exports.StSearchSponsorClassConfig = StSearchSponsorClassConfig;
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor-guard", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_11, _features_config_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorGuard = void 0;
    var StSearchSponsorGuard = function(_super) {
        __extends(StSearchSponsorGuard, _super);
        function StSearchSponsorGuard(classConfig, browserHistory, objectFormatting, generalMethods, cartComponent) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorGuard";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.listenForSponsorChange();
                    _this.cartComponent.subscribeRenderCart(function() {
                        var ref = _this.objectFormatting.convertQueryStringToObject(window.location.search).ref;
                        _this.toggleCantGoUnderCorporateSite(ref === _features_config_4.defaultWebAlias);
                    });
                });
            };
            _this.toggleElementVisibility = function(element, hideElement) {
                if (hideElement) {
                    _this.hideElement(element);
                } else {
                    _this.showElement(element);
                }
            };
            _this.showElement = function(element) {
                if (_this.isElementHidden(element)) {
                    element.classList.remove("st_hidden");
                }
            };
            _this.hideElement = function(element) {
                if (!_this.isElementHidden(element)) {
                    element.classList.add("st_hidden");
                }
            };
            _this.isElementHidden = function(element) {
                return element.classList.contains("st_hidden");
            };
            _this.toggleShoppingWith = function(hideElement) {
                var banner = document.querySelector(_this.classConfig.selectorRepresentativeBannerWrapper);
                _this.toggleElementVisibility(banner, hideElement);
            };
            _this.disableNonSponsor = function() {
                var nonSponsorBtn = document.querySelector(_this.classConfig.selectorNonSponsor);
                nonSponsorBtn === null || nonSponsorBtn === void 0 ? void 0 : nonSponsorBtn.remove();
            };
            _this.toggleBuying = function(hideBuying) {
                _this.toggleCheckoutButtons(hideBuying);
                _this.togglePaymentButtons(hideBuying);
                _this.toggleSearchSponsor(hideBuying);
            };
            _this.toggleSearchSponsor = function(hideElement) {
                var searchSponsorWrappers = document.querySelectorAll(".st_search-sponsor--wrapper_JS");
                searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                    _this.toggleSearchSponsorInput(searchSponsorWrapper, !hideElement);
                    _this.toggleSearchSponsorResult(searchSponsorWrapper, hideElement);
                });
            };
            _this.toggleSearchSponsorResult = function(container, hideElement) {
                var searchSponsorResultWrapper = container.querySelector(".st_search-result_JS");
                if (!!searchSponsorResultWrapper) {
                    _this.toggleElementVisibility(searchSponsorResultWrapper, hideElement);
                }
            };
            _this.toggleSearchSponsorInput = function(container, hideElement) {
                var searchSponsorInputWrapper = container.querySelector(".st_search-input_JS");
                if (!!searchSponsorInputWrapper) {
                    _this.toggleElementVisibility(searchSponsorInputWrapper, hideElement);
                }
            };
            _this.toggleCheckoutButtons = function(hideElement) {
                var checkoutButtons = document.querySelectorAll('button[name="checkout"]');
                if (checkoutButtons.length > 0) {
                    checkoutButtons.forEach(function(btn) {
                        _this.toggleElementVisibility(btn, hideElement);
                    });
                }
            };
            _this.togglePaymentButtons = function(hideElement) {
                var paymentButtonsWrapper = document.querySelectorAll(".st_product-buy-now-wrapper_JS");
                if (paymentButtonsWrapper.length > 0) {
                    paymentButtonsWrapper.forEach(function(wrp) {
                        _this.toggleElementVisibility(wrp, hideElement);
                    });
                }
            };
            _this.toggleCantGoUnderCorporateSite = function(hideElements) {
                if (!_features_config_4.canGoUnderCorporateSite) {
                    _this.disableNonSponsor();
                    _this.toggleShoppingWith(hideElements);
                    _this.toggleBuying(hideElements);
                }
            };
            _this.listenForSponsorChange = function() {
                window.addEventListener("sponsorChange", function() {
                    var ref = _this.objectFormatting.convertQueryStringToObject(window.location.search).ref;
                    _this.toggleCantGoUnderCorporateSite(ref === _features_config_4.defaultWebAlias);
                });
            };
            _this.classConfig = classConfig;
            _this.browserHistory = browserHistory;
            _this.objectFormatting = objectFormatting;
            _this.generalMethods = generalMethods;
            _this.cartComponent = cartComponent;
            return _this;
        }
        return StSearchSponsorGuard;
    }(st_module_11.StModule);
    exports.StSearchSponsorGuard = StSearchSponsorGuard;
});

define("core/connector-app/_shared/models/customer/sponsor/customer.update.sponsor.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/webalias/webalias.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/_general/account-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_12) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountClassConfig = void 0;
    var StAccountClassConfig = function(_super) {
        __extends(StAccountClassConfig, _super);
        function StAccountClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "AccountClassConfig";
            _this.classNameProvinceSelector = "st_province-selector_JS";
            _this.selectorProvinceSelector = "." + _this.classNameProvinceSelector;
            _this.classNameProvinceSource = "st_province-source_JS";
            _this.selectorProvinceSource = "." + _this.classNameProvinceSource;
            _this.classNameAccountPage = "st_account_JS";
            _this.selectorAccountPage = "." + _this.classNameAccountPage;
            _this.classNameAccountSection = "st_account-page--section_JS";
            _this.selectorAccountSection = "." + _this.classNameAccountSection;
            _this.classNameAccountContent = "st_account-page_JS";
            _this.selectorAccountContent = "." + _this.classNameAccountContent;
            _this.classNameAccountNavWrapper = "st_account-nav--wrapper_JS";
            _this.selectorAccountNavWrapper = "." + _this.classNameAccountNavWrapper;
            _this.classNameAccountNavHolder = "st_account-nav--holder_JS";
            _this.selectorAccountNavHolder = "." + _this.classNameAccountNavHolder;
            _this.classNameAccountNavHolderSingle = "st_account-nav--holder-single_JS";
            _this.selectorAccountNavHolderSingle = "." + _this.classNameAccountNavHolderSingle;
            _this.classNameAccountNavButton = "st_account-button_JS";
            _this.selectorAccountNavButton = "." + _this.classNameAccountNavButton;
            _this.classNameAccountIcon = "st_account--nav-icon_JS";
            _this.selectorAccountIcon = "." + _this.classNameAccountIcon;
            _this.classNameAccountCopyText = "st_copy-repsite_JS";
            _this.selectorAccountIconCopyText = "." + _this.classNameAccountCopyText;
            _this.classNameAccountCopyTextWrapper = "st_copy-repsite--wrapper_JS";
            _this.selectorAccountIconCopyTextWrapper = "." + _this.classNameAccountCopyTextWrapper;
            _this.classNameAccountLogout = "st_account-logout_JS";
            _this.selectorAccountLogout = "." + _this.classNameAccountLogout;
            _this.classNameAccountWebAlias = "st_formatting-web-alias_JS";
            _this.selectorAccountWebAlias = "." + _this.classNameAccountWebAlias;
            _this.classNameAccountAddressesDropdown = "st_addresses-dots--button_JS";
            _this.selectorAccountAddressesDropdown = "." + _this.classNameAccountAddressesDropdown;
            _this.classNameAccountAddressesDropdownWrapper = "st_dropdown-address--wrapper";
            _this.selectorAccountAddressesDropdownWrapper = "." + _this.classNameAccountAddressesDropdownWrapper;
            _this.classNameAccountTabButton = "st_button-wrapper_JS";
            _this.selectorAccountTabButton = "." + _this.classNameAccountTabButton;
            _this.classNameAccountBackButton = "st_arrow-back--button_JS";
            _this.selectorAccountBackButton = "." + _this.classNameAccountBackButton;
            _this.classNamePasswordVisibilityButton = "st_toggle-visibility-button_JS";
            _this.selectorPasswordVisibilityButton = "." + _this.classNamePasswordVisibilityButton;
            _this.classNameSingleOrder = "st_single-order_JS";
            _this.selectorSingleOrder = "." + _this.classNameSingleOrder;
            _this.classNameOpenOrderCSSClass = "st_open-single-order";
            _this.selectorOpenOrderCSSClass = "." + _this.classNameOpenOrderCSSClass;
            _this.classNameOpenSingleOrderButton = "st_open-single-order_JS";
            _this.selectorOpenSingleOrderButton = "." + _this.classNameOpenSingleOrderButton;
            _this.classNameOrderHistory = "st_order-history_JS";
            _this.selectorOrderHistory = "." + _this.classNameOrderHistory;
            _this.classNameBackToHistoryOrders = "st_back-to-history-orders_JS";
            _this.selectorBackToHistoryOrders = "." + _this.classNameBackToHistoryOrders;
            _this.classNameBackOfficeLink = "st_backoffice-link_JS";
            _this.selectorBackOfficeLink = "." + _this.classNameBackOfficeLink;
            _this.classNameWebAliasFormatting = "st_formatting-web-alias_JS";
            _this.selectorWebAliasFormatting = "." + _this.classNameWebAliasFormatting;
            _this.classNameWebAliasWrapper = "st_web-alias-wrapper_JS";
            _this.selectorWebAliasWrapper = "." + _this.classNameWebAliasWrapper;
            _this.classNameWebAliasValue = "st_web-alias-readonly-input_JS";
            _this.selectorWebAliasValue = "." + _this.classNameWebAliasValue;
            _this.classNameAddressesWrapper = "st_addresses--wrapper_JS";
            _this.selectorAddressesWrapper = "." + _this.classNameAddressesWrapper;
            _this.classNameEditWebAliasForm = "st_edit-webalias-form_JS";
            _this.selectorEditWebAliasForm = "." + _this.classNameEditWebAliasForm;
            _this.classNameSubmitButton = "st_submit--btn_JS";
            _this.selectorSubmitButton = "." + _this.classNameSubmitButton;
            _this.classNameProvinceWrapper = "st_province-wrapper_JS";
            _this.selectorProvinceWrapper = "." + _this.classNameProvinceWrapper;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNameBusinessContent = "st_account-business--content_JS";
            _this.selectorBusinessContent = "." + _this.classNameBusinessContent;
            _this.classNameBusinessContentName = "st_account-business--name_JS";
            _this.selectorBusinessContentName = "." + _this.classNameBusinessContentName;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNameBusinessContentEmail = "st_account-business--email_JS";
            _this.selectorBusinessContentEmail = "." + _this.classNameBusinessContentEmail;
            return _this;
        }
        return StAccountClassConfig;
    }(st_module_12.StModule);
    exports.StAccountClassConfig = StAccountClassConfig;
});

define("core/shopify-app/st-modules/account/blocks/personal-site/personal-site", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_13, _features_config_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalSite = void 0;
    var StAccountPersonalSite = function(_super) {
        __extends(StAccountPersonalSite, _super);
        function StAccountPersonalSite(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountPersonalSite";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.copyRefToClipboard(_this_1.classConfig.selectorAccountIconCopyText, ".st_representative-site-link_JS");
                    _this_1.getRefCode();
                });
            };
            _this_1.getRefCode = function() {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                if (_features_config_5.shareRefCodeFunctionality) {
                    _this_1.copyRefToClipboard(".st_referral-link-copy-clipboard_JS", ".st_retail-personal-promo-code-link_JS");
                    _this_1.createLinkWithRef;
                    _this_1.showIncludePromoCode();
                    _this_1.showPersonalSiteRetailBlock();
                    if (!customersRef) {
                        _this_1.createLinkWithoutRef;
                    }
                } else {
                    _this_1.hideIncludePromoCode();
                    _this_1.hidePersonalSiteRetailBlock();
                    _this_1.createLinkWithoutRef;
                }
            };
            _this_1.createLinkWithRef = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                retailInput.forEach(function(input) {
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + "ref=" + alias;
                });
            };
            _this_1.createLinkWithoutRef = function(ref) {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var ref = localStorage.getItem("ref");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + "ref=" + ref;
                    });
                }
            };
            _this_1.hidePersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showPersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.createLinkWithRefRep = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_representative-site-link_JS");
                retailInput.forEach(function(input) {
                    var hisAlias = localStorage.getItem("ref");
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + "ref=" + hisAlias + "&" + "ref=" + customersRef;
                });
            };
            _this_1.createLinkWithoutRefRep = function(ref) {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var hisAlias = localStorage.getItem("ref");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + "ref=" + hisAlias;
                    });
                }
            };
            _this_1.includePromoCode = function(ref) {
                var _this = _this_1;
                var includeInput = document.querySelector(".st_include-promo-code-input_JS");
                if (!!includeInput) {
                    var inputEl_1 = document.querySelectorAll(".st_representative-site-link_JS");
                    if (includeInput.checked) {
                        _this.createLinkWithRefRep(ref);
                    } else {
                        _this.createLinkWithoutRefRep(ref);
                    }
                    includeInput.addEventListener("change", function(event) {
                        if (!!inputEl_1) {
                            if (includeInput.checked) {
                                _this.createLinkWithRefRep(ref);
                            } else {
                                _this.createLinkWithoutRefRep(ref);
                            }
                        }
                    });
                }
            };
            _this_1.hideIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.copyRefToClipboard = function(button, input) {
                var copyRepSiteButtonAll = document.querySelectorAll(button);
                if (!!copyRepSiteButtonAll) {
                    copyRepSiteButtonAll.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            var copyText = document.querySelectorAll(input);
                            if (!!copyText) {
                                copyText.forEach(function(input) {
                                    if (!!input) {
                                        input.select();
                                        input.setSelectionRange(0, 99999);
                                        navigator.clipboard.writeText(input.value);
                                        input.style.backgroundColor = "rgb(217, 218, 220)";
                                        input.style.transition = "0.2s";
                                        setTimeout(function() {
                                            input.style.backgroundColor = "rgb(249, 249, 249)";
                                        }, 1e3);
                                    }
                                });
                            }
                        });
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountPersonalSite;
    }(st_module_13.StModule);
    exports.StAccountPersonalSite = StAccountPersonalSite;
});

define("core/shopify-app/st-modules/share-cart/share-cart-landing", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_14, _features_config_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCartLanding = void 0;
    var StShareCartLanding = function(_super) {
        __extends(StShareCartLanding, _super);
        function StShareCartLanding(objectFormatting, cartComponent) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StShareCartLanding";
            _this.landOnShareCart = function(cartToken) {
                _this.clearCart(_this.injectShareableCart, [ cartToken, function(responseData) {
                    var parseData = JSON.parse(responseData);
                    var sponsorRepId = parseData.sponsorRepId || parseData.repId;
                    var partyId = parseData.partyId;
                    var isOutOfStock = parseData.isItemOutOfStock;
                    var params = new URLSearchParams();
                    if (sponsorRepId) {
                        params.set(_features_config_6.webAliasParam, sponsorRepId);
                    }
                    if (partyId) {
                        params.set("partyId", partyId);
                    }
                    if (isOutOfStock) {
                        params.set("itemOutOfStock", "true");
                    }
                    window.location.href = "".concat(window.location.protocol, "//").concat(window.location.hostname, "/cart?").concat(params.toString());
                } ]);
            };
            _this.toggleShareCartOverlayDisplay = function(showLoadingPage) {
                var overlayWrapper = document.querySelector(".st_landing_share_cart_overlay_JS");
                if (overlayWrapper) {
                    showLoadingPage ? overlayWrapper.classList.remove("st_hidden") : overlayWrapper.classList.add("st_hidden");
                }
            };
            _this.injectShareableCart = function(cartToken, callback, params) {
                var _a;
                var shopifyCustomerId = window.customerShopifyId;
                var shareCartUrl = ((_a = window === null || window === void 0 ? void 0 : window.stAppConfig) === null || _a === void 0 ? void 0 : _a.shareCartUrl) || "";
                var apiUrl = "".concat(shareCartUrl, "/share-cart/getShareCartByToken/").concat(cartToken, "?shopifyCustomerId=").concat(shopifyCustomerId);
                var requestOptions = {
                    method: "GET",
                    headers: {
                        "x-api-key": _this.shareCartApiKey,
                        "Content-Type": "application/json"
                    }
                };
                fetch(apiUrl, requestOptions).then(function(response) {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                }).then(function(responseData) {
                    var _a;
                    var itemsToAdd = [];
                    if (responseData.data) {
                        if (responseData.data.line_items && responseData.data.line_items.length > 0) {
                            responseData.data.line_items.forEach(function(lineItem) {
                                if (lineItem.quantity >= 1) {
                                    var addItem = {
                                        quantity: lineItem.quantity,
                                        id: lineItem.shopify_variant_id,
                                        properties: __assign(__assign({}, lineItem.line_item_properties), {
                                            _sharedCartToken: cartToken
                                        })
                                    };
                                    itemsToAdd.push(addItem);
                                }
                            });
                        }
                        var isItemOutOfStock = ((_a = responseData.data.line_item_messages) === null || _a === void 0 ? void 0 : _a.is_out_of_stock) ? responseData.data.line_item_messages.is_out_of_stock : undefined;
                        var updateAttributes = {
                            attributes: __assign(__assign({}, responseData.data.share_cart_attributes), {
                                _sharedCartToken: cartToken
                            })
                        };
                        _this.cartComponent.updateCartAttributesOrNote(updateAttributes, function() {});
                        var paramsToSave = {
                            repId: responseData.data.share_cart_attributes.repId,
                            partyId: responseData.data.share_cart_attributes.partyId ? responseData.data.share_cart_attributes.partyId : undefined,
                            isItemOutOfStock: isItemOutOfStock
                        };
                        params = JSON.stringify(paramsToSave);
                        _this.addItems(itemsToAdd, callback, params);
                    } else {
                        _this.shareCartGenerateError();
                    }
                }).catch(function(error) {
                    _this.shareCartGenerateError();
                    console.error(error);
                });
            };
            _this.shareCartGenerateError = function(outOfStockErrorMessage) {
                var loadingOverlay = document.querySelector(".st_landing_share_cart_overlay_JS");
                if (loadingOverlay) {
                    var contentWrapper = loadingOverlay.querySelector(".st_content_wrapper_JS");
                    contentWrapper === null || contentWrapper === void 0 ? void 0 : contentWrapper.classList.add("st_hidden");
                    var errorWrapper = loadingOverlay.querySelector(".st_error_message_wrapper_JS");
                    errorWrapper.classList.remove("st_hidden");
                    if (outOfStockErrorMessage) {
                        var errorEl = errorWrapper.querySelector(".st_error_JS");
                        if (errorEl) {
                            errorEl.innerHTML = outOfStockErrorMessage;
                        }
                    }
                }
            };
            _this.clearCart = function(callback, params) {
                if (params === void 0) {
                    params = [];
                }
                _this.cartComponent.clearCart(function(response) {
                    callback.apply(void 0, params);
                });
            };
            _this.addItems = function(items, cb, params) {
                _this.cartComponent.addCart(items, function(response) {
                    cb(params);
                });
            };
            _this.disableBodyScroll = function() {
                document.body.style.overflow = "hidden";
            };
            _this.objectFormatting = objectFormatting;
            _this.cartComponent = cartComponent;
            return _this;
        }
        Object.defineProperty(StShareCartLanding.prototype, "shareCartApiKey", {
            get: function() {
                var shareCartKey = window.shareCartApiKey;
                return shareCartKey;
            },
            enumerable: false,
            configurable: true
        });
        return StShareCartLanding;
    }(st_module_14.StModule);
    exports.StShareCartLanding = StShareCartLanding;
});

define("core/shopify-app/st-modules/webalias/webalias", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_15, _features_config_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAlias = void 0;
    var StWebAlias = function(_super) {
        __extends(StWebAlias, _super);
        function StWebAlias(classConfig, browserHistory, objectFormatting, cookies, customerType, generalMethods, injectRepresentativeInfo, cartComponent, searchSponsorGuard, accountPersonalSite, shareCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "WebAlias";
            _this_1.cookieNameWebAlias = "ref";
            _this_1.cookieNameRepId = "repId";
            _this_1.cookieNameFirstName = "firstName";
            _this_1.cookieNameLastName = "lastName";
            _this_1.cookieNameImageUrl = "imageUrl";
            _this_1.cookieNamePromoCode = "promoCode";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var queryParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    _this_1.initWebAliasFlow();
                    _this_1.initSponsorCheck();
                    if (!_this_1.isCustomerGuest) {
                        _this_1.getSponsorInformation();
                    }
                    if (queryParams.share_cart_token) {
                        _this_1.shareCart.landOnShareCart(queryParams.share_cart_token);
                    }
                });
            };
            _this_1.initWebAliasFlow = function() {
                if (_this_1.isCustomerRepresentative) {
                    _this_1.representativeAliasFlow();
                    return;
                }
                if (_this_1.isCustomerRetail) {
                    _this_1.retailAliasFlow();
                    return;
                }
                if (_this_1.isCustomerGuest) {
                    _this_1.guestAliasFlow();
                }
            };
            _this_1.representativeAliasFlow = function() {
                var customerId = _this_1.customerIdFromMetafields;
                if (!customerId) {
                    _this_1.injectRepresentativeCustomerInfo();
                    return;
                }
                _this_1.getRepresentativesOwnInfo(customerId);
            };
            _this_1.retailAliasFlow = function() {
                var representativeId = _this_1.customerRepresentativeIdFromMetafields;
                if (!representativeId) {
                    return;
                }
                _this_1.getRepresentativesOwnInfo(representativeId);
            };
            _this_1.guestAliasFlow = function() {
                var ref = _this_1.objectFormatting.convertQueryStringToObject(window.location.search).ref;
                var urlAliasExists = !!ref;
                var cookieAliasExists = !!_this_1.cookies.getCookie("ref");
                if (urlAliasExists) {
                    _this_1.getRepresentativesOwnInfo(ref);
                    return;
                }
                if (cookieAliasExists) {
                    _this_1.injectRepInfoFromCookie();
                    return;
                }
                _this_1.injectDefaultRepInfo();
            };
            _this_1.handleRepresentativeInfoResponse = function(response) {
                var data = response.data, status = response.status;
                if (status !== 200 || !data) {
                    _this_1.nonExistentRepresentativeFlow();
                    return;
                }
                var repInfo = _this_1.normalizeRepInfo(data);
                if (_this_1.isCustomerRepresentative) {
                    repInfo = _this_1.getRepresentativeInfoWithCustomerFallback(repInfo);
                }
                if (!repInfo.ref) {
                    _this_1.nonExistentRepresentativeFlow();
                    return;
                }
                _this_1.updateCurrentRepInfo(repInfo);
            };
            _this_1.getRepresentativesOwnInfo = function(customerIdOrAlias) {
                _this_1.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                }, _this_1.handleRepresentativeInfoResponse);
            };
            _this_1.getCustomersRepresentativeInfo = function(customerIdOrAlias) {
                _this_1.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: false
                }, _this_1.handleRepresentativeInfoResponse);
            };
            _this_1.getRepresentativeInfo = function(webAliasRequest, handleResponse) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["webalias"]["repSite"],
                        method: "post",
                        contentType: "json",
                        data: webAliasRequest,
                        callback: function(response) {
                            try {
                                var representativeInfoRes = JSON.parse(response.response);
                                handleResponse(representativeInfoRes);
                            } catch (error) {
                                _this_1.nonExistentRepresentativeFlow();
                                console.log("Response Error ------\x3e" + error);
                            }
                        }
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e" + error);
                }
            };
            _this_1.getSponsorInformation = function() {
                var repIdMetafield = _this_1.customerRepresentativeIdFromMetafields;
                if (!repIdMetafield) {
                    _this_1.injectRepresentativeInfo.injectSponsorInfoToField("", "");
                    return;
                }
                var webAliasRequestedData = {
                    customerIdOrAlias: repIdMetafield,
                    isOwnInfo: true
                };
                _this_1.getRepresentativeInfo(webAliasRequestedData, _this_1.handleSponsorInfoResponse);
            };
            _this_1.handleSponsorInfoResponse = function(response) {
                if (response.status === 200) {
                    var sponsorInfo = response.data;
                    _this_1.injectRepresentativeInfo.injectSponsorInfoToField(sponsorInfo.firstName, sponsorInfo.lastName);
                    _this_1.accountPersonalSite.createLinkWithRef(sponsorInfo.ref);
                    _this_1.accountPersonalSite.includePromoCode(sponsorInfo.ref);
                } else {
                    _this_1.injectRepresentativeInfo.injectSponsorInfoToField("", "");
                }
            };
            _this_1.updateCurrentRepInfo = function(repInfo) {
                return __awaiter(_this_1, void 0, void 0, function() {
                    var ref;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            ref = repInfo.ref;
                            this.setRepresentativeCookies(repInfo);
                            if (!(repInfo.repId !== _features_config_7.defaultWebAlias)) return [ 3, 2 ];
                            return [ 4, this.isCustomerPromoCodeEligible() ];

                          case 1:
                            _a.sent();
                            _a.label = 2;

                          case 2:
                            this.cartComponent.updateCartItemsProperties(ref);
                            this.searchSponsorGuard.toggleCantGoUnderCorporateSite(ref === _features_config_7.defaultWebAlias);
                            this.injectRepresentativeInfo.injectToFields(repInfo);
                            return [ 2 ];
                        }
                    });
                });
            };
            _this_1.nonExistentRepresentativeFlow = function() {
                if (_this_1.isCustomerRepresentative) {
                    _this_1.injectRepresentativeCustomerInfo();
                    return;
                }
                if (_this_1.isCustomerRetail) {
                    return;
                }
                _this_1.injectDefaultRepInfo();
            };
            _this_1.injectRepInfoFromCookie = function() {
                var ref = _this_1.cookies.getCookie(_this_1.cookieNameWebAlias);
                if (!ref) {
                    _this_1.injectDefaultRepInfo();
                    return;
                }
                var repInfo = {
                    firstName: _this_1.cookies.getCookie(_this_1.cookieNameFirstName) || "",
                    lastName: _this_1.cookies.getCookie(_this_1.cookieNameLastName) || "",
                    ref: ref,
                    repId: _this_1.cookies.getCookie(_this_1.cookieNameRepId) || ref,
                    promoCode: _this_1.cookies.getCookie(_this_1.cookieNamePromoCode) || ""
                };
                var imageUrl = _this_1.cookies.getCookie(_this_1.cookieNameImageUrl);
                if (!!imageUrl && _features_config_7.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: imageUrl
                    });
                }
                _this_1.updateCurrentRepInfo(repInfo);
            };
            _this_1.injectDefaultRepInfo = function() {
                var repInfo = {
                    ref: _features_config_7.defaultWebAlias,
                    firstName: _features_config_7.corporationName,
                    lastName: ""
                };
                if (_features_config_7.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: _features_config_7.defaultCorporationImage
                    });
                }
                _this_1.updateCurrentRepInfo(repInfo);
            };
            _this_1.injectRepresentativeCustomerInfo = function() {
                var customerInfo = window.customerInfoMetafields || {};
                var ref = customerInfo.webAlias || customerInfo.ref || customerInfo.personalId || customerInfo.customerId || "";
                var firstName = customerInfo.firstName || customerInfo.customerFirstName || "";
                var lastName = customerInfo.lastName || customerInfo.customerLastName || "";
                if (!ref) {
                    return;
                }
                var repInfo = {
                    ref: ref,
                    firstName: firstName,
                    lastName: lastName,
                    repId: customerInfo.personalId || customerInfo.customerId || ref
                };
                _this_1.updateCurrentRepInfo(repInfo);
            };
            _this_1.isAliasEqualToStored = function(alias) {
                return alias === _this_1.cookies.getCookie("ref");
            };
            _this_1.isAliasEqualToUrlAlias = function(alias) {
                var ref = _this_1.objectFormatting.convertQueryStringToObject(window.location.search).ref;
                return ref === alias;
            };
            _this_1.setNewAliasInUrl = function(alias) {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var newUrlParams = __assign({}, urlParams);
                if (alias === _features_config_7.defaultWebAlias || alias === "1") {
                    delete newUrlParams.ref;
                } else {
                    newUrlParams = __assign(__assign({}, newUrlParams), {
                        ref: alias
                    });
                }
                _this_1.cartComponent.updateCartItemsProperties(alias);
                if (Object.keys(newUrlParams).length === 0) {
                    window.history.replaceState({}, "", window.location.origin + window.location.pathname);
                    return;
                }
                var newURL = window.location.href.replace(window.location.search, "");
                _this_1.browserHistory.pushHistory(newURL, newUrlParams);
            };
            _this_1.setRepresentativeCookies = function(repInfo) {
                var cookieDurationDays = 30;
                _this_1.cookies.setCookies(_this_1.cookieNameWebAlias, repInfo.ref || "", cookieDurationDays);
                _this_1.cookies.setCookies(_this_1.cookieNameRepId, repInfo.repId || repInfo.ref || "", cookieDurationDays);
                _this_1.cookies.setCookies(_this_1.cookieNameFirstName, repInfo.firstName || "", cookieDurationDays);
                _this_1.cookies.setCookies(_this_1.cookieNameLastName, repInfo.lastName || "", cookieDurationDays);
                _this_1.cookies.setCookies(_this_1.cookieNamePromoCode, repInfo.promoCode || "", cookieDurationDays);
                if (_features_config_7.additionalRepInfo) {
                    _this_1.cookies.setCookies(_this_1.cookieNameImageUrl, repInfo.imageUrl || "", cookieDurationDays);
                }
            };
            _this_1.initSponsorWebAliasFieldChange = function() {
                var representativeWebAliasInput = document.querySelectorAll(".st_representative-alias_JS");
                representativeWebAliasInput.forEach(function(webAliasInput) {
                    webAliasInput.oninput = function() {
                        return _this_1.updateWebAliasOnSponsorFieldChange(webAliasInput);
                    };
                });
            };
            _this_1.updateWebAliasOnSponsorFieldChange = function(representativeWebAliasInput) {
                clearTimeout(_this_1.sponsorWebAliasInputTimeout);
                _this_1.sponsorWebAliasInputTimeout = setTimeout(function() {
                    var currentUrlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    var newUrlParams = __assign(__assign({}, currentUrlParams), {
                        ref: representativeWebAliasInput.value
                    });
                    var newQueryString = _this_1.objectFormatting.convertObjectToQueryString(newUrlParams);
                    _this_1.cartComponent.updateCartItemsProperties(representativeWebAliasInput.value);
                }, 1e3);
            };
            _this_1.initSponsorCheck = function() {
                if (_this_1.isCustomerRetail) {
                    return;
                }
                var shopifyCustomerId = _this_1.shopifyCustomerId;
                if (_this_1.isTimeForSponsorCheck() && shopifyCustomerId && shopifyCustomerId !== 0) {
                    _this_1.updateCustomerSponsor(shopifyCustomerId);
                }
            };
            _this_1.updateCustomerSponsor = function(shopifyCustomerId) {
                var updateSponsorData = {
                    shopifyCustomerId: shopifyCustomerId
                };
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["customer"]["updateSponsor"],
                        method: "post",
                        contentType: "json",
                        data: updateSponsorData
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e " + error);
                }
            };
            _this_1.isTimeForSponsorCheck = function() {
                var timestamp = Date.now();
                var lastCheck = _this_1.customerSponsorLastCheck;
                var timeThreshold = _features_config_7.sponsorGenealogyTimeout ? _features_config_7.sponsorGenealogyTimeout : 9e5;
                return timestamp - lastCheck > timeThreshold;
            };
            _this_1.getRepresentativeInfoWithCustomerFallback = function(repInfo) {
                var customerInfo = window.customerInfoMetafields || {};
                var firstName = customerInfo.firstName || customerInfo.customerFirstName || repInfo.firstName || "";
                var lastName = customerInfo.lastName || customerInfo.customerLastName || repInfo.lastName || "";
                if (firstName === _features_config_7.corporationName) {
                    firstName = "";
                }
                return __assign(__assign({}, repInfo), {
                    ref: repInfo.ref || customerInfo.webAlias || customerInfo.ref || customerInfo.personalId || customerInfo.customerId || "",
                    repId: repInfo.repId || customerInfo.personalId || customerInfo.customerId || repInfo.ref || "",
                    firstName: firstName,
                    lastName: lastName,
                    promoCode: repInfo.promoCode || ""
                });
            };
            _this_1.normalizeRepInfo = function(data) {
                var ref = data.ref || data.ref_code || data.webAlias || data.web_alias || data.alias || data.repId || data.id || "";
                var repId = data.repId || data.rep_id || data.personalId || data.customer_id || data.id || ref;
                return {
                    ref: ref,
                    repId: repId,
                    firstName: data.firstName || data.first_name || data.firstname || data.first || "",
                    lastName: data.lastName || data.last_name || data.lastname || data.last || "",
                    imageUrl: data.imageUrl || data.image_url || data.image || "",
                    promoCode: data.promoCode
                };
            };
            _this_1.classConfig = classConfig;
            _this_1.browserHistory = browserHistory;
            _this_1.objectFormatting = objectFormatting;
            _this_1.cookies = cookies;
            _this_1.customerType = customerType;
            _this_1.generalMethods = generalMethods;
            _this_1.injectRepresentativeInfo = injectRepresentativeInfo;
            _this_1.cartComponent = cartComponent;
            _this_1.searchSponsorGuard = searchSponsorGuard;
            _this_1.accountPersonalSite = accountPersonalSite;
            _this_1.shareCart = shareCart;
            return _this_1;
        }
        Object.defineProperty(StWebAlias.prototype, "isCustomerGuest", {
            get: function() {
                return this.customerType.get() === _features_config_7.ECustomerType.guest;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "isCustomerRetail", {
            get: function() {
                return this.customerType.get() === _features_config_7.ECustomerType.retail;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "isCustomerRepresentative", {
            get: function() {
                return this.customerType.get() === _features_config_7.ECustomerType.representative || this.customerType.get() === _features_config_7.ECustomerType.consultant || this.customerType.get() === _features_config_7.ECustomerType.members;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "customerIdFromMetafields", {
            get: function() {
                var customerInfo = window.customerInfoMetafields || {};
                return customerInfo.customerId || customerInfo.personalId || customerInfo.repId || customerInfo.ref || "";
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "customerRepresentativeIdFromMetafields", {
            get: function() {
                var customerInfo = window.customerInfoMetafields || {};
                return customerInfo.representativeId || customerInfo.uplineId || customerInfo.sponsorId || "";
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "shopifyCustomerId", {
            get: function() {
                return window.customerShopifyId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "customerSponsorLastCheck", {
            get: function() {
                return window.customerSponsorLastCheck;
            },
            enumerable: false,
            configurable: true
        });
        StWebAlias.prototype.isCustomerPromoCodeEligible = function() {
            return __awaiter(this, void 0, void 0, function() {
                var _this_2;
                var _this_1 = this;
                return __generator(this, function(_a) {
                    try {
                        _this_2 = this;
                        this.ajax.send({
                            endpoint: this.endpoint["webalias"]["isPromoCodeEligible"],
                            method: "post",
                            contentType: "json",
                            data: {
                                shopifyCustomerId: this.shopifyCustomerId
                            },
                            callback: function(response) {
                                try {
                                    var res = JSON.parse(response.response);
                                    var isCustomerPromoCodeEligible = res.data.isPromoCodeEligible;
                                    var promoCode = localStorage.getItem("promoCode");
                                    if (isCustomerPromoCodeEligible) {
                                        _this_2.cartComponent.updateCart({
                                            discount: promoCode,
                                            attributes: {
                                                promoCode: promoCode
                                            }
                                        }, function(res) {});
                                    } else {
                                        _this_2.cartComponent.updateCart({
                                            discount: promoCode,
                                            attributes: {
                                                promoCode: ""
                                            }
                                        }, function(res) {});
                                    }
                                } catch (error) {
                                    _this_1.nonExistentRepresentativeFlow();
                                    console.log("Response Error ------\x3e" + error);
                                }
                            }
                        });
                    } catch (err) {
                        console.error(" Error: ".concat(err));
                        return [ 2 ];
                    }
                    return [ 2 ];
                });
            });
        };
        return StWebAlias;
    }(st_module_15.StModule);
    exports.StWebAlias = StWebAlias;
});

define("core/shopify-app/st-modules/_general-methods/form/form-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_16) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFormClassConfig = void 0;
    var StFormClassConfig = function(_super) {
        __extends(StFormClassConfig, _super);
        function StFormClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "FormClassConfig";
            _this.classNameDateWrp = "st_date_JS";
            _this.selectorDateWrp = "." + _this.classNameDateWrp;
            _this.classNameDateYearInput = "st_date--year_JS";
            _this.selectorDateYearInput = "." + _this.classNameDateYearInput;
            _this.classNameDateMonthInput = "st_date--month_JS";
            _this.selectorDateMonthInput = "." + _this.classNameDateMonthInput;
            _this.classNameDateDayInput = "st_date--day_JS";
            _this.selectorDateDayInput = "." + _this.classNameDateDayInput;
            _this.classNameDateCompleteInput = "st_date--complete_JS";
            _this.selectorDateCompleteInput = "." + _this.classNameDateCompleteInput;
            _this.months = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
            return _this;
        }
        return StFormClassConfig;
    }(st_module_16.StModule);
    exports.StFormClassConfig = StFormClassConfig;
});

define("core/shopify-app/st-modules/_general-methods/form/fields/date-input", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_17) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDateInput = void 0;
    var StDateInput = function(_super) {
        __extends(StDateInput, _super);
        function StDateInput(classConfig) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "DateInput";
            _this_1.setupDateFields = function() {
                var dateWraps = document.querySelectorAll(_this_1.classConfig.selectorDateWrp);
                dateWraps.forEach(function(dateWrp) {
                    _this_1.setupDateField(dateWrp);
                });
            };
            _this_1.setupDateField = function(dateWrap) {
                var _a;
                var dateYearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var dateMonthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dateDayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var now = new Date();
                var yearNow = now.getUTCFullYear();
                _this_1.generateYears(dateYearInput, 1900, yearNow);
                dateYearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var defaultYear = dateYearInput.getAttribute("data-default");
                var defaultYearIndex = !!defaultYear ? parseInt(dateYearInput.querySelector('[value="'.concat(defaultYear, '"]')).getAttribute("data-index")) : 0;
                _this_1.setSelectValue(dateYearInput, defaultYearIndex);
                _this_1.generateMonths(dateMonthInput);
                dateMonthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var defaultMonth = dateMonthInput.getAttribute("data-default");
                var defaultMonthIndex = !!defaultMonth ? parseInt(dateMonthInput.querySelector('[value="'.concat(defaultMonth, '"]')).getAttribute("data-index")) : 0;
                _this_1.setSelectValue(dateMonthInput, defaultMonthIndex);
                _this_1.generateDays(dateDayInput, (_a = parseInt(dateYearInput.value)) !== null && _a !== void 0 ? _a : yearNow, defaultMonthIndex);
                var defaultDay = dateDayInput.getAttribute("data-default");
                var defaultDayIndex = !!defaultDay ? parseInt(dateDayInput.querySelector('[value="'.concat(defaultDay, '"]')).getAttribute("data-index")) : 0;
                dateDayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                _this_1.setSelectValue(dateDayInput, defaultDayIndex);
                _this_1.setupEvents(dateWrap, dateYearInput, dateMonthInput, dateDayInput);
            };
            _this_1.getDays = function(year, month) {
                return new Date(year, month + 1, 0).getDate();
            };
            _this_1.generateDays = function(holder, year, month) {
                var days = _this_1.getDays(year, month);
                holder.replaceChildren();
                for (var i = 1; i <= days; i++) {
                    var option = _this_1.generateOption(i, undefined, undefined, i - 1);
                    holder.appendChild(option);
                }
                return days;
            };
            _this_1.generateMonths = function(holder) {
                for (var i = 0; i < _this_1.classConfig.months.length; i++) {
                    var option = _this_1.generateOption(i, _this_1.classConfig.months[i], undefined, i);
                    holder.appendChild(option);
                }
            };
            _this_1.generateYears = function(holder, startingYear, endYear) {
                for (var i = 0; i < endYear - startingYear; i++) {
                    var option = _this_1.generateOption(endYear - i, undefined, undefined, i);
                    holder.appendChild(option);
                }
            };
            _this_1.generateOption = function(value, displayValue, selected, elementIndex) {
                if (displayValue === void 0) {
                    displayValue = value;
                }
                if (selected === void 0) {
                    selected = false;
                }
                var option = document.createElement("option");
                option.value = "".concat(value);
                option.setAttribute("value", "".concat(value));
                option.innerHTML = "".concat(displayValue);
                if (selected) {
                    option.setAttribute("selected", "selected");
                }
                if (typeof elementIndex !== "undefined") {
                    option.setAttribute("data-index", "".concat(elementIndex));
                }
                return option;
            };
            _this_1.setSelectValue = function(holder, optionIndex) {
                var options = holder.querySelectorAll("option");
                var selected = options[holder.selectedIndex];
                if (!!selected) {
                    selected.removeAttribute("selected");
                    selected.selected = false;
                }
                optionIndex = optionIndex > options.length - 1 ? options.length - 1 : optionIndex;
                holder.selectedIndex = optionIndex;
                options[optionIndex].selected = true;
                options[optionIndex].setAttribute("selected", "selected");
            };
            _this_1.setInputValue = function(input, value) {
                input.value = value;
                input.setAttribute("value", value);
                input.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            };
            _this_1.setupEvents = function(dateWrap, yearInput, monthInput, dayInput) {
                var _this = _this_1;
                monthInput.addEventListener("change", function(e) {
                    _this.adaptDaysOnChange(dateWrap);
                    _this.completeDate(dateWrap);
                });
                yearInput.addEventListener("change", function(e) {
                    _this.adaptDaysOnChange(dateWrap);
                    _this.completeDate(dateWrap);
                });
                dayInput.addEventListener("change", function(e) {
                    _this.completeDate(dateWrap);
                });
            };
            _this_1.completeDate = function(dateWrap) {
                var yearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var monthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var completeInput = dateWrap.querySelector(_this_1.classConfig.selectorDateCompleteInput);
                var year = parseInt(yearInput.querySelectorAll("option")[yearInput.selectedIndex].value);
                var month = parseInt(monthInput.querySelectorAll("option")[monthInput.selectedIndex].value);
                var day = parseInt(dayInput.querySelectorAll("option")[dayInput.selectedIndex].value);
                var completeDate = "".concat(year, "-").concat(month + 1, "-").concat(day);
                _this_1.setInputValue(completeInput, completeDate);
            };
            _this_1.adaptDaysOnChange = function(dateWrap) {
                var yearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var monthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var year = parseInt(yearInput.querySelectorAll("option")[yearInput.selectedIndex].value);
                var month = parseInt(monthInput.querySelectorAll("option")[monthInput.selectedIndex].value);
                var day = parseInt(dayInput.querySelectorAll("option")[dayInput.selectedIndex].value);
                var maxDays = _this_1.generateDays(dayInput, year, month);
                var selectedIndex = day > maxDays ? maxDays : day;
                _this_1.setSelectValue(dayInput, selectedIndex - 1);
            };
            _this_1.classConfig = classConfig;
            return _this_1;
        }
        return StDateInput;
    }(st_module_17.StModule);
    exports.StDateInput = StDateInput;
});

define("core/shopify-app/st-modules/_general-methods/form/form", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StForm = void 0;
    var StForm = function(_super) {
        __extends(StForm, _super);
        function StForm(classConfig, dateInput) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Form";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.dateInput.setupDateFields();
                });
            };
            _this_1.liveTrim = function(inputs) {
                inputs = inputs ? inputs : document.querySelectorAll(".st_input");
                var trimOperation = function(trigger) {
                    trigger.value = trigger.value.replace(/  +/g, " ");
                    trigger.value = trigger.value.trimStart();
                };
                inputs.forEach(function(input) {
                    input.addEventListener("keyup", function() {
                        trimOperation(this);
                    });
                    input.addEventListener("change", function() {
                        trimOperation(this);
                    });
                });
            };
            _this_1.collectFormData = function(form) {
                if (form === undefined || form === null) {
                    return false;
                }
                var data = {};
                for (var i = 0; i < form.elements.length; i++) {
                    var field = form.elements[i];
                    data = __assign(__assign({}, data), _this_1.collectField(field));
                }
                return data;
            };
            _this_1.collectField = function(field) {
                var data = {};
                if (!field.name || field.type === "file" || field.type === "reset" || field.type === "submit" || field.type === "button") return data;
                if (field.disabled && field.tagName !== "SELECT") return data;
                if (field.type === "select-multiple") {
                    data[field.name] = [];
                    for (var n = 0; n < field.options.length; n++) {
                        if (!field.options[n].selected) continue;
                        data[field.name].push(field.options[n].value);
                    }
                } else if (field.type !== "checkbox" && field.type !== "radio") {
                    data[field.name] = field.value;
                    if (field.value.toLowerCase() === "true") {
                        data[field.name] = true;
                    } else if (field.value.toLowerCase() === "false") {
                        data[field.name] = false;
                    }
                } else if (field.type === "checkbox") {
                    data[field.name] = !!field.checked;
                }
                if (field.getAttribute("data-parse") === "true") {
                    if (field.getAttribute("data-decode") !== "false") {
                        data[field.name] = decodeURIComponent(data[field.name]);
                    }
                    data[field.name] = JSON.parse(data[field.name]);
                }
                return data;
            };
            _this_1.markValidation = function(page, inputName, isValid, invalidMessage) {
                if (invalidMessage === void 0) {
                    invalidMessage = "";
                }
                page.querySelectorAll('[data-validation-visual="'.concat(inputName, '"]')).forEach(function(validationVisual) {
                    var errorMessage = validationVisual.parentElement.querySelector(".st_message-error_JS");
                    if (isValid) {
                        validationVisual.classList.remove("st_input_invalid");
                        if (!!errorMessage) {
                            errorMessage.remove();
                        }
                    } else {
                        validationVisual.classList.add("st_input_invalid");
                        if (!errorMessage) {
                            var errorMessageBlock = document.createElement("span");
                            errorMessageBlock.className = "st_message-error st_message-error_JS";
                            validationVisual.parentElement.append(errorMessageBlock);
                            errorMessage = validationVisual.parentElement.querySelector(".st_message-error_JS");
                        }
                        errorMessage.innerHTML = invalidMessage;
                    }
                });
            };
            _this_1.markValidationResults = function(page, validationResponse) {
                if (Object.keys(validationResponse).length > 0) {
                    Object.keys(validationResponse).forEach(function(paramName) {
                        _this_1.markValidation(page, paramName, validationResponse[paramName].isValid, validationResponse[paramName].message);
                    });
                }
            };
            _this_1.numbersOnly = function() {
                var numberInputs = document.querySelectorAll(".nuv_only-number_JS");
                if (numberInputs && numberInputs.length > 0) {
                    for (var i = 0; i < numberInputs.length; i++) {
                        var inputSelector = numberInputs[i];
                        inputSelector.addEventListener("keyup", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("input", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("change", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                    }
                }
            };
            _this_1.formValidation = function() {
                var _this = _this_1;
                var taxId = document.querySelector('[name="enrollment[tax_id]"]');
                if (taxId && typeof taxId != "undefined") {
                    taxId.addEventListener("input", function(e) {
                        _this.applyFormatting(this);
                    });
                }
                var email = document.querySelector('[name="enrollment[email]"]');
                if (email && typeof email != "undefined") {
                    email.addEventListener("input", function(e) {
                        _this.validateEmail(this);
                    });
                }
                var upgradeEmail = document.querySelector('[name="address[email]"]');
                if (upgradeEmail && typeof upgradeEmail != "undefined") {
                    upgradeEmail.addEventListener("input", function(e) {
                        _this.validateEmail(this);
                    });
                }
            };
            _this_1.validateDateOfBirth = function() {
                var currentYear = new Date().getFullYear();
                var dateOfBirtd = document.querySelector('[name="enrollment[date_of_birtd]"]');
                if (dateOfBirtd && typeof dateOfBirtd != "undefined") {
                    var date = new Date(dateOfBirtd.value);
                    var year = date.getFullYear();
                    return year < currentYear && year > 1900;
                } else {
                    return false;
                }
            };
            _this_1.validateEmail = function(field) {
                var valid = false;
                var val = field.value;
                var at = val.indexOf("@");
                if (at >= 2) {
                    val = val.substr(at);
                    var dot = val.indexOf(".");
                    if (dot >= 2) {
                        val = val.substr(dot);
                        if (val.length >= 2) {
                            valid = true;
                            if (field.classList.contains("st-bds_invalid_input")) {
                                field.classList.remove("st-bds_invalid_input");
                            }
                        }
                    } else {
                        if (!field.classList.contains("st-bds_invalid_input")) {
                            field.classList.add("st-bds_invalid_input");
                        }
                    }
                } else {
                    if (!field.classList.contains("st-bds_invalid_input")) {
                        field.classList.add("st-bds_invalid_input");
                    }
                }
                return valid;
            };
            _this_1.applyFormatting = function(field) {
                var val = field.value;
                var format = "";
                var formatData = {
                    separator: "-",
                    format: "XXX-XX-XXXX",
                    type: "numeric"
                };
                if (formatData.type === "numeric") {
                    val = val.replace(/[^0-9]/g, "");
                }
                if (typeof formatData.format === "object") {
                    format = formatData.format[field.name];
                } else {
                    format = formatData.format;
                    var segments = formatData.separator ? formatData.format.split(formatData.separator) : [ formatData.format ];
                    var disp = [];
                    for (var i = 0; i < segments.length; i++) {
                        var it = val.substr(0, segments[i].length);
                        if (it !== "") {
                            disp.push(it);
                        }
                        val = val.replace(it, "");
                    }
                    val = disp.join(formatData.separator);
                }
                if (format.length > val.length) {
                    field.classList.add("st-bds_invalid_input");
                } else if (format.length === val.length) {
                    field.classList.remove("st-bds_invalid_input");
                } else {
                    val = val.substr(0, format.length);
                }
                field.value = val;
            };
            _this_1.clearFormatting = function(page, inputNames) {
                var _this = _this_1;
                inputNames.forEach(function(inputName) {
                    _this.markValidation(page, inputName, true, "");
                });
            };
            _this_1.dateInput = dateInput;
            _this_1.classConfig = classConfig;
            return _this_1;
        }
        return StForm;
    }(st_module_18.StModule);
    exports.StForm = StForm;
});

define("core/shopify-app/st-modules/account/account", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_19) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccount = void 0;
    var StAccount = function(_super) {
        __extends(StAccount, _super);
        function StAccount(form) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Account";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.form.liveTrim();
                });
            };
            _this.form = form;
            return _this;
        }
        return StAccount;
    }(st_module_19.StModule);
    exports.StAccount = StAccount;
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_20) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentClassConfig = void 0;
    var StEnrollmentClassConfig = function(_super) {
        __extends(StEnrollmentClassConfig, _super);
        function StEnrollmentClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentClassConfig";
            _this.classNameEnrollmentWrapper = "st_enrollment_JS";
            _this.selectorEnrollmentWrapper = "." + _this.classNameEnrollmentWrapper;
            _this.classNameEnrollmentPage = "st_enrollment--page_JS";
            _this.selectorEnrollmentPage = "." + _this.classNameEnrollmentPage;
            _this.classNameEnrollmentPageShow = "st_show";
            _this.selectorEnrollmentPageShow = "." + _this.classNameEnrollmentPageShow;
            _this.classNameEnrollmentForm = "st_enrollment-section--form_JS";
            _this.selectorEnrollmentForm = "." + _this.classNameEnrollmentForm;
            _this.classNameEnrollmentPrev = "st_enrollment--prev_JS";
            _this.selectorEnrollmentPrev = "." + _this.classNameEnrollmentPrev;
            _this.classNameEnrollmentNext = "st_enrollment--next_JS";
            _this.selectorEnrollmentNext = "." + _this.classNameEnrollmentNext;
            _this.classNameEnrollmentNavWrapper = "st_enrollment-nav--wrapper_JS";
            _this.selectorEnrollmentNavWrapper = "." + _this.classNameEnrollmentNavWrapper;
            _this.classNameEnrollmentNavHolder = "st_enrollment-nav--holder_JS";
            _this.selectorEnrollmentNavHolder = "." + _this.classNameEnrollmentNavHolder;
            _this.classNameEnrollmentNavHolderSingle = "st_enrollment-nav--holder-single_JS";
            _this.selectorEnrollmentNavHolderSingle = "." + _this.classNameEnrollmentNavHolderSingle;
            _this.classNameEnrollmentNavButton = "st_enrollment-button_JS";
            _this.selectorEnrollmentNavButton = "." + _this.classNameEnrollmentNavButton;
            _this.classNameInputInvalid = "st_input_invalid";
            _this.selectorInputInvalid = "." + _this.classNameInputInvalid;
            _this.classNameElementShow = "st_show";
            _this.selectorElementShow = "." + _this.classNameElementShow;
            _this.classNameElementHide = "st_hidden";
            _this.selectorElementHide = "." + _this.classNameElementHide;
            _this.textSubmit = "Submit";
            _this.textNext = "Next";
            _this.classNameEnrollmentPrivacyForm = "st_enrollment-section--privacy-form_JS";
            _this.selectorEnrollmentPrivacyForm = "." + _this.classNameEnrollmentPrivacyForm;
            _this.classNameEnrollmentTnCField = "st_enrollment--tnc-field_JS";
            _this.selectorEnrollmentTnCField = "." + _this.classNameEnrollmentTnCField;
            _this.classNameEnrollmentAccountDetailsForm = "st_enrollment-section--account-details-form_JS";
            _this.selectorEnrollmentAccountDetailsForm = "." + _this.classNameEnrollmentAccountDetailsForm;
            _this.classNameEnrollmentAccountDetailsPhone = "st_enrollment-section--account-details-phone_JS";
            _this.selectorEnrollmentAccountDetailsPhone = "." + _this.classNameEnrollmentAccountDetailsPhone;
            _this.classNameEnrollmentBusinessDetailsWebAlias = "st_enrollment-section--business-details-web-alias_JS";
            _this.selectorEnrollmentBusinessDetailsWebAlias = "." + _this.classNameEnrollmentBusinessDetailsWebAlias;
            _this.classNameEnrollmentBusinessDetailsWebAliasPresenter = "st_enrollment-web-alias-preview_JS";
            _this.selectorEnrollmentBusinessDetailsWebAliasPresenter = "." + _this.classNameEnrollmentBusinessDetailsWebAliasPresenter;
            _this.classNameEnrollmentBusinessDetailsSSN = "st_enrollment-section--business-details-ssn_JS";
            _this.selectorEnrollmentBusinessDetailsSSN = "." + _this.classNameEnrollmentBusinessDetailsSSN;
            _this.classEnrollmentRequiredKitVariantSelect = "st_enrollment-required-kits-select_JS";
            _this.selectorEnrollmentRequiredKitVariantSelect = "." + _this.classEnrollmentRequiredKitVariantSelect;
            _this.classEnrollmentRequiredKitVariantHeading = "st_enrollment-required-kit-variant-title_JS";
            _this.selectorEnrollmentRequiredKitVariantHeading = "." + _this.classEnrollmentRequiredKitVariantHeading;
            _this.classEnrollmentRequiredKitVariantPrice = "st_enrollment-required-kit-price_JS";
            _this.selectorEnrollmentRequiredKitVariantPrice = "." + _this.classEnrollmentRequiredKitVariantPrice;
            _this.classEnrollmentRequiredKitSelectedVariantTitle = "st_enrollment-required-kits-selected-variant-title_JS";
            _this.selectorEnrollmentRequiredKitSelectedVariantTitle = "." + _this.classEnrollmentRequiredKitSelectedVariantTitle;
            _this.classEnrollmentHiddenRequiredKitInput = "st_hidden-requiredKitInput_JS";
            _this.selectorEnrollmentHiddenRequiredKitInput = "." + _this.classEnrollmentHiddenRequiredKitInput;
            _this.classEnrollmentRequiredKitWrapper = "st_consultant-kit-order--wrapper";
            _this.selectorEnrollmentRequiredKitWrapper = "." + _this.classEnrollmentRequiredKitWrapper;
            _this.classEnrollmentRequiredKitsOptionsWrapper = "st_enrollment-required-kits-options-wrapper_JS";
            _this.selectorEnrollmentRequiredKitsOptionsWrapper = "." + _this.classEnrollmentRequiredKitsOptionsWrapper;
            _this.classEnrollmentRequiredKitsText = "st_consultant-kit-text_JS";
            _this.selectorEnrollmentRequiredKitsText = "." + _this.classEnrollmentRequiredKitsText;
            _this.classEnrollmentRequiredKitsImg = "st_enrollment-required-kit-img_JS";
            _this.selectorEnrollmentRequiredKitsImg = "." + _this.classEnrollmentRequiredKitsImg;
            _this.classNameEnrollmentOptionalKitsInput = "st_optional-kits--input_JS";
            _this.selectorEnrollmentOptionalKitsInput = "." + _this.classNameEnrollmentOptionalKitsInput;
            _this.classNameEnrollmentOptionalKitsTrigger = "st_enrollment--optional-bundle-trigger_JS";
            _this.selectorEnrollmentOptionalKitsTrigger = "." + _this.classNameEnrollmentOptionalKitsTrigger;
            _this.reviewEditText = "Edit";
            _this.classNameEnrollmentReviewWrapper = "st_enrollment--review-wrapper_JS";
            _this.selectorEnrollmentReviewWrapper = "." + _this.classNameEnrollmentReviewWrapper;
            _this.classNameEnrollmentReviewParamHolder = "st_enrollment--review-param-holder_JS";
            _this.selectorEnrollmentReviewParamHolder = "." + _this.classNameEnrollmentReviewParamHolder;
            _this.classNameEnrollmentReviewCartWrapper = "st_enrollment--review-cart-wrapper_JS";
            _this.selectorEnrollmentReviewCartWrapper = "." + _this.classNameEnrollmentReviewCartWrapper;
            _this.classNameEnrollmentReviewCartContentWrapper = "st_enrollment--review-cart-content-wrapper_JS";
            _this.selectorEnrollmentReviewCartContentWrapper = "." + _this.classNameEnrollmentReviewCartContentWrapper;
            _this.classNameEnrollmentReviewCartTotalWrapper = "st_enrollment--review-cart-total-wrapper_JS";
            _this.selectorEnrollmentReviewCartTotalWrapper = "." + _this.classNameEnrollmentReviewCartTotalWrapper;
            _this.classNameEnrollmentReviewCartTotal = "st_enrollment--review-cart-total_JS";
            _this.selectorEnrollmentReviewCartTotal = "." + _this.classNameEnrollmentReviewCartTotal;
            return _this;
        }
        return StEnrollmentClassConfig;
    }(st_module_20.StModule);
    exports.StEnrollmentClassConfig = StEnrollmentClassConfig;
});

define("core/shopify-app/st-modules/enrollment/enrollment", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_21) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollment = void 0;
    var StEnrollment = function(_super) {
        __extends(StEnrollment, _super);
        function StEnrollment(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Enrollment";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.preventFormSubmit();
                });
            };
            _this.classConfig = classConfig;
            return _this;
        }
        StEnrollment.prototype.preventFormSubmit = function(forms) {
            forms = forms ? forms : document.querySelectorAll(this.classConfig.selectorEnrollmentForm);
            if (forms.length > 0) {
                forms.forEach(function(form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                    });
                });
            }
        };
        return StEnrollment;
    }(st_module_21.StModule);
    exports.StEnrollment = StEnrollment;
});

define("core/shopify-app/st-modules/_general-methods/form/cart-manipulation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_22) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCartManipulation = void 0;
    var StCartManipulation = function(_super) {
        __extends(StCartManipulation, _super);
        function StCartManipulation() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CartManipulation";
            return _this;
        }
        return StCartManipulation;
    }(st_module_22.StModule);
    exports.StCartManipulation = StCartManipulation;
});

define("core/shopify-app/st-modules/_general-methods/form/loader", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_23) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StLoader = void 0;
    var StLoader = function(_super) {
        __extends(StLoader, _super);
        function StLoader() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Loader";
            _this.init = function() {};
            _this.on = function(triggerBtn) {
                if (!!triggerBtn && !triggerBtn.classList.contains("st_loader-active")) {
                    triggerBtn.classList.add("st_loader-active");
                }
            };
            _this.off = function(triggerBtn) {
                if (!!triggerBtn && triggerBtn.classList.contains("st_loader-active")) {
                    triggerBtn.classList.remove("st_loader-active");
                }
            };
            return _this;
        }
        return StLoader;
    }(st_module_23.StModule);
    exports.StLoader = StLoader;
});

define("core/shopify-app/st-modules/_general-methods/button/button-actions", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_24) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StButtonActions = exports.EButtonAction = void 0;
    var EButtonAction;
    (function(EButtonAction) {
        EButtonAction["enable"] = "enable";
        EButtonAction["disable"] = "disable";
        EButtonAction["toggleState"] = "toggleState";
        EButtonAction["prevent"] = "prevent";
        EButtonAction["allow"] = "allow";
        EButtonAction["addLoader"] = "addLoader";
        EButtonAction["removeLoader"] = "removeLoader";
        EButtonAction["toggleLoader"] = "toggleLoader";
    })(EButtonAction = exports.EButtonAction || (exports.EButtonAction = {}));
    var StButtonActions = function(_super) {
        __extends(StButtonActions, _super);
        function StButtonActions() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ButtonActions";
            _this.applyToMultiple = function(buttons, action) {
                buttons.forEach(function(button) {
                    _this[action](button);
                });
            };
            _this.enable = function(button) {
                if (!!button) {
                    button.removeAttribute("disabled");
                    button.classList.remove("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.disable = function(button) {
                if (!!button) {
                    button.setAttribute("disabled", "");
                    button.classList.add("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.addLoader = function(button) {
                if (!!button) {
                    button.classList.add("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.removeLoader = function(button) {
                if (!!button) {
                    button.classList.remove("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.toggleState = function(button) {
                if (!!button) {
                    if (button.classList.contains("st-disabled")) {
                        _this.enable(button);
                    } else {
                        _this.disable(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.toggleLoader = function(button) {
                if (!!button) {
                    if (button.classList.contains("st-loading")) {
                        _this.removeLoader(button);
                    } else {
                        _this.addLoader(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.prevent = function(button) {
                if (!!button) {
                    _this.disable(button);
                    _this.addLoader(button);
                    button.classList.add("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.allow = function(button) {
                if (!!button) {
                    _this.enable(button);
                    _this.removeLoader(button);
                    button.classList.remove("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.isBlocked = function(button) {
                return button.classList.contains("st-blocked");
            };
            _this.isLoading = function(button) {
                return button.classList.contains("st-loading");
            };
            _this.isDisabled = function(button) {
                return button.classList.contains("st-disabled") || button.classList.contains("st-disabled");
            };
            return _this;
        }
        return StButtonActions;
    }(st_module_24.StModule);
    exports.StButtonActions = StButtonActions;
});

define("core/shopify-app/st-modules/_general-methods/notification", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_25) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StNotification = exports.ENotificationType = void 0;
    var ENotificationType;
    (function(ENotificationType) {
        ENotificationType["success"] = "success";
        ENotificationType["error"] = "error";
        ENotificationType["info"] = "info";
    })(ENotificationType = exports.ENotificationType || (exports.ENotificationType = {}));
    var StNotification = function(_super) {
        __extends(StNotification, _super);
        function StNotification() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Notification";
            _this.createNotification = function() {
                var element = document.createElement("div");
                element.setAttribute("class", "st_notification-wrapper");
                element.setAttribute("id", "st_notification");
                var trigger = document.createElement("button");
                trigger.setAttribute("type", "button");
                trigger.dataset.close = "notification";
                trigger.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 40 40"><path d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z" /></svg>';
                element.appendChild(trigger);
                var title = document.createElement("div");
                title.setAttribute("class", "st_notification-title");
                element.appendChild(title);
                var desc = document.createElement("div");
                desc.setAttribute("class", "st_notification-description");
                element.appendChild(desc);
                return element;
            };
            _this.assembleNotification = function(type, title, description) {
                if (title === void 0) {
                    title = "";
                }
                if (description === void 0) {
                    description = "";
                }
                var typeClass = "";
                var notification = _this.createNotification();
                if (typeof description === "string") {
                    description = [ description ];
                }
                switch (type) {
                  case "success":
                    typeClass = "st_success";
                    break;

                  case "error":
                    typeClass = "st_error";
                    break;

                  case "info":
                    typeClass = "st_info";
                    break;
                }
                notification.classList.add(typeClass);
                var t = notification.querySelector(".st_notification-title");
                t.innerHTML = title;
                var d = notification.querySelector(".st_notification-description");
                var message = "";
                for (var i = 0; i < description.length; i++) {
                    if (i !== 0) {
                        message += "<hr>";
                    }
                    message += description[i];
                }
                d.innerHTML = message;
                return notification;
            };
            _this.showNotification = function(type, title, description, duration, preventDisappear) {
                if (type === void 0) {
                    type = ENotificationType.error;
                }
                if (title === void 0) {
                    title = "";
                }
                if (description === void 0) {
                    description = "";
                }
                if (duration === void 0) {
                    duration = 5e3;
                }
                if (preventDisappear === void 0) {
                    preventDisappear = false;
                }
                var notif = document.getElementById("st_notification");
                if (notif !== null) {
                    notif.remove();
                }
                var notification = _this.assembleNotification(type, title, description);
                var button = notification.querySelectorAll('button[data-close="notification"]')[0];
                button.addEventListener("click", function(e) {
                    var el = this.closest(".st_notification-wrapper");
                    body.removeChild(el);
                });
                var body = document.getElementsByTagName("body")[0];
                body.appendChild(notification);
                if (!preventDisappear) {
                    clearTimeout(_this.globalShowTimeout);
                    _this.globalShowTimeout = setTimeout(function() {
                        if (notification && notification.parentNode) {
                            notification.parentNode.removeChild(notification);
                        }
                    }, duration);
                }
            };
            return _this;
        }
        return StNotification;
    }(st_module_25.StModule);
    exports.StNotification = StNotification;
});

define("core/connector-app/_shared/models/enrollment/enrollment-submit/enrollment.submit.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/page/enrollment-submit", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_26, notification_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentActions = void 0;
    var StEnrollmentActions = function(_super) {
        __extends(StEnrollmentActions, _super);
        function StEnrollmentActions(classConfig, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentActions";
            _this_1.submit = function(dataToSubmit) {
                var _this = _this_1;
                console.log(dataToSubmit);
                _this_1.ajax.send({
                    endpoint: _this.endpoint["enrollment"]["submit"],
                    method: "post",
                    contentType: "json",
                    data: dataToSubmit,
                    callback: function(response) {
                        try {
                            var submitResponse = JSON.parse(response.response);
                            if (response.status === 200) {
                                if (submitResponse.data.checkoutUrl && submitResponse.data.checkoutUrl !== "") {
                                    console.log(submitResponse.data.checkoutUrl);
                                    window.location.href = submitResponse.data.checkoutUrl;
                                } else {
                                    window.location.href = window.typagehandle;
                                }
                            } else {
                                _this.notification.showNotification(notification_1.ENotificationType.error, "An Error Occurred", submitResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_1.ENotificationType.error, "An Error Occurred", error);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            return _this_1;
        }
        return StEnrollmentActions;
    }(st_module_26.StModule);
    exports.StEnrollmentActions = StEnrollmentActions;
});

define("core/connector-app/_shared/models/enrollment/enrollment-validation/enrollment.validation.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/enrollment/enrollment-validation/enrollment.validation.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-models", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/page/enrollment-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_27) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentPage = void 0;
    var StEnrollmentPage = function(_super) {
        __extends(StEnrollmentPage, _super);
        function StEnrollmentPage(classConfig, generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentPage";
            _this.maxPage = 0;
            _this.currentIndex = 0;
            _this.setMaxPage = function(maxPage) {
                _this.maxPage = maxPage;
            };
            _this.getMaxPage = function() {
                return _this.maxPage;
            };
            _this.setCurrentIndex = function(index) {
                _this.currentIndex = index;
            };
            _this.getCurrentIndex = function() {
                return _this.currentIndex;
            };
            _this.getCurrentPage = function() {
                return _this.getPageByIndex(_this.currentIndex);
            };
            _this.setupPageIndex = function(pages) {
                pages.forEach(function(page, ind) {
                    page.setAttribute("data-page-index", "" + ind);
                });
            };
            _this.getPageByIndex = function(pageIndex) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPage);
                return pages[pageIndex];
            };
            _this.openPage = function(pageIndex) {
                if (pageIndex === void 0) {
                    pageIndex = 0;
                }
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var alreadyOpen = wrp.querySelector(_this.classConfig.selectorEnrollmentPage + _this.classConfig.selectorEnrollmentPageShow);
                var enrollmentPages = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPage);
                var navHolder = wrp.querySelector(_this.classConfig.selectorEnrollmentNavHolder);
                var enrollmentNavElements = navHolder.querySelectorAll(_this.classConfig.selectorEnrollmentNavHolderSingle);
                var prevButtons = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPrev);
                if (!!alreadyOpen) {
                    alreadyOpen.classList.remove(_this.classConfig.classNameElementShow);
                }
                if (enrollmentPages.length > 0) {
                    enrollmentPages[pageIndex].classList.add(_this.classConfig.classNameElementShow);
                } else {
                    console.error("Invalid page index supplied to enrollment openPage method!");
                }
                enrollmentNavElements.forEach(function(navElement, index) {
                    navElement.classList.remove("active");
                    navElement.classList.remove("current");
                    if (index < pageIndex) {
                        navElement.classList.add("active");
                    } else if (index === pageIndex) {
                        navElement.classList.add("current");
                    }
                });
                _this.setCurrentIndex(pageIndex);
                _this.changeButtonText();
                _this.prevButtonVisibility(prevButtons, pageIndex);
                _this.generalMethods.scrollTo(_this.getCurrentPage(), 500);
            };
            _this.changeButtonText = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var selectorEnrollmentNext = wrp.querySelector(_this.classConfig.selectorEnrollmentNext);
                selectorEnrollmentNext.querySelector("span").innerHTML = _this.currentIndex === _this.maxPage - 1 ? _this.classConfig.textSubmit : _this.classConfig.textNext;
            };
            _this.prevButtonVisibility = function(prevButtons, pageIndex) {
                if (pageIndex === 0) {
                    prevButtons.forEach(function(button) {
                        button.classList.add("st_hidden");
                    });
                } else {
                    prevButtons.forEach(function(button) {
                        button.classList.remove("st_hidden");
                    });
                }
            };
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StEnrollmentPage;
    }(st_module_27.StModule);
    exports.StEnrollmentPage = StEnrollmentPage;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-validation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_28, notification_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentValidation = void 0;
    var StEnrollmentValidation = function(_super) {
        __extends(StEnrollmentValidation, _super);
        function StEnrollmentValidation(classConfig, notification, enrollmentPage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentValidate";
            _this_1.validationMethods = {};
            _this_1.setupValidation = function(validationClasses) {
                validationClasses.forEach(function(validationClass) {
                    var methods = validationClass.setupValidationMethods();
                    if (!!methods) {
                        _this_1.validationMethods = __assign(__assign({}, _this_1.validationMethods), methods);
                    }
                });
            };
            _this_1.getValidation = function() {
                return __assign({}, _this_1.validationMethods);
            };
            _this_1.markInvalid = function(page, inputName) {
                page.querySelectorAll('[data-validation-visual="'.concat(inputName, '"]')).forEach(function(validationVisual) {
                    validationVisual.classList.add(_this_1.classConfig.classNameInputInvalid);
                });
            };
            _this_1.clearInvalid = function(page, specificElement) {
                if (!!specificElement) {
                    specificElement.classList.remove(_this_1.classConfig.classNameInputInvalid);
                } else {
                    page.querySelectorAll(_this_1.classConfig.selectorInputInvalid).forEach(function(element) {
                        element.classList.remove(_this_1.classConfig.classNameInputInvalid);
                    });
                }
            };
            _this_1.serverValidate = function(dataToValidate, validCB, invalidCB) {
                if (validCB === void 0) {
                    validCB = function() {};
                }
                if (invalidCB === void 0) {
                    invalidCB = function() {};
                }
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this.endpoint["enrollment"]["validate-data"],
                    method: "post",
                    contentType: "json",
                    data: dataToValidate,
                    callback: function(request) {
                        try {
                            var data = JSON.parse(request.response);
                            if (request.status === 200) {
                                validCB(request, data);
                            } else {
                                invalidCB({
                                    status: request.status,
                                    message: data.message
                                });
                                _this.notification.showNotification(notification_2.ENotificationType.error, "Validation Error", data.message);
                            }
                        } catch (error) {
                            invalidCB({
                                status: 500,
                                message: error.message
                            });
                            console.error(error);
                            _this.notification.showNotification(notification_2.ENotificationType.error, "Validation Error", error);
                        }
                    }
                });
            };
            _this_1.basicValidate = function(pageIndex) {
                var page, forms;
                if (typeof pageIndex !== "undefined" && pageIndex !== -1) {
                    page = _this_1.enrollmentPage.getPageByIndex(pageIndex);
                    forms = page.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                } else {
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    forms = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                }
                for (var i = 0; i < forms.length; i++) {
                    var form = forms[i];
                    var sectionName = form.getAttribute("data-name");
                    var validation = _this_1.getValidation();
                    if (validation[sectionName]) {
                        var basicValidationParams = validation[sectionName].basic();
                        for (var j = 0; j < basicValidationParams.length; j++) {
                            var validationParam = basicValidationParams[j];
                            var input = form.querySelector('[name="'.concat(validationParam, '"]'));
                            if (!!input) {
                                if (typeof input.value === "undefined" || input.value === "") {
                                    return false;
                                }
                            } else {
                                console.warn('Input with name: "'.concat(validationParam, "\" was added to basic validation but doesn't exist in DOM. Skipping this field for validation."));
                            }
                        }
                    }
                }
                return true;
            };
            _this_1.basicValidationDelay = 200;
            _this_1.setupBasicValidationEvents = function(inputSelector, afterValidation) {
                var _this = _this_1;
                afterValidation(_this.runBasicValidation());
                var eventListenerFn = function() {
                    clearTimeout(_this.basicValidationTimeout);
                    _this.basicValidationTimeout = setTimeout(function() {
                        afterValidation(_this.runBasicValidation());
                    }, _this.basicValidationDelay);
                };
                inputSelector.addEventListener("input", eventListenerFn);
                inputSelector.addEventListener("change", eventListenerFn);
                inputSelector.addEventListener("paste", eventListenerFn);
            };
            _this_1.runBasicValidation = function() {
                var pageIndex = _this_1.enrollmentPage.getCurrentIndex();
                return _this_1.basicValidate(pageIndex);
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            _this_1.enrollmentPage = enrollmentPage;
            return _this_1;
        }
        return StEnrollmentValidation;
    }(st_module_28.StModule);
    exports.StEnrollmentValidation = StEnrollmentValidation;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_29) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionBase = void 0;
    var StEnrollmentSectionBase = function(_super) {
        __extends(StEnrollmentSectionBase, _super);
        function StEnrollmentSectionBase(args) {
            var _this = _super.call(this, args) || this;
            _this.setupValidationMethods = function() {
                var methods = {};
                methods[_this.validationName] = {
                    site: _this.validateOnSite,
                    server: _this.validateOnServer,
                    basic: _this.addToBasicValidation
                };
                return methods;
            };
            _this.addToBasicValidation = function() {
                return [];
            };
            _this.validateOnServer = function() {
                return [];
            };
            _this.validateOnSite = function() {
                return [];
            };
            return _this;
        }
        StEnrollmentSectionBase.prototype.initFields = function() {};
        StEnrollmentSectionBase.prototype.selectFields = function() {
            return [];
        };
        return StEnrollmentSectionBase;
    }(st_module_29.StModule);
    exports.StEnrollmentSectionBase = StEnrollmentSectionBase;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-privacy/enrollment-section-review-privacy", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionPrivacy = void 0;
    var StEnrollmentSectionPrivacy = function(_super) {
        __extends(StEnrollmentSectionPrivacy, _super);
        function StEnrollmentSectionPrivacy(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentSectionPrivacy";
            _this.validationName = "privacy";
            _this.validateOnSite = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var output = [];
                if (!!wrp) {
                    var inputs = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentTnCField);
                    inputs.forEach(function(input) {
                        var fieldName = input.getAttribute("name");
                        var isChecked = input.checked === true;
                        var isRequired = !!input.getAttribute("required");
                        var isValid = isChecked && isRequired || !isRequired;
                        output[fieldName] = {
                            isValid: isValid,
                            message: !isValid ? "You must accept terms and conditions to continue!" : ""
                        };
                    });
                }
                return output;
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentSectionPrivacy;
    }(enrollment_section_validation_base_1.StEnrollmentSectionBase);
    exports.StEnrollmentSectionPrivacy = StEnrollmentSectionPrivacy;
});

define("core/shopify-app/st-modules/enrollment/blocks/account-details/enrollment-section-account-details", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionAccountDetails = void 0;
    var StEnrollmentSectionAccountDetails = function(_super) {
        __extends(StEnrollmentSectionAccountDetails, _super);
        function StEnrollmentSectionAccountDetails() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountDetails";
            _this.validationName = "account-details";
            _this.addToBasicValidation = function() {
                return [ "firstName", "lastName", "phoneNumber", "dateOfBirth" ];
            };
            _this.validateOnServer = function() {
                return [ "firstName", "lastName", "phoneNumber", "dateOfBirth" ];
            };
            return _this;
        }
        return StEnrollmentSectionAccountDetails;
    }(enrollment_section_validation_base_2.StEnrollmentSectionBase);
    exports.StEnrollmentSectionAccountDetails = StEnrollmentSectionAccountDetails;
});

define("core/shopify-app/st-modules/enrollment/blocks/business-info/enrollment-section-business-details", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionBusinessDetails = void 0;
    var StEnrollmentSectionBusinessDetails = function(_super) {
        __extends(StEnrollmentSectionBusinessDetails, _super);
        function StEnrollmentSectionBusinessDetails() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentBusinessDetails";
            _this.validationName = "business-details";
            _this.addToBasicValidation = function() {
                return [ "SSN", "ref" ];
            };
            _this.validateOnServer = function() {
                return [ "SSN", "ref" ];
            };
            return _this;
        }
        return StEnrollmentSectionBusinessDetails;
    }(enrollment_section_validation_base_3.StEnrollmentSectionBase);
    exports.StEnrollmentSectionBusinessDetails = StEnrollmentSectionBusinessDetails;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-validation-setup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_30) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentValidationSetup = void 0;
    var StEnrollmentValidationSetup = function(_super) {
        __extends(StEnrollmentValidationSetup, _super);
        function StEnrollmentValidationSetup(enrollmentValidation, sectionPrivacy, sectionAccountDetails, sectionBusinessDetails) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentValidationSetup";
            _this.setupValidation = function() {
                _this.enrollmentValidation.setupValidation([ _this.sectionPrivacy, _this.sectionAccountDetails, _this.sectionBusinessDetails ]);
            };
            _this.enrollmentValidation = enrollmentValidation;
            _this.sectionPrivacy = sectionPrivacy;
            _this.sectionAccountDetails = sectionAccountDetails;
            _this.sectionBusinessDetails = sectionBusinessDetails;
            return _this;
        }
        return StEnrollmentValidationSetup;
    }(st_module_30.StModule);
    exports.StEnrollmentValidationSetup = StEnrollmentValidationSetup;
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-store", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_31) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentStore = void 0;
    var StEnrollmentStore = function(_super) {
        __extends(StEnrollmentStore, _super);
        function StEnrollmentStore(classConfig, cartHandler) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentStore";
            _this.dataStore = {
                shopifyId: undefined
            };
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                    var shopifyIdHolder = wrp.querySelector('[name="shopifyId"]');
                    var shopifyId = parseInt(shopifyIdHolder.value);
                    _this.saveData({
                        shopifyId: shopifyId
                    });
                });
            };
            _this.saveData = function(dataToSave) {
                _this.dataStore = __assign(__assign({}, _this.dataStore), dataToSave);
                _this.updateCart({
                    attributes: __assign({}, _this.dataStore)
                }, function(cart) {
                    console.log(cart);
                });
            };
            _this.loadData = function() {
                return __assign({}, _this.dataStore);
            };
            _this.updateCart = function(params, callback) {
                _this.ajax.send({
                    endpoint: _this.cartHandler.shopifyCartApiEndpoints["update-cart"],
                    method: "POST",
                    contentType: "json",
                    data: params,
                    callback: function(request) {
                        callback(JSON.parse(request.response));
                    }
                });
            };
            _this.classConfig = classConfig;
            _this.cartHandler = cartHandler;
            return _this;
        }
        return StEnrollmentStore;
    }(st_module_31.StModule);
    exports.StEnrollmentStore = StEnrollmentStore;
});

define("core/shopify-app/st-modules/_general-methods/currency", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_32) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCurrency = exports.EAmountType = exports.ECurrencyFormatType = void 0;
    var ECurrencyFormatType;
    (function(ECurrencyFormatType) {
        ECurrencyFormatType["withCurrency"] = "withCurrency";
        ECurrencyFormatType["withoutCurrency"] = "withoutCurrency";
    })(ECurrencyFormatType = exports.ECurrencyFormatType || (exports.ECurrencyFormatType = {}));
    var EAmountType;
    (function(EAmountType) {
        EAmountType["amount"] = "amount";
        EAmountType["amount_no_decimals"] = "amount_no_decimals";
        EAmountType["unknown"] = "unknown";
    })(EAmountType = exports.EAmountType || (exports.EAmountType = {}));
    var StCurrency = function(_super) {
        __extends(StCurrency, _super);
        function StCurrency() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Currency";
            _this.currencyFormat = window.stCurrencyFormat;
            _this.applyFormat = function(amount, formatType) {
                if (formatType === void 0) {
                    formatType = ECurrencyFormatType.withCurrency;
                }
                var format = _this.currencyFormat[formatType];
                var amountType = _this.determineAmountType(format);
                if (amountType !== EAmountType.unknown) {
                    return format.replace("{{" + amountType + "}}", "" + amount.toFixed(2));
                } else {
                    console.error("Unrecognized price format. Returning price without currency formatting.");
                    return "" + amount;
                }
            };
            _this.determineAmountType = function(format) {
                if (format.indexOf("{{amount}}") > -1) {
                    return EAmountType.amount;
                } else if (format.indexOf("{{amount_no_decimals}}") > -1) {
                    return EAmountType.amount_no_decimals;
                } else {
                    return EAmountType.unknown;
                }
            };
            return _this;
        }
        StCurrency.prototype.commaFormattedPrice = function(amount, decimalDelimiter, thousandsDelimiter) {
            if (decimalDelimiter === void 0) {
                decimalDelimiter = ".";
            }
            if (thousandsDelimiter === void 0) {
                thousandsDelimiter = ",";
            }
            var amountComponents = String(amount).split(".", 2);
            var wholeNumber = parseInt(amountComponents[0]);
            if (isNaN(wholeNumber)) {
                return "";
            }
            var decimal = amountComponents[1];
            var minus = wholeNumber < 0 ? "-" : "";
            wholeNumber = Math.abs(wholeNumber);
            var wholeString = String(wholeNumber);
            var amountSegmented = [];
            while (wholeString.length > 3) {
                amountSegmented.unshift(wholeString.substr(wholeString.length - 3));
                wholeString = wholeString.substr(0, wholeString.length - 3);
            }
            if (wholeString.length > 0) {
                amountSegmented.unshift(wholeString);
            }
            wholeString = amountSegmented.join(thousandsDelimiter);
            decimal = decimal.length < 1 ? "" : decimalDelimiter + decimal;
            return minus + wholeString + decimal;
        };
        return StCurrency;
    }(st_module_32.StModule);
    exports.StCurrency = StCurrency;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_33, currency_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentReviewCart = void 0;
    var StEnrollmentReviewCart = function(_super) {
        __extends(StEnrollmentReviewCart, _super);
        function StEnrollmentReviewCart(classConfig, store, currency) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentReviewCart";
            _this.injectCart = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var cartContent = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartContentWrapper);
                var cartWrapper = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartWrapper);
                var storeData = _this.store.loadData();
                var reqKits = storeData.requiredKits ? storeData.requiredKits : [];
                var optKits = storeData.optionalKits ? storeData.optionalKits : [];
                var selectedProducts = __spreadArray(__spreadArray([], reqKits, true), optKits, true);
                if (selectedProducts.length > 0) {
                    !!cartWrapper && cartWrapper.classList.remove("st_hidden");
                    !!cartContent && cartContent.classList.remove("st_hidden");
                    !!cartContent && cartContent.replaceChildren();
                    var productPrices_1 = [];
                    selectedProducts.forEach(function(selectedProduct) {
                        var imageEl = wrp.querySelector('[data-image-holder="'.concat(selectedProduct.variantId, '"]'));
                        var titleEl = wrp.querySelector('[data-title-holder="'.concat(selectedProduct.variantId, '"]'));
                        var descriptionEl = wrp.querySelector('[data-description-holder="'.concat(selectedProduct.variantId, '"]'));
                        var priceEl = wrp.querySelector('[data-price-holder="'.concat(selectedProduct.variantId, '"]'));
                        var recurringEl = wrp.querySelector('[data-recurring-holder="'.concat(selectedProduct.variantId, '"]'));
                        var sellingPlanEl = wrp.querySelector('[data-selling-plan-holder="'.concat(selectedProduct.variantId, '"]'));
                        var imageURL = !!imageEl ? imageEl.src : "";
                        var title = !!titleEl ? titleEl.innerHTML : "";
                        var description = !!descriptionEl ? descriptionEl.innerHTML : "";
                        var price = !!priceEl ? priceEl.innerHTML : "";
                        var priceRaw = !!priceEl ? parseInt(priceEl.getAttribute("data-price-raw")) : 0;
                        var recurring = !!recurringEl ? recurringEl.value === "true" : false;
                        var sellingPlan = !!sellingPlanEl ? sellingPlanEl.value : "One Time Payment";
                        var printableReviewProduct = {
                            variantId: selectedProduct.variantId,
                            image: imageURL,
                            title: title,
                            description: description,
                            price: price,
                            recurring: recurring,
                            sellingPlan: sellingPlan
                        };
                        productPrices_1.push(priceRaw);
                        if (!!cartContent) {
                            var cartMember = _this.generateCartMember(printableReviewProduct);
                            cartContent.appendChild(cartMember);
                        }
                    });
                    var cartTotalEl = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartTotal);
                    if (!!cartTotalEl) {
                        var total = productPrices_1.reduce(function(accumulator, value) {
                            return accumulator + parseInt("".concat(value));
                        });
                        cartTotalEl.innerHTML = _this.currency.applyFormat(total / 100, currency_1.ECurrencyFormatType.withCurrency);
                    }
                } else {
                    !!cartWrapper && cartWrapper.classList.add("st_hidden");
                    !!cartContent && cartContent.classList.add("st_hidden");
                }
            };
            _this.generateCartMembers = function(products) {
                var output = [];
                products.forEach(function(productInfo) {
                    var cartMember = _this.generateCartMember(productInfo);
                    output.push(cartMember);
                });
                return output;
            };
            _this.generateCartMember = function(productInfo) {
                var wrap = document.createElement("div");
                wrap.classList.add("st_enrollment-checkout-row");
                wrap.classList.add("st_flex");
                wrap.classList.add("st_align");
                var imageWrap = document.createElement("div");
                imageWrap.classList.add("st_enrollment-image--wrapper");
                var image = document.createElement("img");
                image.src = productInfo.image;
                image.alt = productInfo.title;
                var listWrapper = document.createElement("div");
                listWrapper.classList.add("st_enrollment-list--wrapper");
                var title = document.createElement("div");
                title.classList.add("st_title");
                title.innerHTML = productInfo.title;
                var description = document.createElement("div");
                description.innerHTML = productInfo.description;
                var priceWrapper = document.createElement("div");
                priceWrapper.classList.add("st_enrollment-price--wrapper");
                var recurring = document.createElement("div");
                recurring.classList.add("st_subscription");
                recurring.classList.add("st_subscription-review");
                recurring.innerText = productInfo.sellingPlan;
                var price = document.createElement("div");
                price.classList.add("st_price");
                price.innerHTML = productInfo.price;
                imageWrap.appendChild(image);
                listWrapper.appendChild(title);
                listWrapper.appendChild(description);
                priceWrapper.appendChild(recurring);
                priceWrapper.appendChild(price);
                wrap.appendChild(imageWrap);
                wrap.appendChild(listWrapper);
                wrap.appendChild(priceWrapper);
                return wrap;
            };
            _this.classConfig = classConfig;
            _this.store = store;
            _this.currency = currency;
            return _this;
        }
        return StEnrollmentReviewCart;
    }(st_module_33.StModule);
    exports.StEnrollmentReviewCart = StEnrollmentReviewCart;
});

define("core/shopify-app/st-modules/enrollment/blocks/optional-kits/enrollment-section-optional-kits", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_34) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentOptionalKits = void 0;
    var StEnrollmentOptionalKits = function(_super) {
        __extends(StEnrollmentOptionalKits, _super);
        function StEnrollmentOptionalKits(classConfig, store, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentOptionalBundle";
            _this_1.setupButtons = function(buttons) {
                var _this = _this_1;
                buttons.forEach(function(button) {
                    button.addEventListener("click", function(e) {
                        e.preventDefault();
                        var variantId = this.getAttribute("data-variant-id");
                        var quantity = parseInt(this.getAttribute("data-quantity"));
                        var sellingPlan = this.getAttribute("data-selling-plan");
                        var selected = this.getAttribute("data-selected") === "true";
                        selected = !selected;
                        var bundleObject = {
                            variantId: "" + variantId,
                            quantity: quantity
                        };
                        if (sellingPlan && sellingPlan !== "") {
                            bundleObject.selling_plan = sellingPlan;
                        }
                        var span = this.querySelector(".st_text");
                        var icon = this.querySelector(".st_check-icon");
                        if (selected) {
                            icon.classList.remove("st_hidden");
                            span.classList.add("st_hidden");
                        } else {
                            icon.classList.add("st_hidden");
                            span.classList.remove("st_hidden");
                        }
                        _this.toggleBundleSelect(selected, bundleObject);
                        this.setAttribute("data-selected", selected);
                    });
                });
            };
            _this_1.toggleBundleSelect = function(makeSelected, bundleObject) {
                try {
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    var optionalBundlesInput = wrp.querySelector(_this_1.classConfig.selectorEnrollmentOptionalKitsInput);
                    var selectedBundles = JSON.parse(optionalBundlesInput.value);
                    if (makeSelected) {
                        var itemAlreadySelected = false;
                        for (var i = 0; i < selectedBundles.length; i++) {
                            if ("" + selectedBundles[i].variantId === "" + bundleObject.variantId) {
                                itemAlreadySelected = true;
                                break;
                            }
                        }
                        if (!itemAlreadySelected) {
                            selectedBundles.push(bundleObject);
                        }
                    } else {
                        var formattedBundles = [];
                        for (var i = 0; i < selectedBundles.length; i++) {
                            if ("" + selectedBundles[i].variantId !== "" + bundleObject.variantId) {
                                formattedBundles.push(selectedBundles[i]);
                            }
                        }
                        selectedBundles = formattedBundles;
                    }
                    optionalBundlesInput.value = JSON.stringify(selectedBundles);
                    optionalBundlesInput.setAttribute("value", optionalBundlesInput.value);
                    _this_1.store.saveData({
                        optionalKits: selectedBundles
                    });
                    _this_1.reviewCart.injectCart();
                } catch (e) {
                    console.error("An error occurred while processing toggleBundleSelect. Error message: " + e.message);
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentOptionalKits;
    }(st_module_34.StModule);
    exports.StEnrollmentOptionalKits = StEnrollmentOptionalKits;
});

define("core/shopify-app/st-modules/enrollment/blocks/required-kits/enrollment-section-required-kits", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_35) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentRequiredKits = void 0;
    var StEnrollmentRequiredKits = function(_super) {
        __extends(StEnrollmentRequiredKits, _super);
        function StEnrollmentRequiredKits(classConfig, store, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentRequiredBundle";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this.store.saveData({
                        requiredKits: _this.getRequiredKits()
                    });
                    _this_1.reviewCart.injectCart();
                    _this_1.onRequiredKitVariantSelect();
                });
            };
            _this_1.getRequiredKits = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var requiredKitsHolder = wrp.querySelector('[name="requiredKits"]');
                return requiredKitsHolder ? JSON.parse(decodeURIComponent(requiredKitsHolder.value)) : [];
            };
            _this_1.format = function(sourceData) {
                var formattedData = [];
                sourceData.forEach(function(item) {
                    if (typeof item.variantId !== "undefined") {
                        var formattedItem = {
                            variantId: item.variantId.toString(),
                            quantity: item.quantity
                        };
                        if (item.selling_plan && item.selling_plan !== "") {
                            formattedItem.selling_plan = item.selling_plan + "";
                        }
                        formattedData.push(formattedItem);
                    }
                });
                return formattedData;
            };
            _this_1.onRequiredKitVariantSelect = function() {
                var _this = _this_1;
                var requiredKitWrapperList = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentRequiredKitWrapper);
                if (!!requiredKitWrapperList) {
                    requiredKitWrapperList.forEach(function(requiredKitWrapper) {
                        var variantSelect = requiredKitWrapper.querySelector(_this_1.classConfig.selectorEnrollmentRequiredKitVariantSelect);
                        if (!!variantSelect) {
                            variantSelect.onchange = function() {
                                var variantValue = JSON.parse(decodeURI(variantSelect.value));
                                var optionValue = [];
                                optionValue.push(variantValue);
                                var variantHiddenWrapper = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsOptionsWrapper);
                                var requiredKitDescription = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsText);
                                var requiredKitImg = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsImg);
                                var variantTitleHeading = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitVariantHeading);
                                var variantTitle = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitSelectedVariantTitle);
                                var variantTitleHidden = variantHiddenWrapper.querySelector('input[data-title-holder="'.concat(variantValue.variantId, '"]'));
                                var variantPrice = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitVariantPrice);
                                var variantPriceHidden = variantHiddenWrapper.querySelector('input[data-price-holder="'.concat(variantValue.variantId, '"]'));
                                var variantPriceRawHidden = variantHiddenWrapper.querySelector('input[data-price-raw-holder="'.concat(variantValue.variantId, '"]'));
                                var hiddenVariantInput = document.querySelector(_this.classConfig.selectorEnrollmentHiddenRequiredKitInput);
                                if (!!requiredKitDescription) {
                                    requiredKitDescription.setAttribute("data-description-holder", variantValue.variantId);
                                }
                                if (!!requiredKitImg) {
                                    requiredKitImg.setAttribute("data-image-holder", variantValue.variantId);
                                }
                                if (!!variantTitleHeading) {
                                    variantTitleHeading.innerHTML = variantTitleHidden.value;
                                    variantTitleHeading.setAttribute("data-title-holder", variantValue.variantId);
                                }
                                if (!!variantTitle) {
                                    variantTitle.innerHTML = variantTitleHidden.value;
                                }
                                if (!!variantPrice) {
                                    variantPrice.innerHTML = variantPriceHidden.value;
                                    variantPrice.setAttribute("data-price-holder", variantValue.variantId);
                                    variantPrice.setAttribute("data-price-raw", variantPriceRawHidden.value);
                                }
                                if (!!hiddenVariantInput) {
                                    delete optionValue[optionValue.length - 1].price;
                                    hiddenVariantInput.value = encodeURI(JSON.stringify(optionValue));
                                    hiddenVariantInput.setAttribute("value", JSON.stringify(optionValue));
                                    _this.store.saveData({
                                        requiredKits: optionValue
                                    });
                                    _this_1.reviewCart.injectCart();
                                }
                            };
                        }
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentRequiredKits;
    }(st_module_35.StModule);
    exports.StEnrollmentRequiredKits = StEnrollmentRequiredKits;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_36) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentReview = void 0;
    var EFormatType;
    (function(EFormatType) {
        EFormatType["date"] = "date";
    })(EFormatType || (EFormatType = {}));
    var StEnrollmentReview = function(_super) {
        __extends(StEnrollmentReview, _super);
        function StEnrollmentReview(classConfig, store, generalMethods, enrollmentPage, currency, form, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentReview";
            _this_1.setupReview = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                if (_this_1.reviewBlockExists(wrp)) {
                    var holder = wrp.querySelector(_this_1.classConfig.selectorEnrollmentReviewParamHolder);
                    if (!!holder) {
                        _this_1.generateReviewParams(holder, _this_1.getParamInfo());
                    }
                    var paramSources = wrp.querySelectorAll("[data-review-param]");
                    _this_1.setupParamChangeEvents(paramSources);
                }
            };
            _this_1.reviewBlockExists = function(wrp) {
                var reviewSection = wrp.querySelector(_this_1.classConfig.selectorEnrollmentReviewWrapper);
                return !!reviewSection;
            };
            _this_1.getParamInfo = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var paramHolders = wrp.querySelectorAll("[data-review-param]");
                var params = [];
                var storedData = _this_1.store.loadData();
                paramHolders.forEach(function(paramHolder) {
                    var pageWrapper = _this_1.generalMethods.getClosestByClass(paramHolder, _this_1.classConfig.classNameEnrollmentPage);
                    var pageIndex = parseInt(pageWrapper.getAttribute("data-page-index"));
                    var inputName = paramHolder.getAttribute("name");
                    var formatName = paramHolder.getAttribute("data-format");
                    var param = {
                        name: paramHolder.getAttribute("data-review-param"),
                        inputName: inputName,
                        value: storedData[inputName] ? storedData[inputName] : "",
                        allowEdit: paramHolder.getAttribute("data-review-edit") !== "false",
                        pageIndex: pageIndex,
                        format: _this_1.getFormatByName(EFormatType[formatName])
                    };
                    params.push(param);
                });
                return params;
            };
            _this_1.getFormatByName = function(name) {
                if (name === EFormatType.date) {
                    return function(value) {
                        if (value && value !== "-") {
                            var dateComponents = value.split("-");
                            var days = dateComponents[2];
                            days = days.length === 1 ? "0".concat(days) : "".concat(days);
                            var months = dateComponents[1];
                            months = months.length === 1 ? "0".concat(months) : "".concat(months);
                            var years = dateComponents[0];
                            return "".concat(months, "/").concat(days, "/").concat(years);
                        } else {
                            return "";
                        }
                    };
                } else {
                    return function(value) {
                        return value;
                    };
                }
            };
            _this_1.generateReviewParams = function(holder, params) {
                var _this = _this_1;
                params.forEach(function(param, ind) {
                    var row = document.createElement("div");
                    row.classList.add("st_enrollment-business-info-row");
                    var col = document.createElement("div");
                    col.classList.add("st_info-column");
                    var colL = document.createElement("div");
                    colL.classList.add("st_col-left");
                    var colName = document.createElement("div");
                    colName.classList.add("st_name");
                    colName.innerText = param.name;
                    colL.appendChild(colName);
                    var value = typeof param.value !== "undefined" && param.value !== "" ? "" + param.value : "-";
                    var colValue = document.createElement("div");
                    colValue.classList.add("st_print-name");
                    if (param.inputName == "email") colValue.classList.add("st_email");
                    colValue.setAttribute("data-field-for", param.inputName);
                    colValue.innerText = param.format(value);
                    colL.appendChild(colValue);
                    col.appendChild(colL);
                    var colR = document.createElement("div");
                    colR.classList.add("st_col-right");
                    if (param.allowEdit) {
                        var editButton = document.createElement("button");
                        editButton.setAttribute("type", "button");
                        editButton.classList.add("st_enrollment-edit");
                        editButton.setAttribute("data-page-index", "" + param.pageIndex);
                        editButton.setAttribute("data-edit-for", param.inputName);
                        editButton.innerText = _this_1.classConfig.reviewEditText;
                        colR.appendChild(editButton);
                        editButton.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.edit(this.getAttribute("data-edit-for"), parseInt(this.getAttribute("data-page-index")));
                        });
                    }
                    col.appendChild(colR);
                    row.appendChild(col);
                    holder.appendChild(row);
                });
            };
            _this_1.setupParamChangeEvents = function(paramSources) {
                var _this = _this_1;
                paramSources.forEach(function(paramHolder) {
                    var fieldObj = _this.form.collectField(paramHolder);
                    var inputName = paramHolder.getAttribute("name");
                    var name = paramHolder.getAttribute("data-review-param");
                    var value = fieldObj[inputName];
                    _this.applyParamChange(name, inputName, value.toString());
                    paramHolder.addEventListener("keyup", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                    paramHolder.addEventListener("input", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                    paramHolder.addEventListener("change", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                });
            };
            _this_1.applyParamChange = function(name, inputName, value) {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var holder = wrp.querySelector('[data-review-param="'.concat(name, '"]'));
                var param = wrp.querySelector('[data-field-for="'.concat(inputName, '"]'));
                var formatName = holder.getAttribute("data-format");
                var format = _this_1.getFormatByName(EFormatType[formatName]);
                if (param) {
                    param.innerText = format(value.toString());
                } else {
                    console.error("Review template error. Couldn't find element to change parameter with name: ".concat(inputName, "."));
                }
            };
            _this_1.edit = function(holderName, pageIndex) {
                _this_1.enrollmentPage.openPage(pageIndex);
                var currentPage = _this_1.enrollmentPage.getCurrentPage();
                var holdersFirstVisual = currentPage.querySelector('[data-validation-visual="'.concat(holderName, '"]'));
                if (!!holdersFirstVisual) {
                    _this_1.generalMethods.scrollTo(holdersFirstVisual, 500);
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.generalMethods = generalMethods;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.currency = currency;
            _this_1.form = form;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentReview;
    }(st_module_36.StModule);
    exports.StEnrollmentReview = StEnrollmentReview;
});

define("core/shopify-app/st-modules/enrollment/page-header/nav/enrollment-nav", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/_general-methods/button/button-actions" ], function(require, exports, st_module_37, notification_3, button_actions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentNav = void 0;
    var StEnrollmentNav = function(_super) {
        __extends(StEnrollmentNav, _super);
        function StEnrollmentNav(classConfig, actions, optionalKits, requiredKits, store, form, buttonActions, enrollmentValidation, enrollmentValidationSetup, notification, enrollmentReview, enrollmentPage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentNav";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupNavPages();
                    _this_1.setupButtons();
                    _this_1.setupOptionalBundles();
                    _this_1.setupBasicValidation();
                });
            };
            _this_1.setupButtons = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                if (pages.length > 0) {
                    _this_1.enrollmentPage.setMaxPage(pages.length);
                    _this_1.enrollmentPage.setupPageIndex(pages);
                    _this_1.enrollmentReview.setupReview();
                    _this_1.openPage(_this_1.enrollmentPage.getCurrentIndex());
                    if (!!wrp) {
                        _this_1.bindEvents(wrp);
                    } else {
                        console.error("Enrollment wrapper does not exist! Cannot setup enrollment nav.");
                    }
                } else {
                    console.error("Enrollment doesn't have a page! Can't init enrollment!");
                }
            };
            _this_1.openPage = function(pageIndex) {
                _this_1.enrollmentPage.openPage(pageIndex);
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                if (pageIndex === 0) {
                    prevButtons.forEach(function(button) {
                        button.classList.add("st_hidden");
                    });
                } else {
                    prevButtons.forEach(function(button) {
                        button.classList.remove("st_hidden");
                    });
                }
            };
            _this_1.bindEvents = function(wrp) {
                var _this = _this_1;
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                nextButtons.forEach(function(nextButton) {
                    nextButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        if (!_this.buttonActions.isDisabled(this)) {
                            _this.nextOrSubmit();
                        }
                    });
                });
                prevButtons.forEach(function(prevButton) {
                    prevButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.prev();
                    });
                });
            };
            _this_1.setupOptionalBundles = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var optionalBundleTriggers = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentOptionalKitsTrigger);
                _this_1.optionalKits.setupButtons(optionalBundleTriggers);
            };
            _this_1.nextOrSubmit = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var enrollmentPages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                var currentPage = enrollmentPages[_this_1.enrollmentPage.getCurrentIndex()];
                var forms = currentPage.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                var shopifyIdHolder = wrp.querySelector('[name="shopifyId"]');
                var shopifyId = parseInt(shopifyIdHolder.value);
                var serverValidationParams = {
                    shopifyId: shopifyId
                };
                var onSiteValidationFunctions = [];
                var validation = _this_1.enrollmentValidation.getValidation();
                var dataToSave = {};
                _this_1.enrollmentValidation.clearInvalid(currentPage);
                forms.forEach(function(form) {
                    var sectionName = form.getAttribute("data-name");
                    if (!!sectionName && sectionName !== "") {
                        var formData_1 = _this_1.form.collectFormData(form);
                        var paramsToValidate_1 = {};
                        dataToSave = __assign(__assign({}, dataToSave), formData_1);
                        if (validation.hasOwnProperty(sectionName)) {
                            var backendParamNames = validation[sectionName].server();
                            backendParamNames.forEach(function(param) {
                                if (typeof paramsToValidate_1[param] !== "undefined") {
                                    console.error("Duplicate setup of param with name: ".concat(param));
                                }
                                paramsToValidate_1[param] = formData_1[param];
                            });
                            serverValidationParams = __assign(__assign({}, serverValidationParams), paramsToValidate_1);
                            onSiteValidationFunctions.push(validation[sectionName].site);
                        } else {
                            console.log('Enrollment block with name "'.concat(sectionName, '" does not have registered validation class. Skipping validation.'));
                        }
                    }
                });
                var joinedValidationResponse = {};
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.prevent);
                _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.prevent);
                if (Object.keys(serverValidationParams).length > 0) {
                    _this_1.enrollmentValidation.serverValidate(serverValidationParams, function(response, validation) {
                        joinedValidationResponse = _this_1.validateOnSite(__assign({}, validation.data), onSiteValidationFunctions);
                        _this_1.afterValidation(joinedValidationResponse, dataToSave, currentPage);
                    }, function(error) {
                        console.error("An error occurred with status: ".concat(error.status, ". Message: ").concat(error.message));
                        _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.allow);
                        _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.allow);
                    });
                } else {
                    joinedValidationResponse = _this_1.validateOnSite(joinedValidationResponse, onSiteValidationFunctions);
                    _this_1.afterValidation(joinedValidationResponse, dataToSave, currentPage);
                }
            };
            _this_1.validateOnSite = function(joinedValidationResponse, onSiteValidationFunctions) {
                if (onSiteValidationFunctions === void 0) {
                    onSiteValidationFunctions = [];
                }
                var output = joinedValidationResponse;
                onSiteValidationFunctions.forEach(function(paramValidationFunction) {
                    output = __assign(__assign({}, output), paramValidationFunction());
                });
                return output;
            };
            _this_1.afterValidation = function(validationResponse, dataToSave, page) {
                if (Object.keys(validationResponse).length > 0) {
                    var hasInvalid_1 = false;
                    var errorMessage_1 = [];
                    Object.keys(validationResponse).forEach(function(paramName) {
                        if (!validationResponse[paramName].isValid) {
                            _this_1.enrollmentValidation.markInvalid(page, paramName);
                            hasInvalid_1 = true;
                            errorMessage_1.push(validationResponse[paramName].message);
                        }
                    });
                    if (hasInvalid_1) {
                        _this_1.notification.showNotification(notification_3.ENotificationType.error, "Some fields are invalid!", errorMessage_1);
                        var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                        var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                        var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                        _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.allow);
                        _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.allow);
                    } else {
                        _this_1.store.saveData(dataToSave);
                        _this_1.next();
                    }
                } else {
                    _this_1.store.saveData(dataToSave);
                    _this_1.next();
                }
            };
            _this_1.setupBasicValidation = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var paramNames = [];
                var validation = _this_1.enrollmentValidation.getValidation();
                var allFormNames = Object.keys(validation);
                allFormNames.forEach(function(formName) {
                    if (validation[formName]) {
                        paramNames = paramNames.concat(validation[formName].basic());
                    }
                });
                for (var i = 0; i < paramNames.length; i++) {
                    var param = paramNames[i];
                    var input = wrp.querySelector('[name="'.concat(param, '"]'));
                    _this_1.enrollmentValidation.setupBasicValidationEvents(input, _this_1.afterBasicValidation);
                }
            };
            _this_1.afterBasicValidation = function(valid) {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                if (valid) {
                    nextButtons.forEach(function(nextButton) {
                        _this_1.buttonActions.enable(nextButton);
                    });
                } else {
                    nextButtons.forEach(function(nextButton) {
                        _this_1.buttonActions.disable(nextButton);
                    });
                }
            };
            _this_1.next = function() {
                var currentIndex = _this_1.enrollmentPage.getCurrentIndex();
                if (currentIndex + 1 < _this_1.enrollmentPage.getMaxPage()) {
                    _this_1.enrollmentPage.setCurrentIndex(currentIndex + 1);
                    _this_1.openPage(currentIndex + 1);
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                    var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                    _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.allow);
                    _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.allow);
                } else {
                    var data = _this_1.store.loadData();
                    var items = data.requiredKits ? _this_1.requiredKits.format(data.requiredKits) : [];
                    items = data.optionalKits ? items.concat(data.optionalKits) : items;
                    var submit = {
                        shopifyId: data.shopifyId,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        phoneNumber: data.phoneNumber,
                        ref: data.ref,
                        sponsorsWebAlias: data.sponsorsWebAlias,
                        dateOfBirth: data.dateOfBirth,
                        SSN: data.SSN,
                        items: items
                    };
                    _this_1.actions.submit(submit);
                }
            };
            _this_1.prev = function() {
                var currentIndex = _this_1.enrollmentPage.getCurrentIndex();
                if (currentIndex - 1 >= 0) {
                    _this_1.enrollmentPage.setCurrentIndex(currentIndex - 1);
                    _this_1.openPage(currentIndex - 1);
                }
            };
            _this_1.setupNavPages = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorEnrollmentNavHolder);
                if (!!navHolder) {
                    if (pages.length > 1) {
                        pages.forEach(function(page, pageIndex) {
                            var templateName = page.getAttribute("data-name");
                            var isActive = pageIndex === 0;
                            navHolder.appendChild(_this_1.navPageTemplate(pageIndex, templateName, isActive));
                        });
                    } else {
                        var navWrp = wrp.querySelector(_this_1.classConfig.selectorEnrollmentNavWrapper);
                        if (navWrp) {
                            navWrp.classList.add(_this_1.classConfig.classNameElementHide);
                        }
                    }
                } else {
                    console.error("Enrollment Nav holder not present! Navigation won't setup");
                }
            };
            _this_1.navPageTemplate = function(pageIndex, templateName, isActive) {
                if (templateName === void 0) {
                    templateName = "";
                }
                var templateNode;
                templateNode = document.createElement("div");
                templateNode.classList.add("st_header-enrollment-single-column");
                templateNode.classList.add(_this_1.classConfig.classNameEnrollmentNavHolderSingle);
                if (isActive) {
                    templateNode.classList.add("active");
                }
                var innerWrapper = document.createElement("div");
                innerWrapper.classList.add("st_flex");
                innerWrapper.classList.add("st_align");
                var button = document.createElement("button");
                button.classList.add("st_header-navigation-enrollment");
                button.classList.add(_this_1.classConfig.selectorEnrollmentNavButton);
                button.setAttribute("data-index", "".concat(pageIndex));
                var text = document.createElement("span");
                text.classList.add("st_header-text");
                text.innerHTML = templateName;
                var pageNumber = document.createElement("span");
                pageNumber.classList.add("st_number");
                pageNumber.innerHTML = "" + (pageIndex + 1);
                button.appendChild(pageNumber);
                innerWrapper.appendChild(button);
                innerWrapper.appendChild(text);
                templateNode.appendChild(innerWrapper);
                return templateNode;
            };
            _this_1.classConfig = classConfig;
            _this_1.actions = actions;
            _this_1.optionalKits = optionalKits;
            _this_1.requiredKits = requiredKits;
            _this_1.store = store;
            _this_1.form = form;
            _this_1.buttonActions = buttonActions;
            _this_1.enrollmentValidation = enrollmentValidation;
            _this_1.enrollmentValidationSetup = enrollmentValidationSetup;
            _this_1.notification = notification;
            _this_1.enrollmentReview = enrollmentReview;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.enrollmentValidationSetup.setupValidation();
            return _this_1;
        }
        return StEnrollmentNav;
    }(st_module_37.StModule);
    exports.StEnrollmentNav = StEnrollmentNav;
});

define("core/connector-app/_shared/models/search-sponsor/search.sponsor.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor-service", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_38) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorService = void 0;
    var StSearchSponsorService = function(_super) {
        __extends(StSearchSponsorService, _super);
        function StSearchSponsorService() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorService";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            _this.getSponsorByPersonalInfo = function(inputValue, handleGetSponsorInfo) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["searchSponsor"]["getSponsorByPersonalInfo"],
                        method: "post",
                        contentType: "json",
                        data: {
                            query: inputValue
                        },
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            _this.getSponsorInfo = function(sponsorIdOrAlias, handleGetSponsorInfo) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["searchSponsor"]["getSponsorInfo"],
                        method: "post",
                        contentType: "json",
                        data: {
                            query: sponsorIdOrAlias
                        },
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            return _this;
        }
        return StSearchSponsorService;
    }(st_module_38.StModule);
    exports.StSearchSponsorService = StSearchSponsorService;
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_39, _features_config_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsor = void 0;
    var SponsorRequestType;
    (function(SponsorRequestType) {
        SponsorRequestType[SponsorRequestType["GET_BY_ID_OR_ALIAS"] = 0] = "GET_BY_ID_OR_ALIAS";
        SponsorRequestType[SponsorRequestType["GET_BY_PERSONAL_INFORMATION"] = 1] = "GET_BY_PERSONAL_INFORMATION";
    })(SponsorRequestType || (SponsorRequestType = {}));
    var StSearchSponsor = function(_super) {
        __extends(StSearchSponsor, _super);
        function StSearchSponsor(generalMethods, objectFormatting, browserHistory, classConfig, cookies, cart, sponsorService) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsor";
            _this.endpointString = [ "getSponsorInfo", "getSponsorByPersonalInfo" ];
            _this.MIN_CHAR_SEARCH_REQUIREMENT = 2;
            _this.REQUEST_DELAY = 1e3;
            _this.inputValue = "";
            _this.cookieNameWebAlias = "ref";
            _this.cookieNameRepId = "repId";
            _this.cookieNameFirstName = "firstName";
            _this.cookieNameLastName = "lastName";
            _this.retryWebAliasFetch = true;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initSearchBoxFunctionality();
                    _this.initRadioButtons();
                    _this.windowClick();
                    _this.triggerVisibilityOfSection();
                    _this.cart.subscribeRenderCart(function(callback) {
                        _this.changeCartEvents();
                    });
                });
            };
            _this.loaderOn = function(triggerBtn) {
                var label = _this.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && !label.classList.contains("st_loader-active")) {
                    label.classList.add("st_loader-active");
                }
            };
            _this.loaderOff = function(triggerBtn) {
                var label = _this.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && label.classList.contains("st_loader-active")) {
                    label.classList.remove("st_loader-active");
                }
            };
            _this.changeCartEvents = function() {
                _this.initSearchBoxFunctionality();
                _this.initRadioButtons();
                _this.triggerVisibilityOfSection();
            };
            _this.setRepCookies = function(repInfo) {
                _this.cookies.setCookies(_this.cookieNameWebAlias, repInfo.ref);
                _this.cookies.setCookies(_this.cookieNameRepId, repInfo.repId);
                _this.cookies.setCookies(_this.cookieNameFirstName, repInfo.firstName);
                _this.cookies.setCookies(_this.cookieNameLastName, repInfo.lastName);
            };
            _this.triggerVisibilityOfSection = function() {
                var searchSponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                searchSponsorWrappers === null || searchSponsorWrappers === void 0 ? void 0 : searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                    var customerType = window.customerInfoMetafields.customerType;
                    if (customerType == _features_config_8.ECustomerType.retail && _features_config_8.lockedRepresentativeSite || customerType == _features_config_8.ECustomerType.representative) {
                        var searchSponsorWrapperLink = searchSponsorWrapper.querySelector(_this.classConfig.selectorChangeSponsorWrapperLink);
                        searchSponsorWrapperLink === null || searchSponsorWrapperLink === void 0 ? void 0 : searchSponsorWrapperLink.classList.add("st_hidden");
                    } else {
                        var triggerForOpenSearchInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorChangeSponsorWrapper);
                        triggerForOpenSearchInput === null || triggerForOpenSearchInput === void 0 ? void 0 : triggerForOpenSearchInput.addEventListener("click", function(e) {
                            e.preventDefault();
                            searchSponsorWrappers.forEach(function(wrapper) {
                                _this.defaultVisibility(wrapper);
                            });
                            _this.showSearchInput(searchSponsorWrapper);
                            _this.hideSearchResults(searchSponsorWrapper);
                        });
                        _this.nonSponsors(searchSponsorWrapper);
                    }
                });
            };
            _this.nonSponsors = function(searchSponsorWrapper) {
                var triggerForDefaultSponsorInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorNonSponsor);
                triggerForDefaultSponsorInput === null || triggerForDefaultSponsorInput === void 0 ? void 0 : triggerForDefaultSponsorInput.addEventListener("click", function() {
                    _this.updateUrl(_features_config_8.defaultWebAlias);
                    _this.defaultVisibility(searchSponsorWrapper);
                    _this.getSponsorInfo(_features_config_8.defaultWebAlias);
                    _this.setSponsorWebAliasToForm(_features_config_8.defaultWebAlias);
                    _this.setNewSponsorInfoToHeader(_features_config_8.corporationName, "", _features_config_8.defaultWebAlias);
                });
            };
            _this.updateUrl = function(newAlias) {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                if (ref !== newAlias) {
                    urlParams = __assign(__assign({}, urlParams), {
                        ref: newAlias
                    });
                    var newURL = window.location.href.replace(window.location.search, "");
                    _this.cart.updateCartItemsProperties(newAlias);
                    _this.browserHistory.pushHistory(newURL, urlParams);
                }
            };
            _this.windowClick = function() {
                document.addEventListener("click", function(e) {
                    var searchSponsorsResult = document.querySelector(_this.classConfig.selectorChooseSponsor);
                    if (!!searchSponsorsResult) {
                        if (!_this.generalMethods.getClosestByClass(e.target, "st_search-input-and-result")) {
                            var sponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                            sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                                _this.clearSponsorSuggestions(sponsorWrapper);
                            });
                        }
                    }
                });
            };
            _this.defaultVisibility = function(searchSponsorWrapper) {
                if (!!searchSponsorWrapper) {
                    _this.hideSearchInput(searchSponsorWrapper);
                    _this.showSearchResults(searchSponsorWrapper);
                }
            };
            _this.setSponsorWebAliasToForm = function(alias) {
                if (_features_config_8.canGoUnderCorporateSite || !_features_config_8.canGoUnderCorporateSite && alias !== _features_config_8.defaultWebAlias) {
                    var sponsorWebAliasFields = document.querySelectorAll(_this.classConfig.selectorRepresentativeAlias);
                    sponsorWebAliasFields === null || sponsorWebAliasFields === void 0 ? void 0 : sponsorWebAliasFields.forEach(function(field) {
                        _this.appendValueToField(field, alias);
                    });
                }
            };
            _this.getSponsorInfo = function(sponsorIdOrAlias) {
                _this.loadersOnForSponsorInfo();
                _this.sponsorService.getSponsorInfo(sponsorIdOrAlias, function(request) {
                    try {
                        if (request.status === 200) {
                            var sponsorInfoResponse = JSON.parse(request.response);
                            var sponsorInformation = sponsorInfoResponse.data.sponsors[0];
                            if (!sponsorInformation.ref && sponsorInformation.ref === "") {
                                sponsorInformation.ref = sponsorInformation.repId;
                            }
                            _this.injectSponsorInfo(sponsorInformation);
                            _this.setRepCookies(sponsorInformation);
                        } else {
                            if (_this.retryWebAliasFetch) {
                                _this.retryWebAliasFetch = false;
                                _this.getSponsorInfo(_features_config_8.defaultWebAlias);
                            }
                        }
                    } catch (error) {
                        console.log(error);
                        _this.getSponsorInfo(_features_config_8.defaultWebAlias);
                    }
                });
            };
            _this.loadersOnForSponsorInfo = function() {
                var sponsorsData = document.querySelectorAll(_this.classConfig.selectorSponsorData);
                var svg = '<svg width="15" height="15" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#222" class="st_loader">\n                        <g fill="none" fill-rule="evenodd">\n                            <g transform="translate(1 1)" stroke-width="2">\n                                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>\n                                <path d="M36 18c0-9.94-8.06-18-18-18">\n                                    <animateTransform\n                                            attributeName="transform"\n                                            type="rotate"\n                                            from="0 18 18"\n                                            to="360 18 18"\n                                            dur="1s"\n                                            repeatCount="indefinite"/>\n                                </path>\n                            </g>\n                        </g>\n                    </svg>';
                sponsorsData === null || sponsorsData === void 0 ? void 0 : sponsorsData.forEach(function(sponsorData) {
                    sponsorData.innerHTML = svg;
                });
            };
            _this.injectSponsorInfo = function(sponsorInformation) {
                var sponsorIdFields = document.querySelectorAll(_this.classConfig.selectorSponsorId);
                var sponsorAliasFields = document.querySelectorAll(_this.classConfig.selectorSponsorAlias);
                var sponsorFullNameFields = document.querySelectorAll(_this.classConfig.selectorSponsorFullName);
                var sponsorInitialsFields = document.querySelectorAll(_this.classConfig.selectorSponsorInitials);
                var sponsorAddressFields = document.querySelectorAll(_this.classConfig.selectorSponsorAddress);
                _this.injectTextIntoFields(sponsorIdFields, sponsorInformation.repId);
                _this.injectTextIntoFields(sponsorAliasFields, sponsorInformation.ref);
                _this.injectTextIntoFields(sponsorFullNameFields, "".concat(sponsorInformation.firstName, " ").concat(sponsorInformation.lastName));
                _this.injectTextIntoFields(sponsorInitialsFields, "".concat(sponsorInformation.firstName.charAt(0)).concat(sponsorInformation.lastName.charAt(0)));
                var address = sponsorInformation.address.state && sponsorInformation.address.state !== "" ? sponsorInformation.address.state + ", " + sponsorInformation.address.city : sponsorInformation.address.city;
                _this.injectTextIntoFields(sponsorAddressFields, address);
            };
            _this.searchSponsors = function(searchWrapper) {
                var input = searchWrapper.querySelector(_this.classConfig.selectorSearchSponsor);
                if (!!input) {
                    input.addEventListener("keyup", function(e) {
                        _this.getSponsors(input);
                    });
                    input.addEventListener("input", function(e) {
                        _this.getSponsors(input);
                    });
                    input.addEventListener("paste", function(e) {
                        _this.getSponsors(input);
                    });
                }
            };
            _this.getSponsors = function(input) {
                var value = input.value;
                if (_this.inputValue === value) return;
                if (value.length < _this.MIN_CHAR_SEARCH_REQUIREMENT) {
                    var searchSponsorInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                    _this.clearSponsorSuggestions(searchSponsorInputWrapper);
                    _this.enableRadioButtons(input);
                    return;
                }
                _this.inputValue = value;
                var requestType = _this.getCurrentRoute(input);
                _this.loaderOn(input);
                _this.disableRadioButtons(input);
                if (requestType === SponsorRequestType.GET_BY_ID_OR_ALIAS) {
                    _this.subscribeToTimeout(input, function() {
                        _this.sponsorService.getSponsorInfo(value, function(request) {
                            return _this.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
                if (requestType === SponsorRequestType.GET_BY_PERSONAL_INFORMATION) {
                    _this.subscribeToTimeout(input, function() {
                        _this.sponsorService.getSponsorByPersonalInfo(value, function(request) {
                            return _this.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
            };
            _this.getCurrentRoute = function(input) {
                var route;
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton, index) {
                    if (radioButton.classList.contains("st_checked")) {
                        route = index;
                    }
                });
                return route;
            };
            _this.enableRadioButtons = function(input) {
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.removeAttribute("disabled");
                });
            };
            _this.disableRadioButtons = function(input) {
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.setAttribute("disabled", "disabled");
                });
            };
            _this.initRadioButtons = function() {
                var radioButtonsWrappers = document.querySelectorAll(_this.classConfig.selectorSearchInput);
                radioButtonsWrappers === null || radioButtonsWrappers === void 0 ? void 0 : radioButtonsWrappers.forEach(function(radioButtonsWrapper) {
                    var radioButtons = radioButtonsWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                    radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(input) {
                        input.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.handleRadioButtonStatusChange(radioButtons, radioButtonsWrapper);
                            _this.clearSearchSponsorInputValueAndSuggestions(input);
                        });
                    });
                });
            };
            _this.setChecked = function(element) {
                if (!element.classList.contains("st_checked")) {
                    element.classList.add("st_checked");
                }
                element.setAttribute("checked", "checked");
            };
            _this.removeChecked = function(element) {
                if (element.classList.contains("st_checked")) {
                    element.classList.remove("st_checked");
                }
                element.removeAttribute("checked");
            };
            _this.renderPlaceholderText = function(radioButton, wrapper) {
                var label = _this.generalMethods.getClosestByTag(radioButton, "label");
                var text = label.querySelector(_this.classConfig.selectorRadioText).textContent;
                var placeholder = wrapper.querySelector(".st_search-input .st_placeholder-text");
                placeholder.innerHTML = text;
            };
            _this.clearSearchSponsorInputValueAndSuggestions = function(input) {
                var searchSponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                if (!!searchSponsorWrapper) {
                    _this.clearSearchSponsorInputValue(searchSponsorWrapper);
                    _this.clearSponsorSuggestions(searchSponsorWrapper);
                }
            };
            _this.clearSearchSponsorInputValue = function(searchSponsorWrapper) {
                var searchSponsorInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorSearchSponsor);
                if (!!searchSponsorInput) {
                    searchSponsorInput.value = "";
                    searchSponsorInput.replaceChildren();
                }
            };
            _this.clearSponsorSuggestions = function(searchSponsorWrapper) {
                var searchSponsorResult = searchSponsorWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                searchSponsorResult === null || searchSponsorResult === void 0 ? void 0 : searchSponsorResult.replaceChildren();
            };
            _this.renderSuggestionsWrapper = function(sponsorsList, input) {
                var sponsorsInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                if (!!sponsorsInputWrapper) {
                    var sponsorsWrapper_1 = sponsorsInputWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                    if (!!sponsorsWrapper_1) {
                        sponsorsWrapper_1.classList.remove("st_hidden");
                        sponsorsWrapper_1.replaceChildren();
                        sponsorsList === null || sponsorsList === void 0 ? void 0 : sponsorsList.forEach(function(sponsor) {
                            var sponsorJson = JSON.stringify(sponsor);
                            var buttonWithSponsorInfo = _this.createDOMElement("button", "st_search-sponsor-button--result st_choose-sponsor_JS", sponsorsWrapper_1);
                            buttonWithSponsorInfo.setAttribute("type", "button");
                            buttonWithSponsorInfo.setAttribute("data-sponsor-info", sponsorJson);
                            var leftPart = _this.createDOMElement("span", "st_result-left-part", buttonWithSponsorInfo);
                            var addressPart = _this.createDOMElement("span", "st_result-address", buttonWithSponsorInfo);
                            var credentialsSection = _this.createDOMElement("span", "st_account-sponsor-credentials-section", leftPart);
                            var sponsorResultName = _this.createDOMElement("span", "st_result-name", leftPart);
                            var addressPartData = _this.createDOMElement("span", "st_sponsor-address_JS", addressPart);
                            var state = sponsor.address.state;
                            var city = sponsor.address.city;
                            var address = state && state !== "" ? state + ", " + city : city;
                            addressPartData.innerHTML = address;
                            var initialsSection = _this.createDOMElement("span", "st_account-sponsor-initials", credentialsSection);
                            var initialsJSSection = _this.createDOMElement("span", "st_sponsor-initials_JS", initialsSection);
                            initialsJSSection.innerHTML = "".concat(sponsor.firstName.charAt(0)).concat(sponsor.lastName.charAt(0));
                            var colWrapper = _this.createDOMElement("span", "st_span-full-width", sponsorResultName);
                            var fullName = _this.createDOMElement("span", "st_sponsor-fullname_JS", colWrapper);
                            fullName.innerHTML = sponsor.firstName + " " + sponsor.lastName;
                            var sponsorIdWrapper = _this.createDOMElement("span", "st_sponsor-id", colWrapper);
                            var sponsorIdNumber = _this.createDOMElement("span", "st_sponsor-id_JS", sponsorIdWrapper);
                            sponsorIdNumber.innerHTML = " (ID: " + sponsor.repId + ")";
                            var aliasWrapper = _this.createDOMElement("span", "st_sponsor-alias", sponsorResultName);
                            var aliasWrapperData = _this.createDOMElement("span", "st_sponsor-alias_JS", aliasWrapper);
                            aliasWrapperData.innerHTML = sponsor.ref;
                        });
                    }
                    _this.chooseSponsor(sponsorsInputWrapper);
                }
            };
            _this.createDOMElement = function(element, classNames, parentElement) {
                var newElement = document.createElement(element);
                newElement.className = classNames;
                parentElement.appendChild(newElement);
                return newElement;
            };
            _this.chooseSponsor = function(sponsorsInputWrapper) {
                var sponsorButtons = sponsorsInputWrapper.querySelectorAll(_this.classConfig.selectorChooseSponsor);
                sponsorButtons === null || sponsorButtons === void 0 ? void 0 : sponsorButtons.forEach(function(sponsor) {
                    sponsor.addEventListener("click", function(e) {
                        e.preventDefault();
                        var newSponsorJson = sponsor.getAttribute("data-sponsor-info");
                        var newSponsor = JSON.parse(newSponsorJson);
                        var sponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                        sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                            _this.defaultVisibility(sponsorWrapper);
                        });
                        _this.updateUrl(newSponsor.ref);
                        _this.clearSearchSponsorInputValueAndSuggestions(e.target);
                        _this.injectSponsorInfo(newSponsor);
                        _this.setRepCookies(newSponsor);
                        _this.setSponsorWebAliasToForm(newSponsor.ref);
                        _this.setNewSponsorInfoToHeader(newSponsor.firstName, newSponsor.lastName, newSponsor.ref);
                        window.dispatchEvent(new Event("sponsorChange"));
                    });
                });
            };
            _this.setNewSponsorInfoToHeader = function(repFirstName, repLastName, ref) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepresentativeFullName);
                var fullName = _this.getFullName(repFirstName, repLastName, ref);
                repFullNameFields === null || repFullNameFields === void 0 ? void 0 : repFullNameFields.forEach(function(field) {
                    _this.appendValueToField(field, fullName);
                });
            };
            _this.appendValueToField = function(field, value) {
                if (field.tagName.toLowerCase() === "input") {
                    field.value = value;
                } else {
                    field.innerHTML = value;
                }
            };
            _this.hideSuggestionsWrapper = function(input) {
                var sponsorsInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var sponsorsWrapper = sponsorsInputWrapper === null || sponsorsInputWrapper === void 0 ? void 0 : sponsorsInputWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.replaceChildren();
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.classList.add("st_hidden");
            };
            _this.generalMethods = generalMethods;
            _this.objectFormatting = objectFormatting;
            _this.browserHistory = browserHistory;
            _this.classConfig = classConfig;
            _this.cookies = cookies;
            _this.cart = cart;
            _this.sponsorService = sponsorService;
            return _this;
        }
        StSearchSponsor.prototype.hideSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (!(searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden"))) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.add("st_hidden");
            }
        };
        StSearchSponsor.prototype.showSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden")) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.remove("st_hidden");
            }
        };
        StSearchSponsor.prototype.hideSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (!(searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden"))) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.add("st_hidden");
            }
        };
        StSearchSponsor.prototype.showSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden")) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.remove("st_hidden");
            }
        };
        StSearchSponsor.prototype.initSearchBoxFunctionality = function() {
            var _this = this;
            var searchWrappers = document.querySelectorAll(this.classConfig.selectorSearchSponsorWrapperPage);
            if (searchWrappers.length > 0) {
                var customerID = window.customerInfoMetafields.customerId;
                var sponsorRepID = window.customerInfoMetafields.representativeId;
                var customerType = window.customerInfoMetafields.customerType;
                var repSite = void 0;
                if (!!customerID && _features_config_8.lockedRepresentativeSite && customerType !== _features_config_8.ECustomerType.noType) {
                    repSite = customerType === _features_config_8.ECustomerType.representative ? customerID : sponsorRepID;
                } else {
                    var ref = this.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (!!ref.ref) {
                        repSite = ref.ref;
                    } else {
                        if (!!this.cookies.getCookie("ref")) {
                            repSite = this.cookies.getCookie("ref");
                        }
                    }
                }
                this.getSponsorInfo(repSite);
            }
            searchWrappers === null || searchWrappers === void 0 ? void 0 : searchWrappers.forEach(function(wrapper) {
                _this.searchSponsors(wrapper);
            });
        };
        StSearchSponsor.prototype.injectTextIntoFields = function(fields, text) {
            fields === null || fields === void 0 ? void 0 : fields.forEach(function(field) {
                field.innerHTML = text;
            });
        };
        StSearchSponsor.prototype.subscribeToTimeout = function(input, request) {
            var value = input.value;
            if (value.length > 1) {
                clearTimeout(this.requestTimeout);
                this.requestTimeout = setTimeout(request, this.REQUEST_DELAY);
            } else {
                var searchSponsorInputWrapper = this.generalMethods.getClosestByClass(input, this.classConfig.classNameSearchInput);
                this.clearSponsorSuggestions(searchSponsorInputWrapper);
                this.enableRadioButtons(input);
            }
        };
        StSearchSponsor.prototype.handleGetSponsorsResponse = function(request, input) {
            var res = JSON.parse(request.response);
            if (res.status === 200) {
                var sponsorsList = res.data.sponsors;
                if (sponsorsList.length > 0) {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.renderSuggestionsWrapper(sponsorsList, input);
                } else {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.hideSuggestionsWrapper(input);
                }
            } else {
                this.loaderOff(input);
                this.enableRadioButtons(input);
                this.hideSuggestionsWrapper(input);
            }
        };
        StSearchSponsor.prototype.handleRadioButtonStatusChange = function(radioButtons, radioButtonsWrapper) {
            var _this = this;
            radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                if (!!radioButton.checked) {
                    _this.setChecked(radioButton);
                    _this.renderPlaceholderText(radioButton, radioButtonsWrapper);
                } else {
                    _this.removeChecked(radioButton);
                }
            });
        };
        StSearchSponsor.prototype.getFullName = function(repFirstName, repLastName, ref) {
            var fullName = !!repLastName ? repFirstName : "";
            fullName = !!repLastName ? fullName.concat(" ".concat(repLastName)) : fullName;
            if (ref === _features_config_8.defaultWebAlias) fullName = _features_config_8.corporationName;
            return fullName;
        };
        return StSearchSponsor;
    }(st_module_39.StModule);
    exports.StSearchSponsor = StSearchSponsor;
});

define("core/shopify-app/st-modules/_general-methods/form/formatting", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_40) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFormFormatting = void 0;
    var StFormFormatting = function(_super) {
        __extends(StFormFormatting, _super);
        function StFormFormatting() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Formatting";
            _this.setupFormatting = function(collectionToIterate, formattingFn, callbackFn) {
                if (callbackFn === void 0) {
                    callbackFn = function(value) {};
                }
                collectionToIterate.forEach(function(input) {
                    var formattedVal = formattingFn(input.value);
                    input.value = formattedVal;
                    input.setAttribute("value", formattedVal);
                    callbackFn(formattedVal);
                    input.addEventListener("input", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                    input.addEventListener("keyup", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                    input.addEventListener("paste", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                });
            };
            _this.formatPhoneNumber = function(phone) {
                var phoneString = ("" + phone).replace(/\D/g, "");
                var segment1 = phoneString.slice(0, 3);
                var segment2 = phoneString.slice(3, 6);
                var segment3 = phoneString.slice(6, 10);
                return segment1 + (segment2.length > 0 ? "-" + segment2 : "") + (segment3.length > 0 ? "-" + segment3 : "");
            };
            _this.formatWebAlias = function(ref) {
                return ref.replace(/[^A-Za-z0-9\-_]/g, "");
            };
            _this.formatSSN = function(ssn) {
                var phoneString = ("" + ssn).replace(/\D/g, "");
                var segment1 = phoneString.slice(0, 3);
                var segment2 = phoneString.slice(3, 5);
                var segment3 = phoneString.slice(5, 9);
                return segment1 + (segment2.length > 0 ? "-" + segment2 : "") + (segment3.length > 0 ? "-" + segment3 : "");
            };
            return _this;
        }
        return StFormFormatting;
    }(st_module_40.StModule);
    exports.StFormFormatting = StFormFormatting;
});

define("core/shopify-app/st-modules/enrollment/blocks/account-details/account-details-helpers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_41) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccountDetailsHelpers = void 0;
    var StEnrollmentAccountDetailsHelpers = function(_super) {
        __extends(StEnrollmentAccountDetailsHelpers, _super);
        function StEnrollmentAccountDetailsHelpers(formFormatting, classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountDetailsHelpers";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.setupPhoneFormatting();
                });
            };
            _this.setupPhoneFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentAccountDetailsPhone);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatPhoneNumber);
            };
            _this.formFormatting = formFormatting;
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentAccountDetailsHelpers;
    }(st_module_41.StModule);
    exports.StEnrollmentAccountDetailsHelpers = StEnrollmentAccountDetailsHelpers;
});

define("core/shopify-app/st-modules/enrollment/blocks/business-info/business-details-helpers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_42) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentBusinessDetailsHelpers = void 0;
    var StEnrollmentBusinessDetailsHelpers = function(_super) {
        __extends(StEnrollmentBusinessDetailsHelpers, _super);
        function StEnrollmentBusinessDetailsHelpers(formatting, classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "BusinessDetailsHelpers";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.setupWebAliasFormatting();
                    _this.setupSSNFormatting();
                });
            };
            _this.setupWebAliasFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentBusinessDetailsWebAlias);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatWebAlias, function(value) {
                    var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                    var webAliasPresenter = wrp.querySelector(_this.classConfig.selectorEnrollmentBusinessDetailsWebAliasPresenter);
                    if (!!webAliasPresenter) {
                        webAliasPresenter.innerText = value;
                    }
                });
            };
            _this.setupSSNFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentBusinessDetailsSSN);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatSSN);
            };
            _this.formFormatting = formatting;
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentBusinessDetailsHelpers;
    }(st_module_42.StModule);
    exports.StEnrollmentBusinessDetailsHelpers = StEnrollmentBusinessDetailsHelpers;
});

define("core/shopify-app/st-modules/account/header/nav/account-nav", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/connector-app/_shared/models/auth/auth.request.model" ], function(require, exports, st_module_43, auth_request_model_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountNav = void 0;
    var StAccountNav = function(_super) {
        __extends(StAccountNav, _super);
        function StAccountNav(classConfig, objectFormatting, browserHistory, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountNav";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupAccountNavPages();
                    _this_1.openPage();
                    _this_1.bindNavEvents();
                    _this_1.logout();
                });
            };
            _this_1.setupAccountNavPages = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var pageWrappers = wrp.querySelectorAll(_this_1.classConfig.selectorAccountContent);
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var navWrp = wrp.querySelector(_this_1.classConfig.selectorAccountNavWrapper);
                if (!!navHolder) {
                    if (pageWrappers.length > 1) {
                        pageWrappers.forEach(function(pageWrapper, pageIndex) {
                            var templateName = pageWrapper.getAttribute("data-name");
                            var svgIcon = pageWrapper.querySelector(_this_1.classConfig.selectorAccountIcon).innerHTML;
                            var page = _this_1.navPageTemplate(pageIndex, templateName, svgIcon);
                            navHolder.appendChild(page);
                        });
                        if (navWrp) {
                            navWrp.classList.remove("st_hidden");
                        }
                    } else {
                        if (navWrp) {
                            navWrp.classList.add("st_hidden");
                        }
                    }
                } else {
                    console.error("Account Nav holder not present! Navigation won't setup");
                }
            };
            _this_1.navPageTemplate = function(pageIndex, templateName, svgIcon) {
                if (templateName === void 0) {
                    templateName = "";
                }
                if (svgIcon === void 0) {
                    svgIcon = "";
                }
                var templateNode;
                templateNode = document.createElement("div");
                templateNode.classList.add("st_header-account-nav-link");
                templateNode.classList.add(_this_1.classConfig.classNameAccountNavHolderSingle);
                var button = document.createElement("button");
                button.classList.add("st_header-navigation-account", "st_account--button");
                button.classList.add(_this_1.classConfig.classNameAccountNavButton);
                button.setAttribute("data-index", "".concat(pageIndex));
                button.innerHTML = svgIcon;
                var normalizedTemplateName = templateName.toLowerCase();
                if (normalizedTemplateName.includes("manage membership")) {
                    button.classList.add("st_account-membership-link_JS");
                    button.setAttribute("data-url", "/apps/memberships");
                }
                if (normalizedTemplateName.includes("manage subscription")) {
                    button.classList.add("st_account-subscription-link_JS");
                    button.setAttribute("data-url", "/apps/subscriptions");
                }
                var text = document.createElement("span");
                text.classList.add("st_header-text");
                text.innerHTML = templateName.charAt(0).toUpperCase() + templateName.slice(1);
                button.appendChild(text);
                templateNode.appendChild(button);
                return templateNode;
            };
            _this_1.bindNavEvents = function() {
                var _this = _this_1;
                var navLinks = document.querySelectorAll(_this.classConfig.selectorAccountNavButton);
                navLinks.forEach(function(navLink) {
                    navLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        var redirectUrl = this.getAttribute("data-url");
                        if (redirectUrl) {
                            window.location.assign(redirectUrl);
                            return;
                        }
                        var pageIndex = parseInt(this.getAttribute("data-index"));
                        _this.openPage(pageIndex);
                        _this.closeAddressEdit();
                        _this.closeSingleOrder();
                    });
                });
            };
            _this_1.closeAddressEdit = function() {
                var editAddressButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountBackButton);
                if (!!editAddressButtons) {
                    editAddressButtons.forEach(function(editAddressButton) {
                        var addressWrapper = _this_1.generalMethods.getClosestByClass(editAddressButton, _this_1.classConfig.classNameAddressesWrapper);
                        if (!!addressWrapper) {
                            var buttonDropdown = addressWrapper.querySelector(_this_1.classConfig.selectorAccountAddressesDropdown);
                            var buttonDropdownContent = addressWrapper.querySelector(_this_1.classConfig.selectorAccountAddressesDropdownWrapper);
                            addressWrapper.classList.remove("st_hide");
                            if (!!buttonDropdown && !!buttonDropdownContent) {
                                buttonDropdown.classList.remove("active");
                                buttonDropdownContent.classList.remove("active");
                            }
                        }
                    });
                }
            };
            _this_1.closeSingleOrder = function() {
                var _this = _this_1;
                var orderHistory = document.querySelectorAll(_this.classConfig.selectorBackToHistoryOrders);
                orderHistory.forEach(function(order) {
                    var singleOrderWrapper = document.querySelector(".st_single-order_JS");
                    if (!!singleOrderWrapper) {
                        singleOrderWrapper.style.display = "none";
                    }
                    var orderWrapper = document.querySelector(".st_order-history_JS");
                    if (!!orderWrapper) {
                        orderWrapper.classList.remove(_this.classConfig.classNameOpenOrderCSSClass);
                    }
                });
            };
            _this_1.openPage = function(pageIndex) {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var alreadyOpen = wrp.querySelector(_this_1.classConfig.selectorAccountSection + ".st_show");
                var accountSections = wrp.querySelectorAll(_this_1.classConfig.selectorAccountSection);
                if (typeof pageIndex === "undefined") {
                    var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    var maxTab = accountSections.length - 1;
                    var tabIndex = urlParams.tab ? parseInt(urlParams.tab) : 0;
                    pageIndex = isNaN(tabIndex) ? 0 : tabIndex;
                    pageIndex = tabIndex > maxTab ? maxTab : tabIndex;
                }
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var AccountNavElements = navHolder.querySelectorAll(_this_1.classConfig.selectorAccountNavHolderSingle);
                if (!!alreadyOpen) {
                    alreadyOpen.classList.remove("st_show");
                }
                if (accountSections.length > pageIndex) {
                    accountSections[pageIndex].classList.add("st_show");
                } else {
                    console.error("Invalid page index supplied to Account nav openPage method!");
                }
                AccountNavElements.forEach(function(navElement, index) {
                    navElement.classList.remove("current");
                    if (index === pageIndex) {
                        _this_1.updateTabToUrl("" + pageIndex);
                        navElement.classList.add("current");
                    }
                });
            };
            _this_1.updateTabToUrl = function(activeTab) {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                urlParams.tab = "" + activeTab;
                var newURL = window.location.href.replace(window.location.search, "");
                _this_1.browserHistory.pushHistory(newURL, urlParams);
            };
            _this_1.logout = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var logoutBtns = wrp.querySelectorAll(_this_1.classConfig.selectorAccountLogout);
                var _this = _this_1;
                if (!!logoutBtns) {
                    logoutBtns.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.removeTokens();
                            window.location.assign(window.location.protocol + "//" + window.location.hostname + "/account/logout");
                        });
                    });
                }
            };
            _this_1.removeTokens = function() {
                var token = window.localStorage.getItem(auth_request_model_2.ETokenType.Access);
                if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_2.ETokenType.Access);
                token = window.localStorage.getItem(auth_request_model_2.ETokenType.Refresh);
                if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_2.ETokenType.Refresh);
            };
            _this_1.classConfig = classConfig;
            _this_1.objectFormatting = objectFormatting;
            _this_1.browserHistory = browserHistory;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountNav;
    }(st_module_43.StModule);
    exports.StAccountNav = StAccountNav;
});

define("core/connector-app/_shared/models/auth/sso.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/auth/sso.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/header/backoffice-sso/backoffice-sso", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_44, notification_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StBackofficeSSO = void 0;
    var StBackofficeSSO = function(_super) {
        __extends(StBackofficeSSO, _super);
        function StBackofficeSSO(classConfig, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "BackofficeSSO";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.getSSOLinkEvent();
                });
            };
            _this_1.getSSOLinkEvent = function() {
                var _this = _this_1;
                var ssoLinks = document.querySelectorAll(_this_1.classConfig.selectorBackOfficeLink);
                for (var i = 0; i < ssoLinks.length; i++) {
                    var ssoLink = ssoLinks[i];
                    ssoLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.getSSOLink();
                    });
                }
            };
            _this_1.getSSOLink = function() {
                var _this = _this_1;
                var customerInfoMetafields = window.customerInfoMetafields;
                var ssoLinkRequest = {
                    customerId: customerInfoMetafields.personalId,
                    sponsorId: customerInfoMetafields.uplineId,
                    isAutoship: false,
                    customerType: customerInfoMetafields.customerType
                };
                _this_1.ajax.send({
                    endpoint: _this.endpoint["auth"]["sso"],
                    method: "post",
                    contentType: "json",
                    data: ssoLinkRequest,
                    callback: function(response) {
                        try {
                            var ssoLinkResponse = JSON.parse(response.response);
                            if (ssoLinkResponse.status === 200) {
                                var ssoLinkData = ssoLinkResponse.data;
                                if (!!ssoLinkData.ssoLink && ssoLinkData.ssoLink !== "") {
                                    window.location.href = ssoLinkData.ssoLink;
                                }
                            } else {
                                _this.notification.showNotification(notification_4.ENotificationType.error, "An Error Occurred!", ssoLinkResponse.message);
                            }
                        } catch (error) {
                            _this.notification.showNotification(notification_4.ENotificationType.error, "An Error Occurred!", error);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            return _this_1;
        }
        return StBackofficeSSO;
    }(st_module_44.StModule);
    exports.StBackofficeSSO = StBackofficeSSO;
});

define("core/shopify-app/st-modules/account/blocks/web-alias-edit/web-alias-edit", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_45, notification_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountWebAliasEdit = void 0;
    var StAccountWebAliasEdit = function(_super) {
        __extends(StAccountWebAliasEdit, _super);
        function StAccountWebAliasEdit(classConfig, generalMethods, notification, buttonActions, form, formFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountWebAliasEdit";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupWebAliasInputEvents();
                    _this_1.editWebAlias();
                });
            };
            _this_1.setupWebAliasInputEvents = function() {
                var _this = _this_1;
                var webAliasInputsFields = document.querySelectorAll(_this_1.classConfig.selectorAccountWebAlias);
                webAliasInputsFields.forEach(function(webAliasInput) {
                    _this.injectWebAlias(webAliasInput);
                    webAliasInput.addEventListener("keyup", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                    webAliasInput.addEventListener("input", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                    webAliasInput.addEventListener("paste", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                });
            };
            _this_1.injectWebAlias = function(webAliasInput) {
                var inputValue = webAliasInput.value;
                var webAliasWrapper = _this_1.generalMethods.getClosestByClass(webAliasInput, _this_1.classConfig.classNameWebAliasWrapper);
                var readOnlyInput = webAliasWrapper.querySelector(_this_1.classConfig.selectorWebAliasValue);
                readOnlyInput.value = inputValue;
            };
            _this_1.editWebAlias = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorEditWebAliasForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.submitWebAlias(this);
                    });
                }
            };
            _this_1.submitWebAlias = function(form) {
                var _this = _this_1;
                var formData = _this.form.collectFormData(form);
                var submitBtn = form.querySelector(_this_1.classConfig.selectorSubmitButton);
                _this.buttonActions.prevent(submitBtn);
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["updateWebAlias"],
                    method: "post",
                    contentType: "json",
                    data: formData,
                    callback: function(response) {
                        try {
                            var editWebAliasResponse = JSON.parse(response.response);
                            if (editWebAliasResponse.status === 200) {
                                _this.buttonActions.allow(submitBtn);
                                window.location.reload();
                            } else if (editWebAliasResponse.status === 400) {
                                var validationProperties = editWebAliasResponse.data;
                                _this.form.markValidationResults(form, validationProperties);
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_5.ENotificationType.error, "An Error Occurred", "Some fields are invalid.");
                            } else {
                                _this.notification.showNotification(notification_5.ENotificationType.error, "An Error Occurred", editWebAliasResponse.message);
                                _this.buttonActions.allow(submitBtn);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_5.ENotificationType.error, "Server Error", error);
                            _this.buttonActions.allow(submitBtn);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.form = form;
            _this_1.formFormatting = formFormatting;
            return _this_1;
        }
        return StAccountWebAliasEdit;
    }(st_module_45.StModule);
    exports.StAccountWebAliasEdit = StAccountWebAliasEdit;
});

define("core/shopify-app/st-modules/account/blocks/addresses/addresses", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_46) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountAddresses = void 0;
    var StAccountAddresses = function(_super) {
        __extends(StAccountAddresses, _super);
        function StAccountAddresses(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountAddress";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.openAddressDropDown();
                    _this_1.setupAddressEdit();
                    _this_1.setupAddressProvinceField();
                });
            };
            _this_1.openAddressDropDown = function() {
                var _this = _this_1;
                var dropDownButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountAddressesDropdown);
                dropDownButtons.forEach(function(dropDownButton) {
                    dropDownButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.openAddressActiveState(dropDownButton);
                    });
                });
            };
            _this_1.openAddressActiveState = function(dropDownButton) {
                dropDownButton.classList.toggle("active");
            };
            _this_1.setupAddressEdit = function() {
                var _this = _this_1;
                var addressTabButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountTabButton);
                addressTabButtons.forEach(function(addressTabButton) {
                    addressTabButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.showAddressEdit(addressTabButton);
                    });
                });
                var editAddressButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountBackButton);
                editAddressButtons.forEach(function(editAddressButton) {
                    editAddressButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.hideAddressEdit(editAddressButton);
                    });
                });
            };
            _this_1.showAddressEdit = function(addressTabButton) {
                var addressWrapper = _this_1.generalMethods.getClosestByClass(addressTabButton, _this_1.classConfig.classNameAddressesWrapper);
                if (!!addressWrapper) {
                    addressWrapper.classList.add("st_hide");
                }
            };
            _this_1.hideAddressEdit = function(editAddressButton) {
                var addressWrapper = _this_1.generalMethods.getClosestByClass(editAddressButton, _this_1.classConfig.classNameAddressesWrapper);
                if (!!addressWrapper) {
                    var buttonDropdown = addressWrapper.querySelector(".st_addresses-dots--button_JS");
                    var buttonDropdownContent = addressWrapper.querySelector(".st_dropdown-address--wrapper");
                    addressWrapper.classList.remove("st_hide");
                    buttonDropdown.classList.remove("active");
                    buttonDropdownContent.classList.remove("active");
                }
            };
            _this_1.setupAddressProvinceField = function() {
                var _this = _this_1;
                var provinceSelector = document.querySelector(_this_1.classConfig.selectorProvinceSelector);
                var provinceSource = document.querySelector(_this_1.classConfig.selectorProvinceSource);
                if (!!provinceSelector && !!provinceSource) {
                    _this_1.addProvinceOptions(provinceSelector, provinceSource);
                    provinceSource.addEventListener("change", function(e) {
                        _this.addProvinceOptions(provinceSelector, provinceSource);
                    });
                }
            };
            _this_1.addProvinceOptions = function(provinceSelector, provinceSource) {
                var selectedCountry = provinceSource.value ? provinceSource.value : provinceSource.getAttribute("data-default");
                var provinceSelectedOption = provinceSource.querySelector('option[value="'.concat(selectedCountry, '"]'));
                var provinceWrapper = _this_1.generalMethods.getClosestByClass(provinceSelector, _this_1.classConfig.classNameProvinceWrapper);
                if (!!provinceWrapper) {
                    provinceWrapper.classList.remove("st_hidden");
                }
                try {
                    var provinces = JSON.parse(provinceSelectedOption.getAttribute("data-provinces"));
                    provinceSelector.replaceChildren();
                    for (var i = 0; i < provinces.length; i++) {
                        var opt = document.createElement("option");
                        opt.value = provinces[i][0];
                        opt.innerHTML = provinces[i][1];
                        opt.setAttribute("data-ind", "" + i);
                        provinceSelector.appendChild(opt);
                    }
                    var defaultProvince = provinceSelector.getAttribute("data-default");
                    var defaultProvinceEl = provinceSelector.querySelector('option[value="'.concat(defaultProvince, '"]'));
                    var provinceOptions = provinceSelector.querySelectorAll("option");
                    var selectedOption = defaultProvince ? defaultProvinceEl : provinceOptions[0];
                    if (!selectedOption || !(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value)) {
                        console.warn("addProvinceOptions failed.");
                        return;
                    }
                    provinceSelector.value = selectedOption.value;
                    provinceSelector.selectedIndex = parseInt(selectedOption.getAttribute("data-ind"));
                    provinceOptions.forEach(function(provinceOption) {
                        provinceOption.removeAttribute("selected");
                    });
                    selectedOption.selected = true;
                    selectedOption.setAttribute("selected", "selected");
                } catch (e) {
                    console.error(e);
                    var provinceWrapper_1 = _this_1.generalMethods.getClosestByClass(provinceSelector, _this_1.classConfig.classNameProvinceWrapper);
                    if (!!provinceWrapper_1) {
                        provinceWrapper_1.classList.add("st_hidden");
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountAddresses;
    }(st_module_46.StModule);
    exports.StAccountAddresses = StAccountAddresses;
});

define("core/connector-app/_shared/models/customer/account/customer.account.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/blocks/personal-info/personal-info", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_47, notification_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalInfo = void 0;
    var StAccountPersonalInfo = function(_super) {
        __extends(StAccountPersonalInfo, _super);
        function StAccountPersonalInfo(classConfig, form, formFormatting, buttonActions, notification, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountPersonalInfo";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.editPersonalInfo();
                    _this_1.setupFormatPhoneNumber();
                });
            };
            _this_1.editPersonalInfo = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorPersonalInfoForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.submitPersonalInfo(this);
                    });
                }
            };
            _this_1.submitPersonalInfo = function(form) {
                var _this = _this_1;
                var data = _this.form.collectFormData(form);
                var formData = {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    phoneNumber: data.phoneNumber,
                    shopifyId: data.shopifyId,
                    email: data.email
                };
                var submitBtn = form.querySelector(_this_1.classConfig.selectorSubmitButton);
                _this.buttonActions.prevent(submitBtn);
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["updatePersonalInfo"],
                    method: "post",
                    contentType: "json",
                    data: formData,
                    callback: function(response) {
                        try {
                            var editPersonalInfoResponse = JSON.parse(response.response);
                            var validationProperties = editPersonalInfoResponse.data;
                            if (editPersonalInfoResponse.status === 200) {
                                _this.buttonActions.allow(submitBtn);
                                _this.form.markValidationResults(form, validationProperties);
                                _this.notification.showNotification(notification_6.ENotificationType.success, "Success", "You have successfully modified your information.");
                                _this.updatePersonalInfoWrapperIfExist(form, formData);
                            } else if (editPersonalInfoResponse.status === 400) {
                                _this.form.markValidationResults(form, validationProperties);
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_6.ENotificationType.error, "An Error Occurred", "Some fields are invalid.");
                            } else {
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_6.ENotificationType.error, "An Error Occurred", editPersonalInfoResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_6.ENotificationType.error, "Server Error", error);
                            _this.buttonActions.allow(submitBtn);
                        }
                    }
                });
            };
            _this_1.updatePersonalInfoWrapperIfExist = function(formSelector, formData) {
                var accountPage = _this_1.generalMethods.getClosestByClass(formSelector, _this_1.classConfig.classNameAccountPage);
                if (!!accountPage) {
                    var selectorBusinessContent = accountPage.querySelector(_this_1.classConfig.selectorBusinessContent);
                    if (!!selectorBusinessContent) {
                        var nameSelector = selectorBusinessContent.querySelector(_this_1.classConfig.selectorBusinessContentName);
                        var emailSelector = selectorBusinessContent.querySelector(_this_1.classConfig.selectorBusinessContentEmail);
                        if (!!emailSelector) {
                            emailSelector.innerHTML = formData.email;
                        }
                        if (!!nameSelector) {
                            nameSelector.innerHTML = formData.firstName + " " + formData.lastName;
                        }
                    }
                }
            };
            _this_1.setupFormatPhoneNumber = function() {
                var phoneNumberInputs = document.querySelectorAll('input[name="phoneNumber"]');
                _this_1.formFormatting.setupFormatting(phoneNumberInputs, _this_1.formFormatting.formatPhoneNumber);
            };
            _this_1.classConfig = classConfig;
            _this_1.form = form;
            _this_1.formFormatting = formFormatting;
            _this_1.buttonActions = buttonActions;
            _this_1.notification = notification;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountPersonalInfo;
    }(st_module_47.StModule);
    exports.StAccountPersonalInfo = StAccountPersonalInfo;
});

define("core/shopify-app/st-modules/account/blocks/order-history/order-history", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_48) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountOrderHistory = void 0;
    var StAccountOrderHistory = function(_super) {
        __extends(StAccountOrderHistory, _super);
        function StAccountOrderHistory(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountOrderHistory";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.openSingleOrder();
                    _this_1.backToHistoryOrders();
                });
            };
            _this_1.openSingleOrder = function() {
                var _this = _this_1;
                var singleOrderTriggers = document.querySelectorAll(_this.classConfig.selectorOpenSingleOrderButton);
                singleOrderTriggers.forEach(function(order) {
                    order.addEventListener("click", function(e) {
                        e.preventDefault();
                        var orderId = order.getAttribute("data-order-id");
                        var orderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        orderWrapper.classList.add(_this.classConfig.classNameOpenOrderCSSClass);
                        var singleOrderWrapper = orderWrapper.querySelector(_this.classConfig.selectorSingleOrder + '[data-order-id="' + orderId + '"]');
                        singleOrderWrapper.style.display = "block";
                    });
                });
            };
            _this_1.backToHistoryOrders = function() {
                var _this = _this_1;
                var orderHistory = document.querySelectorAll(_this.classConfig.selectorBackToHistoryOrders);
                orderHistory.forEach(function(order) {
                    order.addEventListener("click", function(e) {
                        e.preventDefault();
                        var singleOrderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameSingleOrder);
                        singleOrderWrapper.style.display = "none";
                        var orderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        orderWrapper.classList.remove(_this.classConfig.classNameOpenOrderCSSClass);
                    });
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountOrderHistory;
    }(st_module_48.StModule);
    exports.StAccountOrderHistory = StAccountOrderHistory;
});

define("core/shopify-app/st-modules/main/auto-apply-promo", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_49, _features_config_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAutoApplyPromo = void 0;
    var StAutoApplyPromo = function(_super) {
        __extends(StAutoApplyPromo, _super);
        function StAutoApplyPromo() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AutoApplyPromo";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var _a, _b;
                    var promoCode = (_b = (_a = window.stAppConfig) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.repPromoCode;
                    if (promoCode) {
                        _this_1.setupRepDiscount(promoCode);
                        _this_1.removeCodeOnLogout(promoCode);
                        if (_features_config_9.shareRefCodeFunctionality) {
                            _this_1.applyRefPromoCode();
                        }
                    }
                });
            };
            _this_1.setupRepDiscount = function(promoCode) {
                var _a, _b;
                document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                var repType = (_b = (_a = window.stAppConfig.options) === null || _a === void 0 ? void 0 : _a.customerType) === null || _b === void 0 ? void 0 : _b.representative;
                var currentCustomerType = window.customerInfoMetafields.customerType;
                if (currentCustomerType === repType && _features_config_9.repDiscountWithPromoCode) {
                    _this_1.applyPromoCodeIfNeeded(promoCode);
                }
            };
            _this_1.applyRefPromoCode = function() {
                document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                var refCode = localStorage.getItem("ref");
                if (!!refCode || refCode !== "null") {
                    _this_1.applyPromoCodeIfNeeded(refCode);
                }
            };
            _this_1.applyPromoCodeIfNeeded = function(promoCode) {
                if (!_this_1.isRepPromoApplied(promoCode)) {
                    var body = document.querySelector("body");
                    var iframeHolder = document.createElement("div");
                    iframeHolder.classList.add("st-autoapply-promocode");
                    var iframe = document.createElement("iframe");
                    iframe.classList.add("st_hidden");
                    iframe.src = "".concat(window.location.origin, "/discount/").concat(promoCode);
                    iframeHolder.appendChild(iframe);
                    body.insertBefore(iframeHolder, body.firstChild);
                }
            };
            _this_1.isRepPromoApplied = function(promoCode) {
                var alreadyApplied = false;
                var x = document.cookie.split("; ");
                for (var i = 0; i < x.length; i++) {
                    var c = x[i].split("=");
                    if (c[0] === "discount_code" || c[0] === "discount_code" && c[1] === promoCode) {
                        alreadyApplied = true;
                        break;
                    }
                }
                return alreadyApplied;
            };
            _this_1.removeCodeOnLogout = function(promoCode) {
                var _this = _this_1;
                var logoutLinks = document.querySelectorAll('[href*="account/logout"]');
                logoutLinks.forEach(function(logoutLink) {
                    logoutLink.addEventListener("click", function(e) {
                        if (_this.isRepPromoApplied(promoCode)) {
                            document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                        }
                    });
                });
            };
            return _this_1;
        }
        return StAutoApplyPromo;
    }(st_module_49.StModule);
    exports.StAutoApplyPromo = StAutoApplyPromo;
});

define("core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_50) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRepresentativeRedirectClassConfig = void 0;
    var StRepresentativeRedirectClassConfig = function(_super) {
        __extends(StRepresentativeRedirectClassConfig, _super);
        function StRepresentativeRedirectClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "representativeRedirectClassConfig";
            _this.classNameRepRedirectCopyText = "st_copy-repsite_JS";
            _this.selectorRepRedirectIconCopyText = "." + _this.classNameRepRedirectCopyText;
            _this.classNameRepRedirectCopyTextWrapper = "st_copy-repsite--wrapper_JS";
            _this.selectorRepRedirectCopyTextWrapper = "." + _this.classNameRepRedirectCopyTextWrapper;
            _this.classNameRepRedirectLabel = "st_representative-site_JS";
            _this.selectorRepRedirectLabel = "." + _this.classNameRepRedirectLabel;
            return _this;
        }
        return StRepresentativeRedirectClassConfig;
    }(st_module_50.StModule);
    exports.StRepresentativeRedirectClassConfig = StRepresentativeRedirectClassConfig;
});

define("core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_51) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRepresentativeRedirectPage = void 0;
    var StRepresentativeRedirectPage = function(_super) {
        __extends(StRepresentativeRedirectPage, _super);
        function StRepresentativeRedirectPage(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "RepresentativeRedirectPage";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.copyToClipboard();
                });
            };
            _this_1.copyToClipboard = function() {
                var _this = _this_1;
                var copyRepSiteButtonAll = document.querySelectorAll(_this_1.classConfig.selectorRepRedirectIconCopyText);
                if (copyRepSiteButtonAll && copyRepSiteButtonAll.length > 0) {
                    for (var i = 0; i < copyRepSiteButtonAll.length; i++) {
                        var copyRepSiteButton = copyRepSiteButtonAll[i];
                        copyRepSiteButton.addEventListener("click", function(e) {
                            e.preventDefault();
                            var copyText = document.querySelector(_this.classConfig.selectorRepRedirectLabel);
                            if (!!copyText) {
                                var copyText_1 = document.querySelector(_this.classConfig.selectorRepRedirectLabel);
                                copyText_1.select();
                                copyText_1.setSelectionRange(0, 99999);
                                navigator.clipboard.writeText(copyText_1.value);
                                copyText_1.style.backgroundColor = "rgb(217, 218, 220)";
                                copyText_1.style.transition = "0.5s";
                                setTimeout(function() {
                                    copyText_1.style.backgroundColor = "rgb(249, 249, 249)";
                                    copyText_1.style.transition = "0.5s";
                                }, 1e3);
                            }
                        });
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StRepresentativeRedirectPage;
    }(st_module_51.StModule);
    exports.StRepresentativeRedirectPage = StRepresentativeRedirectPage;
});

define("core/shopify-app/st-modules/reset-password/reset-password-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_52) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StResetPasswordClassConfig = void 0;
    var StResetPasswordClassConfig = function(_super) {
        __extends(StResetPasswordClassConfig, _super);
        function StResetPasswordClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ResetPasswordClassConfig";
            _this.classNamePasswordVisibilityButton = "st_toggle-password-visibility-button_JS";
            _this.selectorPasswordVisibilityButton = "." + _this.classNamePasswordVisibilityButton;
            _this.classLoginPasswordInput = "st_reset-password-input_JS";
            _this.selectorLoginPasswordInput = "." + _this.classLoginPasswordInput;
            return _this;
        }
        return StResetPasswordClassConfig;
    }(st_module_52.StModule);
    exports.StResetPasswordClassConfig = StResetPasswordClassConfig;
});

define("core/shopify-app/st-modules/reset-password/reset-password", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_53) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StResetPassword = void 0;
    var StResetPassword = function(_super) {
        __extends(StResetPassword, _super);
        function StResetPassword(form, notification, buttonActions, classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "ResetPassword";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.togglePassword();
                });
            };
            _this_1.togglePassword = function() {
                var _this = _this_1;
                var passwordEyeIcons = document.querySelectorAll(_this_1.classConfig.selectorPasswordVisibilityButton);
                passwordEyeIcons.forEach(function(icon) {
                    icon.addEventListener("click", function(e) {
                        e.preventDefault();
                        var passwordLabel = _this.generalMethods.getClosestByTag(this, "div");
                        var passwordInput = passwordLabel.querySelector(_this.classConfig.selectorLoginPasswordInput);
                        if (!!passwordInput) {
                            if (passwordInput.getAttribute("type") === "password") {
                                passwordInput.setAttribute("type", "text");
                                this.classList.add("st_password-visible");
                            } else {
                                passwordInput.setAttribute("type", "password");
                                this.classList.remove("st_password-visible");
                            }
                        }
                    });
                });
            };
            _this_1.form = form;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StResetPassword;
    }(st_module_53.StModule);
    exports.StResetPassword = StResetPassword;
});

define("core/shopify-app/st-modules/enrollment/enrollment-cleanup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_54, _features_config_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentCleanup = void 0;
    var StEnrollmentCleanup = function(_super) {
        __extends(StEnrollmentCleanup, _super);
        function StEnrollmentCleanup(cart) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StEnrollmentCleanup";
            _this.init = function() {};
            _this.clearCartAttributes = function(callback) {
                if (callback === void 0) {
                    callback = function() {};
                }
                _this.cart.getCart(function(cartData) {
                    var paramsToClear = _features_config_10.enrollmentParams !== null && _features_config_10.enrollmentParams !== void 0 ? _features_config_10.enrollmentParams : [];
                    if (cartData.attributes) {
                        var attributesFormatted_1 = __assign({}, cartData.attributes);
                        Object.keys(attributesFormatted_1).forEach(function(param) {
                            if (paramsToClear.indexOf(param) > -1) {
                                attributesFormatted_1[param] = "";
                            }
                        });
                        _this.cart.updateCart({
                            attributes: attributesFormatted_1
                        }, callback);
                    }
                });
            };
            _this.cart = cart;
            return _this;
        }
        return StEnrollmentCleanup;
    }(st_module_54.StModule);
    exports.StEnrollmentCleanup = StEnrollmentCleanup;
});

define("core/shopify-app/st-modules/referral/referral", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_55, notification_7, _features_config_11) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StReferral = void 0;
    var StReferral = function(_super) {
        __extends(StReferral, _super);
        function StReferral(generalMethods, objectFormatting, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Referral";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.checkTags();
                    _this_1.handlerRefBanner();
                });
            };
            _this_1.checkTags = function() {
                if (_features_config_11.shareRefCodeFunctionality) {
                    var customerTagsWrapper = document.querySelector(".st_customer-tags");
                    if (!!customerTagsWrapper) {
                        var tags = customerTagsWrapper.getAttribute("data-tags");
                        var isLogged = customerTagsWrapper.getAttribute("data-customer-id");
                        var splitStr = tags.split(",");
                        var retail = splitStr.find(function(ret) {
                            return ret.includes("retail");
                        });
                        var noOrder = splitStr.find(function(el) {
                            return el.includes("no_order");
                        });
                        if (isLogged) {
                            if (retail && noOrder) {
                                _this_1.getRefFromLink();
                                _this_1.setRefInLink();
                            } else {
                                _this_1.deleteRefCode();
                            }
                        } else {
                            _this_1.getRefFromLink();
                            _this_1.setRefInLink();
                        }
                    }
                } else {
                    _this_1.deleteRefCode();
                    _this_1.hideRef();
                }
            };
            _this_1.getRefFromLink = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                if (!!ref) {
                    localStorage.setItem("ref", ref);
                }
            };
            _this_1.getCode = function() {
                var tagFromNav = document.querySelector(".st_referral-code-div_JS");
                if (!!tagFromNav) {
                    return tagFromNav.getAttribute("data-customer-tags");
                }
            };
            _this_1.setRefInLink = function() {
                var refCode = localStorage.getItem("ref");
                var refCodeFromTag = _this_1.getCode();
                if (!refCode || refCode === "null" || refCode === " " || refCode === "undefined" || refCode === "") {
                    _this_1.deleteRefCode();
                } else {
                    if (refCode === refCodeFromTag) {
                        _this_1.deleteRefCode();
                    } else {
                        var params = new URLSearchParams(window.location.search);
                        if (!params.get("ref")) {
                            params.append("ref", refCode);
                        }
                    }
                }
            };
            _this_1.deleteRefCode = function() {
                var params = new URLSearchParams(window.location.search);
                params.delete("ref");
                var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                if (!!params.toString()) {
                    newUrl += "?" + params;
                }
            };
            _this_1.handlerRefBanner = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                if (_features_config_11.shareRefCodeFunctionality) {
                    if (!!ref) {
                        _this_1.getReferralsData();
                    } else {
                        _this_1.hideRef();
                    }
                } else {
                    _this_1.hideRef();
                }
            };
            _this_1.showRef = function() {
                var refWrapper = document.querySelector(".st_referred-by-banner_JS");
                if (!!refWrapper) {
                    if (refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.remove("st_hidden");
                    }
                }
            };
            _this_1.hideRef = function() {
                var refWrapper = document.querySelector(".st_referred-by-banner_JS");
                if (!!refWrapper) {
                    if (!refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.getReferralsData = function() {
                var _this = _this_1;
                var referralCode = localStorage.getItem("ref");
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                var refCode = {
                    promoCode: referralCode,
                    ref: ref
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["customer"]["getReferralInfo"],
                    method: "post",
                    contentType: "json",
                    data: refCode,
                    callback: function(response) {
                        try {
                            var getReferralInfo = JSON.parse(response.response);
                            if (getReferralInfo.status === 200) {
                                var refType = getReferralInfo.data.customerType;
                                if (refType === "retail") {
                                    _this.showRef();
                                    var fullname = getReferralInfo.data.firstName + " " + getReferralInfo.data.lastName;
                                    _this.writeRefName(fullname);
                                    if (getReferralInfo.data.customerSponsorMatch === false) {
                                        _this.deleteRefCode();
                                        _this.hideRef();
                                    }
                                }
                                if (refType === "representative") {
                                    if (getReferralInfo.data.customerSponsorMatch === false) {
                                        _this.deleteRefCode();
                                        _this.hideRef();
                                    }
                                }
                                if (refType === "") {
                                    console.log("INVALID REF CODE !!!!!!!!!!!");
                                    _this.deleteRefCode();
                                    _this.hideRef();
                                }
                            } else {
                                _this.notification.showNotification(notification_7.ENotificationType.error, "An Error Occurred", getReferralInfo.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_7.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.writeRefName = function(fullname) {
                var refNameSpan = document.querySelector(".st_referral-fullname_JS");
                if (!!refNameSpan) {
                    refNameSpan.innerHTML = fullname;
                }
            };
            _this_1.generalMethods = generalMethods;
            _this_1.objectFormatting = objectFormatting;
            _this_1.notification = notification;
            return _this_1;
        }
        return StReferral;
    }(st_module_55.StModule);
    exports.StReferral = StReferral;
});

define("core/shopify-app/st-modules/account/blocks/coupon-codes/coupon-codes", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_56, _features_config_12) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCouponCodes = void 0;
    var StCouponCodes = function(_super) {
        __extends(StCouponCodes, _super);
        function StCouponCodes() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "CouponCodes";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.blockHandle();
                });
            };
            _this_1.blockHandle = function() {
                var mainWrapper = document.querySelector(".st_account-coupon-codes_wrapper_JS");
                if (!!mainWrapper) {
                    if (_features_config_12.shareRefCodeFunctionality) {
                        mainWrapper.classList.remove("st_hidden");
                        _this_1.toggleInputs();
                        _this_1.copyCode();
                        _this_1.earnedCouponCodes();
                        _this_1.redeemedCouponCodes();
                        var showInactive = false;
                        _this_1.filterStatus(showInactive);
                    } else {
                        mainWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.toggleInputs = function() {
                var _this = _this_1;
                var showCodeBtnField = document.querySelectorAll(".st_coupon-codes-table-codes_JS");
                if (!!showCodeBtnField) {
                    showCodeBtnField.forEach(function(el) {
                        var showCodeBtn = el.querySelector(".st_table-show-coupon_JS");
                        showCodeBtn.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.showCode(el);
                        });
                    });
                }
            };
            _this_1.showCode = function(el) {
                var showCodeBtnWrapper = el.querySelector(".st_table-coupon-code-show-wrapper_JS");
                var codeWrapper = el.querySelector(".st_table-coupon-code-input-wrapper_JS");
                if (!!showCodeBtnWrapper && !!codeWrapper) {
                    showCodeBtnWrapper.classList.add("st_hidden");
                    codeWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.copyCode = function() {
                var showCodeBtnField = document.querySelectorAll(".st_coupon-codes-table-codes_JS");
                if (!!showCodeBtnField) {
                    showCodeBtnField.forEach(function(el) {
                        var copyCodeBtn = el.querySelector(".st_table-copy-coupon_JS");
                        if (!!copyCodeBtn) {
                            copyCodeBtn.addEventListener("click", function() {
                                var input = el.querySelector(".st_table-coupon-code_JS");
                                if (!!input) {
                                    input.select();
                                    input.setSelectionRange(0, 99999);
                                    navigator.clipboard.writeText(input.value);
                                    input.style.backgroundColor = "rgb(217, 218, 220)";
                                    input.style.transition = "0.2s";
                                    setTimeout(function() {
                                        input.style.backgroundColor = "rgb(249, 249, 249)";
                                    }, 1e3);
                                }
                            });
                        }
                    });
                }
            };
            _this_1.earnedCouponCodes = function() {
                var _this = _this_1;
                var earnedBtn = document.querySelector(".st_earned-coupon-codes_JS");
                if (!!earnedBtn) {
                    earnedBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var flag = false;
                        _this.filterStatus(flag);
                    });
                }
            };
            _this_1.redeemedCouponCodes = function() {
                var _this = _this_1;
                var redeemedBtn = document.querySelector(".st_redeemed-coupon-codes_JS");
                if (!!redeemedBtn) {
                    redeemedBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var flag = true;
                        _this.filterStatus(flag);
                    });
                }
            };
            _this_1.filterStatus = function(flag) {
                var _this = _this_1;
                var tableRows = document.querySelectorAll(".st_coupon-codes-table-row_JS");
                if (!!tableRows) {
                    tableRows.forEach(function(el) {
                        var couponStatusEl = el.querySelector(".st_coupon-codes-table-status_JS");
                        var status = couponStatusEl.getAttribute("data-status");
                        if (flag) {
                            if (status === "Active") {
                                el.classList.add("st_hidden");
                            } else {
                                el.classList.remove("st_hidden");
                            }
                        } else {
                            if (status === "Active") {
                                el.classList.remove("st_hidden");
                            } else {
                                el.classList.add("st_hidden");
                            }
                        }
                        _this.adjustTableHeader(flag);
                        _this.adjustTableForInactive(status, el);
                    });
                }
            };
            _this_1.adjustTableForInactive = function(status, el) {
                var copyBtn = el.querySelector(".st_table-copy-coupon_JS");
                var columnNameEl = document.querySelector(".st_table-head-actions_JS");
                if (!!columnNameEl) {
                    if (status === "Active") {
                        copyBtn.classList.remove("st_hidden");
                    } else {
                        copyBtn.classList.add("st_hidden");
                        _this_1.showCode(el);
                    }
                }
            };
            _this_1.adjustTableHeader = function(flag) {
                var columnNameEl = document.querySelector(".st_table-head-actions_JS");
                if (!!columnNameEl) {
                    if (flag) {
                        columnNameEl.innerHTML = "Used Promo Code";
                    } else {
                        columnNameEl.innerHTML = "Actions";
                    }
                }
            };
            return _this_1;
        }
        return StCouponCodes;
    }(st_module_56.StModule);
    exports.StCouponCodes = StCouponCodes;
});

define("core/shopify-app/st-modules/auth/auth", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_57) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAuth = void 0;
    var StAuth = function(_super) {
        __extends(StAuth, _super);
        function StAuth() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Auth";
            _this.init = function() {
                _this.ajax.tryGetTokens();
            };
            return _this;
        }
        return StAuth;
    }(st_module_57.StModule);
    exports.StAuth = StAuth;
});

define("core/shopify-app/st-modules/share-cart/share-cart-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_58) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCartClassConfig = void 0;
    var StShareCartClassConfig = function(_super) {
        __extends(StShareCartClassConfig, _super);
        function StShareCartClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StShareCartClassConfig";
            _this.classNameShareCartWrapper = "st-share-cart";
            _this.selectorShareCartWrapper = "." + _this.classNameShareCartWrapper;
            _this.classNameShareCartToggle = "st-share-cart__toggle_JS";
            _this.selectorShareCartToggle = "." + _this.classNameShareCartToggle;
            _this.classNameShareCartContent = "st-share-cart__content_JS";
            _this.selectorShareCartContent = "." + _this.classNameShareCartContent;
            _this.classNameShareCartForm = "st-share-cart__form_JS";
            _this.selectorShareCartForm = "." + _this.classNameShareCartForm;
            _this.classNameShareCartSuccess = "st-share-cart__success_JS";
            _this.selectorShareCartSuccess = "." + _this.classNameShareCartSuccess;
            _this.classNameShareCartInput = "st-share-cart__input_JS";
            _this.selectorShareCartInput = "." + _this.classNameShareCartInput;
            _this.classNameShareCartSwitchInput = "st-share-cart__switch-input_JS";
            _this.selectorShareCartSwitchInput = "." + _this.classNameShareCartSwitchInput;
            _this.classNameShareCartPartySwitchInput = "st-share-cart__party-switch-input_JS";
            _this.selectorShareCartPartySwitchInput = "." + _this.classNameShareCartPartySwitchInput;
            _this.classNameShareCartPartyField = "st-share-cart__party-field_JS";
            _this.selectorShareCartPartyField = "." + _this.classNameShareCartPartyField;
            _this.classNameShareCartPartyInput = "st-share-cart__party-input_JS";
            _this.selectorShareCartPartyInput = "." + _this.classNameShareCartPartyInput;
            _this.classNameShareCartGenerateLink = "st-share-cart__generate-link_JS";
            _this.selectorShareCartGenerateLink = "." + _this.classNameShareCartGenerateLink;
            _this.classNameShareCartCopyInput = "st-share-cart__copy-input_JS";
            _this.selectorShareCartCopyInput = "." + _this.classNameShareCartCopyInput;
            _this.classNameShareCartCopyButton = "st-share-cart__copy-button_JS";
            _this.selectorShareCartCopyButton = "." + _this.classNameShareCartCopyButton;
            _this.classNameShareCartReset = "st-share-cart__reset_JS";
            _this.selectorShareCartReset = "." + _this.classNameShareCartReset;
            _this.classNameShareCartViewAllLink = "st-share-cart__view-all-link";
            _this.selectorShareCartViewAllLink = "." + _this.classNameShareCartViewAllLink;
            _this.classNameShareCartOpenState = "is-open";
            _this.cartDrawer = function() {
                return document.querySelector("#cart-drawer") || document.querySelector(".wt-cart__wrapper");
            };
            _this.shareCartMainWrapper = function() {
                return document.querySelector(_this.selectorShareCartWrapper);
            };
            _this.shareCartWrappers = function() {
                return document.querySelectorAll(_this.selectorShareCartWrapper);
            };
            _this.shareCartToggle = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartToggle);
            };
            _this.shareCartContent = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartContent);
            };
            _this.shareCartForm = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartForm);
            };
            _this.shareCartSuccess = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartSuccess);
            };
            _this.shareCartNameInput = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartInput);
            };
            _this.shareCartSaveSwitch = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartSwitchInput);
            };
            _this.shareCartPartySwitch = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartPartySwitchInput);
            };
            _this.shareCartPartyField = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartPartyField);
            };
            _this.shareCartPartyInput = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartPartyInput);
            };
            _this.shareCartGenerateButton = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartGenerateLink);
            };
            _this.shareCartCopyInput = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartCopyInput);
            };
            _this.shareCartCopyButton = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartCopyButton);
            };
            _this.shareCartResetButton = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartReset);
            };
            _this.shareCartViewAllLink = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartViewAllLink);
            };
            return _this;
        }
        return StShareCartClassConfig;
    }(st_module_58.StModule);
    exports.StShareCartClassConfig = StShareCartClassConfig;
});

define("core/shopify-app/st-modules/share-cart/share-cart-types", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/share-cart/sharecart.feature.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.shareCartCartEditingEnabled = exports.shareCartShortLinkEnabled = exports.shareCartPromoCodeEnabled = exports.shareCartNameEnabled = exports.shareCartPartyEnabled = exports.shareCartDeleteEnabled = exports.shareCartEditEnabled = exports.shareCartCopyEnabled = exports.shareCartViewEnabled = exports.shareCartCreateEnabled = exports.shareCartStatisticsEnabled = exports.shareCartAccountDetailsPageEnabled = exports.shareCartAccountDashboardEnabled = exports.shareCartLandingEnabled = exports.shareCartDrawerEnabled = exports.shareCartEnabled = void 0;
    exports.shareCartEnabled = true;
    exports.shareCartDrawerEnabled = true;
    exports.shareCartLandingEnabled = true;
    exports.shareCartAccountDashboardEnabled = true;
    exports.shareCartAccountDetailsPageEnabled = true;
    exports.shareCartStatisticsEnabled = true;
    exports.shareCartCreateEnabled = true;
    exports.shareCartViewEnabled = true;
    exports.shareCartCopyEnabled = true;
    exports.shareCartEditEnabled = true;
    exports.shareCartDeleteEnabled = true;
    exports.shareCartPartyEnabled = false;
    exports.shareCartNameEnabled = true;
    exports.shareCartPromoCodeEnabled = true;
    exports.shareCartShortLinkEnabled = true;
    exports.shareCartCartEditingEnabled = true;
});

define("core/shopify-app/st-modules/share-cart/share-cart-drawer", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/share-cart/sharecart.feature.config", "_features.config" ], function(require, exports, st_module_59, notification_8, sharecart_feature_config_1, _features_config_13) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCartDrawer = void 0;
    var StShareCartDrawer = function(_super) {
        __extends(StShareCartDrawer, _super);
        function StShareCartDrawer(classConfig, generalMethods, cartComponent, objectFormatting, notification) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StShareCartDrawer";
            _this.init = function() {
                if (!sharecart_feature_config_1.shareCartEnabled || !sharecart_feature_config_1.shareCartDrawerEnabled) {
                    return;
                }
                _this.subscribeDOMLoaded(function() {
                    _this.tryToSetupDrawer();
                    _this.cartComponent.subscribeChangeCart(function(cartObject) {
                        if (!!(cartObject === null || cartObject === void 0 ? void 0 : cartObject.items) && cartObject.items.length > 0) {
                            _this.tryToSetupDrawer();
                        }
                    });
                });
            };
            _this.tryToSetupDrawer = function() {
                if (!sharecart_feature_config_1.shareCartEnabled || !sharecart_feature_config_1.shareCartDrawerEnabled) {
                    return;
                }
                var shareCartWrapper = _this.classConfig.shareCartMainWrapper();
                if (!!shareCartWrapper) {
                    _this.setupConditionalRender();
                    _this.handleSaveSwitchPersistence();
                    if (sharecart_feature_config_1.shareCartPartyEnabled) {
                        _this.handlePartyToggle();
                    }
                    _this.handleClickOnShareCart();
                    _this.handleViewAllSharedCarts();
                } else {
                    var cartDrawer = _this.classConfig.cartDrawer();
                    if (!cartDrawer) {
                        return;
                    }
                    _this.onElementLoaded(cartDrawer, function() {
                        var newShareCartWrapper = _this.classConfig.shareCartMainWrapper();
                        if (!!newShareCartWrapper) {
                            _this.setupConditionalRender();
                            _this.handleSaveSwitchPersistence();
                            if (sharecart_feature_config_1.shareCartPartyEnabled) {
                                _this.handlePartyToggle();
                            }
                            _this.handleClickOnShareCart();
                            _this.handleViewAllSharedCarts();
                        }
                    }, {
                        childList: true,
                        subtree: true,
                        attributeOldValue: true,
                        attributes: true
                    });
                }
            };
            _this.onElementLoaded = function(elementToObserve, callback, options) {
                var MutationObserverRef = window.MutationObserver;
                if (!elementToObserve || elementToObserve.nodeType !== 1 || !MutationObserverRef) {
                    return;
                }
                var observer = new MutationObserverRef(callback);
                observer.observe(elementToObserve, options || {
                    childList: true,
                    attributeFilter: [ "innerHTML" ]
                });
                return observer;
            };
            _this.setupConditionalRender = function() {
                var wrappers = _this.classConfig.shareCartWrappers();
                if (!wrappers.length) {
                    return;
                }
                wrappers.forEach(function(wrapper) {
                    var shareCartToggle = _this.classConfig.shareCartToggle(wrapper);
                    var shareCartContent = _this.classConfig.shareCartContent(wrapper);
                    var shareCartResetButton = _this.classConfig.shareCartResetButton(wrapper);
                    if (shareCartToggle && shareCartContent) {
                        shareCartToggle.onclick = function(event) {
                            event.preventDefault();
                            var isExpanded = shareCartToggle.getAttribute("aria-expanded") === "true";
                            var nextExpandedState = !isExpanded;
                            shareCartToggle.setAttribute("aria-expanded", String(nextExpandedState));
                            shareCartContent.hidden = !nextExpandedState;
                            wrapper.classList.toggle(_this.classConfig.classNameShareCartOpenState, nextExpandedState);
                        };
                    }
                    if (shareCartResetButton) {
                        shareCartResetButton.onclick = function() {
                            _this.newShareCartState(wrapper);
                            if (shareCartToggle && shareCartContent) {
                                shareCartToggle.setAttribute("aria-expanded", "true");
                                shareCartContent.hidden = false;
                                wrapper.classList.add(_this.classConfig.classNameShareCartOpenState);
                            }
                        };
                    }
                });
            };
            _this.handleSaveSwitchPersistence = function() {
                var wrappers = _this.classConfig.shareCartWrappers();
                if (!wrappers.length) {
                    return;
                }
                wrappers.forEach(function(wrapper) {
                    var saveSwitch = _this.classConfig.shareCartSaveSwitch(wrapper);
                    if (!saveSwitch) {
                        return;
                    }
                    var persistedValue = localStorage.getItem("saveShareCart") === "true";
                    saveSwitch.checked = persistedValue;
                    saveSwitch.onchange = function() {
                        localStorage.setItem("saveShareCart", saveSwitch.checked ? "true" : "false");
                    };
                });
            };
            _this.handlePartyToggle = function() {
                if (!sharecart_feature_config_1.shareCartPartyEnabled) {
                    return;
                }
                var wrappers = _this.classConfig.shareCartWrappers();
                if (!wrappers.length) {
                    return;
                }
                wrappers.forEach(function(wrapper) {
                    var partySwitch = _this.classConfig.shareCartPartySwitch(wrapper);
                    var partyField = _this.classConfig.shareCartPartyField(wrapper);
                    var partyInput = _this.classConfig.shareCartPartyInput(wrapper);
                    if (!partySwitch || !partyField || !partyInput) {
                        return;
                    }
                    var togglePartyFieldVisibility = function() {
                        var isChecked = !!partySwitch.checked;
                        partyField.hidden = !isChecked;
                        if (!isChecked) {
                            partyInput.value = "";
                            wrapper.removeAttribute("data-party-validation-request-id");
                            _this.setPartyValidationState(wrapper, "idle");
                        } else {
                            _this.setPartyValidationState(wrapper, partyInput.value.trim() ? "checking" : "idle");
                        }
                    };
                    togglePartyFieldVisibility();
                    partySwitch.onchange = togglePartyFieldVisibility;
                    if (partyInput.dataset.stPartyValidationBound === "true") {
                        return;
                    }
                    partyInput.dataset.stPartyValidationBound = "true";
                    var debounceTimer = null;
                    partyInput.addEventListener("input", function() {
                        var partyValue = partyInput.value.trim();
                        if (debounceTimer) {
                            clearTimeout(debounceTimer);
                        }
                        if (!partySwitch.checked) {
                            _this.setPartyValidationState(wrapper, "idle");
                            return;
                        }
                        if (!partyValue) {
                            _this.setPartyValidationState(wrapper, "idle");
                            return;
                        }
                        _this.setPartyValidationState(wrapper, "checking");
                        debounceTimer = setTimeout(function() {
                            var requestId = "".concat(Date.now(), "-").concat(partyValue);
                            wrapper.setAttribute("data-party-validation-request-id", requestId);
                            _this.validatePartyId(partyValue, function(isValid) {
                                var activeRequestId = wrapper.getAttribute("data-party-validation-request-id");
                                if (activeRequestId !== requestId) {
                                    return;
                                }
                                _this.setPartyValidationState(wrapper, isValid ? "valid" : "invalid");
                            });
                        }, 500);
                    });
                });
            };
            _this.handleClickOnShareCart = function() {
                var wrappers = _this.classConfig.shareCartWrappers();
                if (!wrappers.length) {
                    return;
                }
                wrappers.forEach(function(wrapper) {
                    var generateButton = _this.classConfig.shareCartGenerateButton(wrapper);
                    var copyButton = _this.classConfig.shareCartCopyButton(wrapper);
                    if (generateButton) {
                        generateButton.onclick = function() {
                            var partyValidationStatus = wrapper.getAttribute("data-party-validation-status");
                            var partySwitch = _this.classConfig.shareCartPartySwitch(wrapper);
                            if (sharecart_feature_config_1.shareCartPartyEnabled && (partySwitch === null || partySwitch === void 0 ? void 0 : partySwitch.checked) && (partyValidationStatus === "checking" || partyValidationStatus === "invalid")) {
                                return;
                            }
                            _this.generateShareCartState(wrapper);
                            _this.cartComponent.getCart(function(cartObj) {
                                var createShareCartData = _this.assembleSCData(cartObj, wrapper);
                                _this.generateShareCartURL(createShareCartData, function(shareCartInfo) {
                                    var _a, _b, _c;
                                    if (shareCartInfo && "data" in shareCartInfo && typeof shareCartInfo.data === "string") {
                                        _this.successShareCartState(wrapper);
                                        _this.handleCopyToClipboard(shareCartInfo.data, createShareCartData.share_cart_attributes || {}, wrapper);
                                    } else {
                                        _this.failureShareCartState(wrapper);
                                        (_b = (_a = _this.notification) === null || _a === void 0 ? void 0 : _a.showNotification) === null || _b === void 0 ? void 0 : _b.call(_a, notification_8.ENotificationType.error, "Share Cart Error", (shareCartInfo === null || shareCartInfo === void 0 ? void 0 : shareCartInfo.message) || ((_c = window === null || window === void 0 ? void 0 : window.stTranslations) === null || _c === void 0 ? void 0 : _c.generateShareCartError) || "Unable to generate share cart.");
                                    }
                                });
                            });
                        };
                    }
                    if (copyButton) {
                        copyButton.onclick = function() {
                            return __awaiter(_this, void 0, void 0, function() {
                                var copyInput, error_1;
                                var _a, _b;
                                return __generator(this, function(_c) {
                                    switch (_c.label) {
                                      case 0:
                                        copyInput = this.classConfig.shareCartCopyInput(wrapper);
                                        if (!copyInput) {
                                            return [ 2 ];
                                        }
                                        _c.label = 1;

                                      case 1:
                                        _c.trys.push([ 1, 3, , 4 ]);
                                        return [ 4, navigator.clipboard.writeText(copyInput.value) ];

                                      case 2:
                                        _c.sent();
                                        copyInput.select();
                                        copyInput.setSelectionRange(0, 99999);
                                        (_b = (_a = this.notification) === null || _a === void 0 ? void 0 : _a.showNotification) === null || _b === void 0 ? void 0 : _b.call(_a, notification_8.ENotificationType.success, "Copied to clipboard");
                                        return [ 3, 4 ];

                                      case 3:
                                        error_1 = _c.sent();
                                        return [ 3, 4 ];

                                      case 4:
                                        return [ 2 ];
                                    }
                                });
                            });
                        };
                    }
                });
            };
            _this.handleViewAllSharedCarts = function() {
                var wrappers = _this.classConfig.shareCartWrappers();
                if (!wrappers.length) {
                    return;
                }
                wrappers.forEach(function(wrapper) {
                    var viewAllLink = wrapper.querySelector(".st-share-cart__view-all-link_JS");
                    if (!viewAllLink || viewAllLink.dataset.stViewAllBound === "true") {
                        return;
                    }
                    viewAllLink.dataset.stViewAllBound = "true";
                    viewAllLink.onclick = function(event) {
                        event.preventDefault();
                        var currentUrl = new URL(window.location.href);
                        var als = currentUrl.searchParams.get(_features_config_13.aliasQueryParam) || localStorage.getItem("webAlias") || "";
                        var redirectUrl = new URL("".concat(window.location.origin, "/account"));
                        redirectUrl.searchParams.set("tab", "4");
                        if (als) {
                            redirectUrl.searchParams.set(_features_config_13.aliasQueryParam, als);
                        }
                        window.location.href = redirectUrl.toString();
                    };
                });
            };
            _this.updateGenerateButtonState = function(wrapper, status) {
                var generateButton = _this.classConfig.shareCartGenerateButton(wrapper);
                var partySwitch = _this.classConfig.shareCartPartySwitch(wrapper);
                if (!generateButton) {
                    return;
                }
                var shouldDisable = !!sharecart_feature_config_1.shareCartPartyEnabled && !!(partySwitch === null || partySwitch === void 0 ? void 0 : partySwitch.checked) && (status === "checking" || status === "invalid");
                generateButton.disabled = shouldDisable;
                generateButton.setAttribute("aria-disabled", String(shouldDisable));
            };
            _this.setPartyValidationState = function(wrapper, status) {
                var _a, _b;
                var feedback = wrapper.querySelector(".st-share-cart__party-feedback_JS");
                var successEl = wrapper.querySelector(".st-share-cart__party-feedback-success_JS");
                var errorEl = wrapper.querySelector(".st-share-cart__party-feedback-error_JS");
                var successText = wrapper.querySelector(".st-share-cart__party-feedback-text-success_JS");
                var errorText = wrapper.querySelector(".st-share-cart__party-feedback-text-error_JS");
                var partyInput = _this.classConfig.shareCartPartyInput(wrapper);
                var partyInputWrapper = partyInput === null || partyInput === void 0 ? void 0 : partyInput.closest(".st_label-primary");
                var loader = partyInputWrapper === null || partyInputWrapper === void 0 ? void 0 : partyInputWrapper.querySelector(".st_input-loader");
                var successMessage = (_a = window.stTranslations) === null || _a === void 0 ? void 0 : _a.shareCartPartySuccessText;
                var errorMessage = (_b = window.stTranslations) === null || _b === void 0 ? void 0 : _b.shareCartPartyErrorText;
                if (loader) {
                    loader.style.display = status === "checking" ? "inline-flex" : "none";
                }
                if (feedback) {
                    feedback.hidden = true;
                    feedback.style.display = "none";
                }
                if (successEl) {
                    successEl.hidden = true;
                    successEl.style.display = "none";
                }
                if (errorEl) {
                    errorEl.hidden = true;
                    errorEl.style.display = "none";
                }
                if (successText) {
                    successText.innerText = successMessage;
                }
                if (errorText) {
                    errorText.innerText = errorMessage;
                }
                if (status === "valid") {
                    if (feedback) {
                        feedback.hidden = false;
                        feedback.style.display = "block";
                    }
                    if (successEl) {
                        successEl.hidden = false;
                        successEl.style.display = "flex";
                    }
                }
                if (status === "invalid") {
                    if (feedback) {
                        feedback.hidden = false;
                        feedback.style.display = "block";
                    }
                    if (errorEl) {
                        errorEl.hidden = false;
                        errorEl.style.display = "block";
                    }
                }
                if (partyInput) {
                    partyInput.classList.remove("is-valid", "is-invalid");
                    if (status === "valid") {
                        partyInput.classList.add("is-valid");
                    }
                    if (status === "invalid") {
                        partyInput.classList.add("is-invalid");
                    }
                }
                wrapper.setAttribute("data-party-validation-status", status);
                _this.updateGenerateButtonState(wrapper, status);
            };
            _this.validatePartyId = function(partyId, callback) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["party"]["party-validation"],
                        method: "POST",
                        contentType: "json",
                        data: {
                            partyId: partyId
                        },
                        callback: function(res) {
                            var _a;
                            try {
                                var response = JSON.parse(res.response);
                                var isValid = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.isPartyOpen) === true;
                                callback(isValid);
                            } catch (error) {
                                callback(false);
                            }
                        }
                    });
                } catch (error) {
                    callback(false);
                }
            };
            _this.generateShareCartState = function(wrapper) {
                var form = _this.classConfig.shareCartForm(wrapper);
                var success = _this.classConfig.shareCartSuccess(wrapper);
                var loading = wrapper.querySelector(".st-share-cart__loading_JS");
                if (form) {
                    form.hidden = true;
                }
                if (success) {
                    success.hidden = true;
                }
                if (loading) {
                    loading.hidden = false;
                }
            };
            _this.successShareCartState = function(wrapper) {
                var form = _this.classConfig.shareCartForm(wrapper);
                var success = _this.classConfig.shareCartSuccess(wrapper);
                var loading = wrapper.querySelector(".st-share-cart__loading_JS");
                if (form) {
                    form.hidden = true;
                }
                if (success) {
                    success.hidden = false;
                }
                if (loading) {
                    loading.hidden = true;
                }
            };
            _this.failureShareCartState = function(wrapper) {
                var form = _this.classConfig.shareCartForm(wrapper);
                var success = _this.classConfig.shareCartSuccess(wrapper);
                var loading = wrapper.querySelector(".st-share-cart__loading_JS");
                if (form) {
                    form.hidden = false;
                }
                if (success) {
                    success.hidden = true;
                }
                if (loading) {
                    loading.hidden = true;
                }
            };
            _this.newShareCartState = function(wrapper) {
                var form = _this.classConfig.shareCartForm(wrapper);
                var success = _this.classConfig.shareCartSuccess(wrapper);
                var input = _this.classConfig.shareCartNameInput(wrapper);
                var saveSwitch = _this.classConfig.shareCartSaveSwitch(wrapper);
                var partySwitch = _this.classConfig.shareCartPartySwitch(wrapper);
                var partyField = _this.classConfig.shareCartPartyField(wrapper);
                var partyInput = _this.classConfig.shareCartPartyInput(wrapper);
                var copyInput = _this.classConfig.shareCartCopyInput(wrapper);
                var loading = wrapper.querySelector(".st-share-cart__loading_JS");
                if (form) {
                    form.hidden = false;
                }
                if (success) {
                    success.hidden = true;
                }
                if (loading) {
                    loading.hidden = true;
                }
                if (input) {
                    input.value = "";
                }
                if (saveSwitch) {
                    saveSwitch.checked = false;
                    localStorage.setItem("saveShareCart", "false");
                }
                if (partySwitch) {
                    partySwitch.checked = false;
                }
                if (partyField) {
                    partyField.hidden = true;
                }
                if (partyInput) {
                    partyInput.value = "";
                    partyInput.classList.remove("is-valid", "is-invalid");
                }
                if (copyInput) {
                    copyInput.value = "";
                }
                wrapper.removeAttribute("data-party-validation-request-id");
                _this.setPartyValidationState(wrapper, "idle");
            };
            _this.assembleSCData = function(cartObj, wrapper) {
                var _a, _b, _c;
                var appWindow = window;
                var nameInput = _this.classConfig.shareCartNameInput(wrapper);
                var saveSwitch = _this.classConfig.shareCartSaveSwitch(wrapper);
                var partySwitch = _this.classConfig.shareCartPartySwitch(wrapper);
                var partyInput = _this.classConfig.shareCartPartyInput(wrapper);
                var isSaved = (saveSwitch === null || saveSwitch === void 0 ? void 0 : saveSwitch.checked) === true;
                var partyId = sharecart_feature_config_1.shareCartPartyEnabled && (partySwitch === null || partySwitch === void 0 ? void 0 : partySwitch.checked) ? ((_a = partyInput === null || partyInput === void 0 ? void 0 : partyInput.value) === null || _a === void 0 ? void 0 : _a.trim()) || "" : "";
                var currentUrl = new URL(window.location.href);
                var activeRepId = currentUrl.searchParams.get(_features_config_13.repIdParam) || localStorage.getItem("repId") || localStorage.getItem("ref") || "";
                var activeWebAlias = currentUrl.searchParams.get(_features_config_13.webAliasParam) || currentUrl.searchParams.get(_features_config_13.aliasQueryParam) || localStorage.getItem("webAlias") || "";
                var createShareCartData = {
                    owner_shopify_id: appWindow.customerShopifyId || "",
                    owner_shopify_email: appWindow.customerShopifyEmail || "",
                    expiration_date: "9999-12-31",
                    share_cart_attributes: __assign(__assign(__assign(__assign({}, (cartObj === null || cartObj === void 0 ? void 0 : cartObj.attributes) || {}), activeRepId ? {
                        sponsorRepId: activeRepId,
                        repId: activeRepId
                    } : {}), activeWebAlias ? {
                        sponsorWebAlias: activeWebAlias,
                        webAlias: activeWebAlias
                    } : {}), sharecart_feature_config_1.shareCartPartyEnabled && partyId ? {
                        partyId: partyId
                    } : {}),
                    discount_codes: (cartObj === null || cartObj === void 0 ? void 0 : cartObj.discount_codes) || [],
                    line_items: [],
                    share_cart_miscfields: {},
                    name: sharecart_feature_config_1.shareCartNameEnabled ? ((_b = nameInput === null || nameInput === void 0 ? void 0 : nameInput.value) === null || _b === void 0 ? void 0 : _b.trim()) || "" : "",
                    is_saved: isSaved,
                    is_active: true,
                    party_id: sharecart_feature_config_1.shareCartPartyEnabled ? partyId : ""
                };
                if (sharecart_feature_config_1.shareCartPartyEnabled && ((_c = cartObj === null || cartObj === void 0 ? void 0 : cartObj.attributes) === null || _c === void 0 ? void 0 : _c.partyId)) {
                    var pamperStorage = localStorage.getItem("pamper");
                    if (pamperStorage) {
                        try {
                            var pamperAttributes = JSON.parse(pamperStorage);
                            if (pamperAttributes === null || pamperAttributes === void 0 ? void 0 : pamperAttributes.partyName) {
                                createShareCartData.share_cart_miscfields = __assign(__assign({}, createShareCartData.share_cart_miscfields), {
                                    partyName: pamperAttributes.partyName
                                });
                            }
                        } catch (error) {}
                    }
                }
                var lineItems = ((cartObj === null || cartObj === void 0 ? void 0 : cartObj.items) || []).map(function(item) {
                    return {
                        sku: item.sku,
                        shopify_variant_id: item.variant_id,
                        quantity: item.quantity,
                        line_item_properties: item.properties || {}
                    };
                });
                createShareCartData.line_items = lineItems;
                return createShareCartData;
            };
            _this.handleCopyToClipboard = function(cartToken, shareCartAttributes, wrapper) {
                var shareCartCopyInput = _this.classConfig.shareCartCopyInput(wrapper);
                if (!shareCartCopyInput) {
                    return;
                }
                var currentUrl = new URL(window.location.href);
                var sponsorRepId = (shareCartAttributes === null || shareCartAttributes === void 0 ? void 0 : shareCartAttributes.sponsorRepId) || (shareCartAttributes === null || shareCartAttributes === void 0 ? void 0 : shareCartAttributes.repId) || currentUrl.searchParams.get(_features_config_13.repIdParam) || localStorage.getItem("repId") || localStorage.getItem("ref") || "";
                var shareCartLink = new URL(location.origin);
                if (sponsorRepId) {
                    shareCartLink.searchParams.set(_features_config_13.webAliasParam, sponsorRepId);
                }
                shareCartLink.searchParams.set("share_cart_token", cartToken);
                shareCartCopyInput.value = shareCartLink.toString();
                shareCartCopyInput.setAttribute("value", shareCartLink.toString());
            };
            _this.handleShortendURLClick = function() {};
            _this.generateShareCartURL = function(data, handleResponse) {
                var _a;
                var appWindow = window;
                var shareCartUrl = (_a = appWindow === null || appWindow === void 0 ? void 0 : appWindow.stAppConfig) === null || _a === void 0 ? void 0 : _a.shareCartUrl;
                var apiUrl = "".concat(shareCartUrl, "/share-cart/createShareCart");
                var requestOptions = {
                    method: "POST",
                    headers: {
                        "x-api-key": _this.shareCartApiKey,
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                };
                fetch(apiUrl, requestOptions).then(function(response) {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                }).then(function(responseData) {
                    var _a, _b;
                    if (responseData.statusCode !== 200 && responseData.statusCode !== 201) {
                        (_b = (_a = _this.notification) === null || _a === void 0 ? void 0 : _a.showNotification) === null || _b === void 0 ? void 0 : _b.call(_a, notification_8.ENotificationType.error, "Share Cart Error", responseData.message || "Unable to generate share cart.");
                    }
                    handleResponse(responseData);
                }).catch(function(error) {
                    var _a, _b, _c;
                    console.error(error);
                    (_b = (_a = _this.notification) === null || _a === void 0 ? void 0 : _a.showNotification) === null || _b === void 0 ? void 0 : _b.call(_a, notification_8.ENotificationType.error, "Share Cart Error", ((_c = appWindow === null || appWindow === void 0 ? void 0 : appWindow.stTranslations) === null || _c === void 0 ? void 0 : _c.generateShareCartError) || "Unable to generate share cart.");
                    handleResponse(null);
                });
            };
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            _this.cartComponent = cartComponent;
            _this.objectFormatting = objectFormatting;
            _this.notification = notification;
            return _this;
        }
        Object.defineProperty(StShareCartDrawer.prototype, "shareCartApiKey", {
            get: function() {
                var shareCartKey = window.shareCartApiKey;
                return shareCartKey;
            },
            enumerable: false,
            configurable: true
        });
        return StShareCartDrawer;
    }(st_module_59.StModule);
    exports.StShareCartDrawer = StShareCartDrawer;
});

define("core/shopify-app/st-modules/account/blocks/account-share-cart/account-share-cart-utils", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_60, _features_config_14) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountShareCartUtils = void 0;
    var StAccountShareCartUtils = function(_super) {
        __extends(StAccountShareCartUtils, _super);
        function StAccountShareCartUtils(generalMethods, objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StAccountShareCartUtils";
            _this.padNumbers = function(num) {
                return num < 10 ? "0".concat(num) : "".concat(num);
            };
            _this.formatShareCartDate = function(isoDate) {
                if (!isoDate) {
                    return "-";
                }
                var date = new Date(isoDate);
                if (Number.isNaN(date.getTime())) {
                    return "-";
                }
                var day = _this.padNumbers(date.getUTCDate());
                var month = _this.padNumbers(date.getUTCMonth() + 1);
                var year = date.getUTCFullYear();
                return "".concat(day, "/").concat(month, "/").concat(year);
            };
            _this.escapeHtml = function(value) {
                var stringValue = "".concat(value !== null && value !== void 0 ? value : "");
                return stringValue.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
            };
            _this.getWrapper = function() {
                return document.querySelector(".st-account-share-cart_JS");
            };
            _this.getListWrapper = function() {
                return document.querySelector(".st-account-share-cart__list_JS");
            };
            _this.getShareCartId = function(targetButton) {
                var shareCartCard = _this.generalMethods.getClosestByClass(targetButton, "st-account-share-cart-card_JS");
                return (shareCartCard === null || shareCartCard === void 0 ? void 0 : shareCartCard.getAttribute("data-share-cart-id")) || "";
            };
            _this.getShareCartTitle = function(shareCart) {
                var name = shareCart === null || shareCart === void 0 ? void 0 : shareCart.name;
                if (typeof name === "string" && name.trim() !== "") {
                    return name.trim();
                }
                var cartId = (shareCart === null || shareCart === void 0 ? void 0 : shareCart.cartId) || (shareCart === null || shareCart === void 0 ? void 0 : shareCart.id) || "";
                return cartId ? "Cart ".concat(cartId) : "Shared Cart";
            };
            _this.getPartyName = function(shareCart) {
                var shareCartAttributes = (shareCart === null || shareCart === void 0 ? void 0 : shareCart.share_cart_attributes) || {};
                var shareCartMiscFields = (shareCart === null || shareCart === void 0 ? void 0 : shareCart.share_cart_miscfields) || {};
                return shareCartMiscFields.partyName || shareCartAttributes.partyName || shareCartAttributes.party_id || shareCartAttributes.partyId || (shareCart === null || shareCart === void 0 ? void 0 : shareCart.party_id) || "-";
            };
            _this.getLinkUsedCount = function(shareCart) {
                var _a, _b, _c;
                return Number((_c = (_b = (_a = shareCart === null || shareCart === void 0 ? void 0 : shareCart.impressions) !== null && _a !== void 0 ? _a : shareCart === null || shareCart === void 0 ? void 0 : shareCart.link_used) !== null && _b !== void 0 ? _b : shareCart === null || shareCart === void 0 ? void 0 : shareCart.linkUsed) !== null && _c !== void 0 ? _c : 0);
            };
            _this.getOrdersCount = function(shareCart) {
                var _a, _b, _c;
                return Number((_c = (_b = (_a = shareCart === null || shareCart === void 0 ? void 0 : shareCart.completed_purchases) !== null && _a !== void 0 ? _a : shareCart === null || shareCart === void 0 ? void 0 : shareCart.orders_count) !== null && _b !== void 0 ? _b : shareCart === null || shareCart === void 0 ? void 0 : shareCart.number_of_orders) !== null && _c !== void 0 ? _c : 0);
            };
            _this.shareCartLink = function(cartToken, shareCartAttributes) {
                if (shareCartAttributes === void 0) {
                    shareCartAttributes = {};
                }
                if (!cartToken) {
                    return "";
                }
                var repId = (shareCartAttributes === null || shareCartAttributes === void 0 ? void 0 : shareCartAttributes.repId) || "";
                return repId ? "".concat(location.origin, "?").concat(_features_config_14.webAliasParam, "=").concat(repId, "&share_cart_token=").concat(cartToken) : "".concat(location.origin, "?share_cart_token=").concat(cartToken);
            };
            _this.getTranslation = function(key, fallback) {
                var _a;
                if (fallback === void 0) {
                    fallback = "";
                }
                return ((_a = window === null || window === void 0 ? void 0 : window.stTranslations) === null || _a === void 0 ? void 0 : _a[key]) || fallback;
            };
            _this.copyShareCartLink = function(copyButton) {
                return __awaiter(_this, void 0, void 0, function() {
                    var shareCartUrl, error_2;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            shareCartUrl = copyButton.getAttribute("data-share-cart-url") || "";
                            if (!shareCartUrl) {
                                return [ 2 ];
                            }
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 3, , 4 ]);
                            return [ 4, navigator.clipboard.writeText(shareCartUrl) ];

                          case 2:
                            _a.sent();
                            copyButton.setAttribute("disabled", "disabled");
                            setTimeout(function() {
                                copyButton.removeAttribute("disabled");
                            }, 1200);
                            return [ 3, 4 ];

                          case 3:
                            error_2 = _a.sent();
                            console.error(error_2);
                            return [ 3, 4 ];

                          case 4:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.toggleMenu = function(menuTrigger) {
                var menuWrapper = _this.generalMethods.getClosestByClass(menuTrigger, "st-account-share-cart-card__menu_JS");
                if (!menuWrapper) {
                    return;
                }
                var isOpen = menuWrapper.classList.contains("is-open");
                _this.closeAllMenus();
                menuWrapper.classList.toggle("is-open", !isOpen);
                menuTrigger.setAttribute("aria-expanded", (!isOpen).toString());
            };
            _this.closeAllMenus = function() {
                var menus = document.querySelectorAll(".st-account-share-cart-card__menu_JS");
                menus.forEach(function(menu) {
                    menu.classList.remove("is-open");
                    var trigger = menu.querySelector(".st-account-share-cart-card__menu-trigger_JS");
                    if (trigger) {
                        trigger.setAttribute("aria-expanded", "false");
                    }
                });
            };
            _this.normalizeLineItems = function(shareCartDetail) {
                var _a, _b;
                if (Array.isArray(shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.line_items)) {
                    return shareCartDetail.line_items;
                }
                if (Array.isArray(shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.items)) {
                    return shareCartDetail.items;
                }
                if (Array.isArray((_a = shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.cart) === null || _a === void 0 ? void 0 : _a.items)) {
                    return shareCartDetail.cart.items;
                }
                if (Array.isArray((_b = shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.cart) === null || _b === void 0 ? void 0 : _b.line_items)) {
                    return shareCartDetail.cart.line_items;
                }
                return [];
            };
            _this.getLineItemTitle = function(lineItem) {
                return (lineItem === null || lineItem === void 0 ? void 0 : lineItem.title) || (lineItem === null || lineItem === void 0 ? void 0 : lineItem.product_title) || (lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant_title) || (lineItem === null || lineItem === void 0 ? void 0 : lineItem.name) || "Product";
            };
            _this.getLineItemImage = function(lineItem) {
                var _a, _b;
                return (lineItem === null || lineItem === void 0 ? void 0 : lineItem.thumbnail) || (lineItem === null || lineItem === void 0 ? void 0 : lineItem.image) || ((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant) === null || _a === void 0 ? void 0 : _a.image) || ((_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.product) === null || _b === void 0 ? void 0 : _b.thumbnail) || "";
            };
            _this.getLineItemQty = function(lineItem) {
                var _a, _b;
                return Number((_b = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.quantity) !== null && _a !== void 0 ? _a : lineItem === null || lineItem === void 0 ? void 0 : lineItem.qty) !== null && _b !== void 0 ? _b : 0);
            };
            _this.getLineItemUnitPrice = function(lineItem) {
                var _a, _b, _c, _d;
                return Number((_d = (_b = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.unit_price) !== null && _a !== void 0 ? _a : lineItem === null || lineItem === void 0 ? void 0 : lineItem.price) !== null && _b !== void 0 ? _b : (_c = lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant) === null || _c === void 0 ? void 0 : _c.price) !== null && _d !== void 0 ? _d : 0);
            };
            _this.getLineItemTotal = function(lineItem) {
                var _a, _b;
                return Number((_b = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.line_total) !== null && _a !== void 0 ? _a : lineItem === null || lineItem === void 0 ? void 0 : lineItem.total) !== null && _b !== void 0 ? _b : _this.getLineItemUnitPrice(lineItem) * _this.getLineItemQty(lineItem));
            };
            _this.getShareCartTotal = function(shareCartDetail) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var directTotal = Number((_h = (_f = (_d = (_c = (_b = (_a = shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.total) !== null && _a !== void 0 ? _a : shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.cart_total) !== null && _b !== void 0 ? _b : shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.grand_total) !== null && _c !== void 0 ? _c : shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.total_price) !== null && _d !== void 0 ? _d : (_e = shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.cart) === null || _e === void 0 ? void 0 : _e.total) !== null && _f !== void 0 ? _f : (_g = shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.cart) === null || _g === void 0 ? void 0 : _g.total_price) !== null && _h !== void 0 ? _h : 0);
                if (directTotal) {
                    return directTotal;
                }
                return _this.normalizeLineItems(shareCartDetail).reduce(function(sum, lineItem) {
                    return sum + _this.getLineItemTotal(lineItem);
                }, 0);
            };
            _this.formatMoney = function(value) {
                var _a, _b;
                if (typeof value === "string" && /[£$€]/.test(value)) {
                    return value;
                }
                var numericValue = Number(value !== null && value !== void 0 ? value : 0);
                var currencyCode = ((_b = (_a = window === null || window === void 0 ? void 0 : window.Shopify) === null || _a === void 0 ? void 0 : _a.currency) === null || _b === void 0 ? void 0 : _b.active) || "GBP";
                return new Intl.NumberFormat(undefined, {
                    style: "currency",
                    currency: currencyCode,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(Number.isNaN(numericValue) ? 0 : numericValue);
            };
            _this.generalMethods = generalMethods;
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StAccountShareCartUtils;
    }(st_module_60.StModule);
    exports.StAccountShareCartUtils = StAccountShareCartUtils;
});

define("core/shopify-app/st-modules/account/blocks/account-share-cart/account-share-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/share-cart/sharecart.feature.config" ], function(require, exports, st_module_61, sharecart_feature_config_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountShareCart = void 0;
    var StAccountShareCart = function(_super) {
        __extends(StAccountShareCart, _super);
        function StAccountShareCart(objectFormatting, generalMethods, cartComponent, accountShareCartUtils) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StAccountShareCart";
            _this.currentPage = 1;
            _this.itemsPerPage = 5;
            _this.backendItemsPerPage = 25;
            _this.paginationBound = false;
            _this.hasNextPage = false;
            _this.lastLoadedCount = 0;
            _this.editNameModalBound = false;
            _this.activeEditShareCartId = "";
            _this.isSubmittingEditName = false;
            _this.deleteModalBound = false;
            _this.activeDeleteShareCartId = "";
            _this.isSubmittingDeleteShareCart = false;
            _this.shareCartDetailsCache = {};
            _this.init = function() {
                if (!sharecart_feature_config_2.shareCartEnabled || !sharecart_feature_config_2.shareCartAccountDashboardEnabled) {
                    return;
                }
                _this.subscribeDOMLoaded(function() {
                    var wrapper = _this.accountShareCartUtils.getWrapper();
                    var listWrapper = _this.accountShareCartUtils.getListWrapper();
                    if (!wrapper || !listWrapper) {
                        return;
                    }
                    _this.ensureSingleShareCartExists();
                    _this.ensureEditNameModalExists();
                    _this.ensureDeleteModalExists();
                    _this.fetchAndRenderShareCarts(1);
                    _this.bindPaginationHandlers();
                    _this.bindCreateNewCartButton();
                    _this.bindOutsideClick();
                    _this.bindSingleShareCartOutsideClick();
                    _this.handleMenuCloseClick();
                    _this.backToHistoryShareCarts();
                    _this.bindEditNameModalEvents();
                    _this.bindDeleteModalEvents();
                });
            };
            _this.ensureSingleShareCartExists = function() {
                var _a;
                var wrapper = _this.accountShareCartUtils.getWrapper();
                if (!wrapper) {
                    return;
                }
                var existingSingle = wrapper.querySelector(".st-account-single-share-cart_JS");
                if (existingSingle) {
                    return;
                }
                var template = document.getElementById("st-account-single-share-cart-template");
                if (!template) {
                    return;
                }
                var fragment = ((_a = template.content) !== null && _a !== void 0 ? _a : template).cloneNode(true);
                wrapper.appendChild(fragment);
            };
            _this.ensureEditNameModalExists = function() {
                var _a;
                var wrapper = _this.accountShareCartUtils.getWrapper();
                if (!wrapper) {
                    return;
                }
                var existingModal = wrapper.querySelector(".st-account-share-cart-edit-modal_JS");
                if (existingModal) {
                    return;
                }
                var template = document.getElementById("st-account-share-cart-edit-name-modal-template");
                if (!template) {
                    return;
                }
                var fragment = ((_a = template.content) !== null && _a !== void 0 ? _a : template).cloneNode(true);
                wrapper.appendChild(fragment);
            };
            _this.ensureDeleteModalExists = function() {
                var _a;
                var wrapper = _this.accountShareCartUtils.getWrapper();
                if (!wrapper) {
                    return;
                }
                var existingModal = wrapper.querySelector(".st-account-share-cart-delete-modal_JS");
                if (existingModal) {
                    return;
                }
                var template = document.getElementById("st-account-share-cart-delete-modal-template");
                if (!template) {
                    return;
                }
                var fragment = ((_a = template.content) !== null && _a !== void 0 ? _a : template).cloneNode(true);
                wrapper.appendChild(fragment);
            };
            _this.fetchAndRenderShareCarts = function(page) {
                if (page === void 0) {
                    page = _this.currentPage;
                }
                return __awaiter(_this, void 0, void 0, function() {
                    var listWrapper, responseData, allShareCarts, savedShareCarts, start, end, shareCarts, error_3;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            listWrapper = this.accountShareCartUtils.getListWrapper();
                            if (!listWrapper) {
                                return [ 2 ];
                            }
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 6, , 7 ]);
                            listWrapper.innerHTML = this.generateLoadingState();
                            return [ 4, this.fetchShareCarts() ];

                          case 2:
                            responseData = _a.sent();
                            allShareCarts = this.normalizeShareCartsResponse(responseData);
                            savedShareCarts = allShareCarts.filter(function(shareCart) {
                                return (shareCart === null || shareCart === void 0 ? void 0 : shareCart.is_saved) === true;
                            });
                            this.currentPage = Math.max(1, page);
                            start = (this.currentPage - 1) * this.itemsPerPage;
                            end = start + this.itemsPerPage;
                            shareCarts = savedShareCarts.slice(start, end);
                            this.lastLoadedCount = shareCarts.length;
                            this.hasNextPage = end < savedShareCarts.length;
                            if (!(!shareCarts.length && this.currentPage > 1)) return [ 3, 4 ];
                            return [ 4, this.fetchAndRenderShareCarts(this.currentPage - 1) ];

                          case 3:
                            _a.sent();
                            return [ 2 ];

                          case 4:
                            if (!shareCarts.length) {
                                listWrapper.innerHTML = this.generateEmptyState();
                                this.renderPagination();
                                return [ 2 ];
                            }
                            return [ 4, this.renderShareCartCards(shareCarts) ];

                          case 5:
                            _a.sent();
                            this.renderPagination();
                            return [ 3, 7 ];

                          case 6:
                            error_3 = _a.sent();
                            console.error("[StAccountShareCart] fetch share carts error:", error_3);
                            listWrapper.innerHTML = this.generateErrorState();
                            this.renderPagination();
                            return [ 3, 7 ];

                          case 7:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.fetchShareCarts = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var appWindow, shareCartUrl, shopifyCustomerId, apiUrl, response;
                    var _a;
                    return __generator(this, function(_b) {
                        switch (_b.label) {
                          case 0:
                            appWindow = window;
                            shareCartUrl = ((_a = appWindow === null || appWindow === void 0 ? void 0 : appWindow.stAppConfig) === null || _a === void 0 ? void 0 : _a.shareCartUrl) || "";
                            shopifyCustomerId = (appWindow === null || appWindow === void 0 ? void 0 : appWindow.customerShopifyId) || "";
                            if (!shareCartUrl || !shopifyCustomerId) {
                                return [ 2, [] ];
                            }
                            apiUrl = "".concat(shareCartUrl, "/share-cart/getAllShareCarts/").concat(shopifyCustomerId, "?page=1&itemsPerPage=").concat(this.backendItemsPerPage);
                            return [ 4, fetch(apiUrl, {
                                method: "GET",
                                headers: {
                                    "x-api-key": this.shareCartApiKey || "",
                                    "Content-Type": "application/json"
                                }
                            }) ];

                          case 1:
                            response = _b.sent();
                            if (!response.ok) {
                                throw new Error("Failed to fetch share carts. Status: ".concat(response.status));
                            }
                            return [ 2, response.json() ];
                        }
                    });
                });
            };
            _this.fetchShareCartById = function(shareCartId) {
                return __awaiter(_this, void 0, void 0, function() {
                    var appWindow, shareCartUrl, shopifyCustomerId, apiUrl, response;
                    var _a;
                    return __generator(this, function(_b) {
                        switch (_b.label) {
                          case 0:
                            appWindow = window;
                            shareCartUrl = ((_a = appWindow === null || appWindow === void 0 ? void 0 : appWindow.stAppConfig) === null || _a === void 0 ? void 0 : _a.shareCartUrl) || "";
                            shopifyCustomerId = (appWindow === null || appWindow === void 0 ? void 0 : appWindow.customerShopifyId) || "";
                            if (!shareCartUrl || !shareCartId) {
                                return [ 2, {} ];
                            }
                            apiUrl = "".concat(shareCartUrl, "/share-cart/getShareCartById/").concat(shareCartId, "?shopifyCustomerId=").concat(shopifyCustomerId);
                            return [ 4, fetch(apiUrl, {
                                method: "GET",
                                headers: {
                                    "x-api-key": this.shareCartApiKey || "",
                                    "Content-Type": "application/json"
                                }
                            }) ];

                          case 1:
                            response = _b.sent();
                            if (!response.ok) {
                                throw new Error("Failed to fetch share cart detail. Status: ".concat(response.status));
                            }
                            return [ 2, response.json() ];
                        }
                    });
                });
            };
            _this.updateShareCartName = function(shareCartId, shareCart, nextName) {
                return __awaiter(_this, void 0, void 0, function() {
                    var appWindow, shareCartUrl, shopifyCustomerId, lineItems, body, apiUrl, response, responseData;
                    var _a, _b, _c, _d;
                    return __generator(this, function(_e) {
                        switch (_e.label) {
                          case 0:
                            appWindow = window;
                            shareCartUrl = ((_a = appWindow === null || appWindow === void 0 ? void 0 : appWindow.stAppConfig) === null || _a === void 0 ? void 0 : _a.shareCartUrl) || "";
                            shopifyCustomerId = (appWindow === null || appWindow === void 0 ? void 0 : appWindow.customerShopifyId) || "";
                            if (!shareCartUrl || !shopifyCustomerId || !shareCartId) {
                                throw new Error("Missing share cart configuration.");
                            }
                            lineItems = this.getLineItemsForUpdate(shareCart);
                            body = {
                                optional: {
                                    name: nextName,
                                    is_saved: (_b = shareCart === null || shareCart === void 0 ? void 0 : shareCart.is_saved) !== null && _b !== void 0 ? _b : true,
                                    is_active: (_c = shareCart === null || shareCart === void 0 ? void 0 : shareCart.is_active) !== null && _c !== void 0 ? _c : true,
                                    party_id: (_d = shareCart === null || shareCart === void 0 ? void 0 : shareCart.party_id) !== null && _d !== void 0 ? _d : ""
                                },
                                owner_shopify_id: Number((shareCart === null || shareCart === void 0 ? void 0 : shareCart.owner_shopify_id) || shopifyCustomerId),
                                owner_shopify_email: (shareCart === null || shareCart === void 0 ? void 0 : shareCart.owner_shopify_email) || "",
                                expiration_date: (shareCart === null || shareCart === void 0 ? void 0 : shareCart.expiration_date) || (shareCart === null || shareCart === void 0 ? void 0 : shareCart.expirationDate) || "9999-12-31",
                                share_cart_attributes: (shareCart === null || shareCart === void 0 ? void 0 : shareCart.share_cart_attributes) || {},
                                discount_codes: (shareCart === null || shareCart === void 0 ? void 0 : shareCart.discount_codes) || [],
                                line_items: lineItems,
                                share_cart_miscfields: (shareCart === null || shareCart === void 0 ? void 0 : shareCart.share_cart_miscfields) || {}
                            };
                            apiUrl = "".concat(shareCartUrl, "/share-cart/updateShareCart/").concat(shareCartId, "/").concat(shopifyCustomerId);
                            return [ 4, fetch(apiUrl, {
                                method: "PATCH",
                                headers: {
                                    "x-api-key": this.shareCartApiKey || "",
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify(body)
                            }) ];

                          case 1:
                            response = _e.sent();
                            return [ 4, response.json() ];

                          case 2:
                            responseData = _e.sent();
                            if (!response.ok) {
                                throw new Error((responseData === null || responseData === void 0 ? void 0 : responseData.message) || "Failed to update share cart. Status: ".concat(response.status));
                            }
                            if (Number(responseData === null || responseData === void 0 ? void 0 : responseData.statusCode) >= 400) {
                                throw new Error((responseData === null || responseData === void 0 ? void 0 : responseData.message) || "Failed to update share cart.");
                            }
                            return [ 2, responseData ];
                        }
                    });
                });
            };
            _this.deleteShareCart = function(shareCartId) {
                return __awaiter(_this, void 0, void 0, function() {
                    var appWindow, shareCartUrl, shopifyCustomerId, apiUrl, response, responseData;
                    var _a;
                    return __generator(this, function(_b) {
                        switch (_b.label) {
                          case 0:
                            appWindow = window;
                            shareCartUrl = ((_a = appWindow === null || appWindow === void 0 ? void 0 : appWindow.stAppConfig) === null || _a === void 0 ? void 0 : _a.shareCartUrl) || "";
                            shopifyCustomerId = (appWindow === null || appWindow === void 0 ? void 0 : appWindow.customerShopifyId) || "";
                            if (!shareCartUrl || !shopifyCustomerId || !shareCartId) {
                                throw new Error("Missing share cart configuration.");
                            }
                            apiUrl = "".concat(shareCartUrl, "/share-cart/deleteShareCart/").concat(shareCartId, "?shopifyCustomerId=").concat(shopifyCustomerId);
                            return [ 4, fetch(apiUrl, {
                                method: "DELETE",
                                headers: {
                                    "x-api-key": this.shareCartApiKey || ""
                                }
                            }) ];

                          case 1:
                            response = _b.sent();
                            return [ 4, response.json() ];

                          case 2:
                            responseData = _b.sent();
                            if (!response.ok) {
                                throw new Error((responseData === null || responseData === void 0 ? void 0 : responseData.message) || "Failed to delete share cart. Status: ".concat(response.status));
                            }
                            if (Number(responseData === null || responseData === void 0 ? void 0 : responseData.statusCode) >= 400) {
                                throw new Error((responseData === null || responseData === void 0 ? void 0 : responseData.message) || "Failed to delete share cart.");
                            }
                            return [ 2, responseData ];
                        }
                    });
                });
            };
            _this.normalizeShareCartsResponse = function(responseData) {
                if (Array.isArray(responseData)) {
                    return responseData;
                }
                if (Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.orderList)) {
                    return responseData.orderList;
                }
                if (Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.shareCarts)) {
                    return responseData.shareCarts;
                }
                if (Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.carts)) {
                    return responseData.carts;
                }
                if (Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.items)) {
                    return responseData.items;
                }
                if (Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.data)) {
                    return responseData.data;
                }
                if ((responseData === null || responseData === void 0 ? void 0 : responseData.data) && !Array.isArray(responseData.data)) {
                    if (Array.isArray(responseData.data.data)) {
                        return responseData.data.data;
                    }
                    if (Array.isArray(responseData.data.items)) {
                        return responseData.data.items;
                    }
                }
                return [];
            };
            _this.normalizePaginationResponse = function(responseData) {
                var _a;
                if (!responseData || Array.isArray(responseData)) {
                    return {};
                }
                if (responseData === null || responseData === void 0 ? void 0 : responseData.pagination) {
                    return responseData.pagination;
                }
                if ((responseData === null || responseData === void 0 ? void 0 : responseData.data) && !Array.isArray(responseData.data) && ((_a = responseData.data) === null || _a === void 0 ? void 0 : _a.pagination)) {
                    return responseData.data.pagination;
                }
                return {};
            };
            _this.normalizeSingleShareCartResponse = function(responseData) {
                if (!responseData) {
                    return {};
                }
                if (responseData === null || responseData === void 0 ? void 0 : responseData.shareCart) {
                    return responseData.shareCart;
                }
                if (responseData === null || responseData === void 0 ? void 0 : responseData.cart) {
                    return responseData.cart;
                }
                if (responseData === null || responseData === void 0 ? void 0 : responseData.item) {
                    return responseData.item;
                }
                if (responseData === null || responseData === void 0 ? void 0 : responseData.data) {
                    return responseData.data;
                }
                return responseData;
            };
            _this.generateLoadingState = function() {
                return '\n            <div class="st-account-share-cart__message st-account-share-cart__message--loading">\n                '.concat(_this.accountShareCartUtils.escapeHtml(_this.accountShareCartUtils.getTranslation("loadingText", "Loading...")), "\n            </div>\n        ");
            };
            _this.generateEmptyState = function() {
                return '\n            <div class="st-account-share-cart__message st-account-share-cart__message--empty">\n                '.concat(_this.accountShareCartUtils.escapeHtml(_this.accountShareCartUtils.getTranslation("noSharedCartsText", "No shared carts found.")), "\n            </div>\n        ");
            };
            _this.generateErrorState = function() {
                return '\n            <div class="st-account-share-cart__message st-account-share-cart__message--error">\n                '.concat(_this.accountShareCartUtils.escapeHtml(_this.accountShareCartUtils.getTranslation("shareCartViewError", "Something went wrong while loading shared carts.")), "\n            </div>\n        ");
            };
            _this.renderShareCartCards = function(shareCarts) {
                return __awaiter(_this, void 0, void 0, function() {
                    var listWrapper, cards;
                    var _this = this;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            listWrapper = this.accountShareCartUtils.getListWrapper();
                            if (!listWrapper) {
                                return [ 2 ];
                            }
                            listWrapper.innerHTML = "";
                            return [ 4, Promise.all(shareCarts.map(function(shareCart) {
                                return _this.createShareCartCardElement(shareCart);
                            })) ];

                          case 1:
                            cards = _a.sent();
                            cards.forEach(function(card) {
                                if (card) {
                                    listWrapper.appendChild(card);
                                }
                            });
                            this.bindCardEvents();
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.resolveShareCartCardSubtotal = function(shareCart) {
                return __awaiter(_this, void 0, void 0, function() {
                    var cartId, subtotalFromList, response, shareCartDetail;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            cartId = (shareCart === null || shareCart === void 0 ? void 0 : shareCart.shareCartId) || (shareCart === null || shareCart === void 0 ? void 0 : shareCart.cartId) || (shareCart === null || shareCart === void 0 ? void 0 : shareCart._id) || (shareCart === null || shareCart === void 0 ? void 0 : shareCart.id) || "";
                            subtotalFromList = this.getShareCartTotal(shareCart);
                            if (subtotalFromList > 0) {
                                return [ 2, subtotalFromList ];
                            }
                            if (!cartId) {
                                return [ 2, 0 ];
                            }
                            if (this.shareCartDetailsCache[String(cartId)]) {
                                return [ 2, this.getShareCartTotal(this.shareCartDetailsCache[String(cartId)]) ];
                            }
                            return [ 4, this.fetchShareCartById(String(cartId)) ];

                          case 1:
                            response = _a.sent();
                            shareCartDetail = this.normalizeSingleShareCartResponse(response);
                            this.shareCartDetailsCache[String(cartId)] = shareCartDetail;
                            return [ 2, this.getShareCartTotal(shareCartDetail) ];
                        }
                    });
                });
            };
            _this.createShareCartCardElement = function(shareCart) {
                return __awaiter(_this, void 0, void 0, function() {
                    var template, fragment, card, cartId, title, date, partyName, linkUsed, ordersCount, subtotal, publicLink, titleEl, dateEl, linkUsedEl, ordersEl, partyNameEl, subtotalEl, linkEl, copyBtn, viewBtn, editBtn, deleteBtn;
                    var _a;
                    return __generator(this, function(_b) {
                        switch (_b.label) {
                          case 0:
                            template = document.getElementById("st-account-share-cart-card-template");
                            if (!template) {
                                return [ 2, null ];
                            }
                            fragment = ((_a = template.content) !== null && _a !== void 0 ? _a : template).cloneNode(true);
                            card = fragment.querySelector(".st-account-share-cart-card_JS");
                            if (!card) {
                                return [ 2, null ];
                            }
                            cartId = (shareCart === null || shareCart === void 0 ? void 0 : shareCart.shareCartId) || (shareCart === null || shareCart === void 0 ? void 0 : shareCart.cartId) || (shareCart === null || shareCart === void 0 ? void 0 : shareCart._id) || (shareCart === null || shareCart === void 0 ? void 0 : shareCart.id) || "";
                            title = this.accountShareCartUtils.getShareCartTitle(shareCart);
                            date = this.accountShareCartUtils.formatShareCartDate(shareCart === null || shareCart === void 0 ? void 0 : shareCart.created_at);
                            partyName = this.accountShareCartUtils.getPartyName(shareCart);
                            linkUsed = this.accountShareCartUtils.getLinkUsedCount(shareCart);
                            ordersCount = this.accountShareCartUtils.getOrdersCount(shareCart);
                            return [ 4, this.resolveShareCartCardSubtotal(shareCart) ];

                          case 1:
                            subtotal = _b.sent();
                            publicLink = this.accountShareCartUtils.shareCartLink((shareCart === null || shareCart === void 0 ? void 0 : shareCart.cart_token) || "", (shareCart === null || shareCart === void 0 ? void 0 : shareCart.share_cart_attributes) || {});
                            card.setAttribute("data-share-cart-id", String(cartId));
                            card.setAttribute("data-share-cart-url", publicLink || "");
                            card.setAttribute("data-share-cart-title", title || "");
                            titleEl = card.querySelector(".st-account-share-cart-card__title_JS");
                            dateEl = card.querySelector(".st-account-share-cart-card__date-value_JS");
                            linkUsedEl = card.querySelector(".st-account-share-cart-card__link-used_JS");
                            ordersEl = card.querySelector(".st-account-share-cart-card__orders_JS");
                            partyNameEl = card.querySelector(".st-account-share-cart-card__party-name_JS");
                            subtotalEl = card.querySelector(".st-account-share-cart-card__subtotal_JS");
                            linkEl = card.querySelector(".st-account-share-cart-card__link_JS");
                            copyBtn = card.querySelector(".st-account-share-cart-card__copy-btn_JS");
                            viewBtn = card.querySelector(".st-account-share-cart-card__view-btn_JS");
                            editBtn = card.querySelector(".st-account-share-cart-card__menu-item--edit_JS");
                            deleteBtn = card.querySelector(".st-account-share-cart-card__menu-item--delete_JS");
                            if (titleEl) {
                                titleEl.textContent = title || "";
                            }
                            if (dateEl) {
                                dateEl.textContent = date || "";
                            }
                            if (linkUsedEl) {
                                linkUsedEl.textContent = String(linkUsed || "0");
                            }
                            if (ordersEl) {
                                ordersEl.textContent = String(ordersCount || "0");
                            }
                            if (partyNameEl) {
                                partyNameEl.textContent = partyName || "-";
                            }
                            if (subtotalEl) {
                                subtotalEl.textContent = this.formatMoney(subtotal);
                            }
                            if (linkEl) {
                                linkEl.textContent = publicLink || "";
                            }
                            if (copyBtn) {
                                copyBtn.setAttribute("data-share-cart-url", publicLink || "");
                            }
                            if (viewBtn) {
                                viewBtn.setAttribute("data-share-cart-id", String(cartId));
                            }
                            if (editBtn) {
                                editBtn.setAttribute("data-share-cart-id", String(cartId));
                            }
                            if (deleteBtn) {
                                deleteBtn.setAttribute("data-share-cart-id", String(cartId));
                            }
                            return [ 2, card ];
                        }
                    });
                });
            };
            _this.bindCardEvents = function() {
                _this.bindCopyButtons();
                _this.bindMenuTriggers();
                _this.bindEditButtons();
                _this.bindDeleteButtons();
                _this.bindViewButtons();
                _this.bindMobileToggleButtons();
            };
            _this.bindMobileToggleButtons = function() {
                var buttons = document.querySelectorAll(".st-account-share-cart-card__mobile-toggle_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__shareCartBound) {
                        return;
                    }
                    btn.__shareCartBound = true;
                    btn.addEventListener("click", function(event) {
                        event.preventDefault();
                        if (window.innerWidth > 767) {
                            return;
                        }
                        var card = _this.generalMethods.getClosestByClass(btn, "st-account-share-cart-card");
                        if (!card) {
                            return;
                        }
                        var isExpanded = card.classList.contains("is-expanded");
                        _this.closeAllMobileExpandedCards();
                        if (!isExpanded) {
                            _this.setMobileCardExpanded(card, true);
                        }
                    });
                });
            };
            _this.closeAllMobileExpandedCards = function() {
                var cards = document.querySelectorAll(".st-account-share-cart-card_JS");
                cards.forEach(function(cardElement) {
                    var card = cardElement;
                    _this.setMobileCardExpanded(card, false);
                });
            };
            _this.setMobileCardExpanded = function(card, isExpanded) {
                card.classList.toggle("is-expanded", isExpanded);
                var toggleBtn = card.querySelector(".st-account-share-cart-card__mobile-toggle_JS");
                var toggleLabel = card.querySelector(".st-account-share-cart-card__mobile-toggle-label_JS");
                if (toggleBtn) {
                    toggleBtn.setAttribute("aria-expanded", String(isExpanded));
                    var moreLabel = toggleBtn.getAttribute("data-more-label") || "View more";
                    var lessLabel = toggleBtn.getAttribute("data-less-label") || "Show less";
                    if (toggleLabel) {
                        toggleLabel.textContent = isExpanded ? lessLabel : moreLabel;
                    }
                }
            };
            _this.bindCopyButtons = function() {
                if (!sharecart_feature_config_2.shareCartCopyEnabled) {
                    return;
                }
                var buttons = document.querySelectorAll(".st-account-share-cart-card__copy-btn_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__shareCartBound) {
                        return;
                    }
                    btn.__shareCartBound = true;
                    btn.addEventListener("click", function() {
                        _this.accountShareCartUtils.copyShareCartLink(btn);
                    });
                });
            };
            _this.bindMenuTriggers = function() {
                var buttons = document.querySelectorAll(".st-account-share-cart-card__menu-trigger_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__shareCartBound) {
                        return;
                    }
                    btn.__shareCartBound = true;
                    btn.addEventListener("click", function(event) {
                        event.stopPropagation();
                        _this.accountShareCartUtils.toggleMenu(btn);
                    });
                });
            };
            _this.bindEditButtons = function() {
                if (!sharecart_feature_config_2.shareCartEditEnabled) {
                    return;
                }
                var buttons = document.querySelectorAll(".st-account-share-cart-card__menu-item--edit_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__shareCartBound) {
                        return;
                    }
                    btn.__shareCartBound = true;
                    btn.addEventListener("click", function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            var shareCartId;
                            return __generator(this, function(_a) {
                                switch (_a.label) {
                                  case 0:
                                    shareCartId = this.accountShareCartUtils.getShareCartId(btn);
                                    this.accountShareCartUtils.closeAllMenus();
                                    return [ 4, this.openEditNameModal(shareCartId) ];

                                  case 1:
                                    _a.sent();
                                    return [ 2 ];
                                }
                            });
                        });
                    });
                });
            };
            _this.bindDeleteButtons = function() {
                if (!sharecart_feature_config_2.shareCartDeleteEnabled) {
                    return;
                }
                var buttons = document.querySelectorAll(".st-account-share-cart-card__menu-item--delete_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__shareCartBound) {
                        return;
                    }
                    btn.__shareCartBound = true;
                    btn.addEventListener("click", function() {
                        var shareCartId = _this.accountShareCartUtils.getShareCartId(btn);
                        _this.accountShareCartUtils.closeAllMenus();
                        _this.openDeleteModal(shareCartId);
                    });
                });
            };
            _this.bindViewButtons = function() {
                if (!sharecart_feature_config_2.shareCartViewEnabled) {
                    return;
                }
                var buttons = document.querySelectorAll(".st-account-share-cart-card__view-btn_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__shareCartBound) {
                        return;
                    }
                    btn.__shareCartBound = true;
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var shareCartId = _this.accountShareCartUtils.getShareCartId(btn);
                        _this.openSingleShareCart(shareCartId);
                    });
                });
            };
            _this.openSingleShareCart = function(shareCartId) {
                return __awaiter(_this, void 0, void 0, function() {
                    var wrapper, single, response, shareCart, error_4;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            if (!sharecart_feature_config_2.shareCartAccountDetailsPageEnabled || !sharecart_feature_config_2.shareCartViewEnabled) {
                                return [ 2 ];
                            }
                            wrapper = this.accountShareCartUtils.getWrapper();
                            single = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(".st-account-single-share-cart_JS");
                            if (!wrapper || !single || !shareCartId) {
                                return [ 2 ];
                            }
                            wrapper.classList.add("st-account-share-cart--single-open");
                            single.style.display = "block";
                            single.setAttribute("data-share-cart-id", shareCartId);
                            this.toggleSingleShareCartLoading(single, true);
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 3, 4, 5 ]);
                            return [ 4, this.fetchShareCartById(shareCartId) ];

                          case 2:
                            response = _a.sent();
                            shareCart = this.normalizeSingleShareCartResponse(response);
                            this.shareCartDetailsCache[String(shareCartId)] = shareCart;
                            this.fillSingleShareCart(single, shareCart);
                            this.bindSingleShareCartEvents(single);
                            return [ 3, 5 ];

                          case 3:
                            error_4 = _a.sent();
                            console.error("[StAccountShareCart] single share cart error:", error_4);
                            this.showSingleShareCartError(single, "Failed to load share cart details.");
                            return [ 3, 5 ];

                          case 4:
                            this.toggleSingleShareCartLoading(single, false);
                            return [ 7 ];

                          case 5:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.backToHistoryShareCarts = function() {
                document.addEventListener("click", function(e) {
                    var target = e.target;
                    var btn = target === null || target === void 0 ? void 0 : target.closest(".st-account-single-share-cart__back-btn_JS");
                    if (!btn) {
                        return;
                    }
                    e.preventDefault();
                    var single = _this.generalMethods.getClosestByClass(btn, "st-account-single-share-cart");
                    var wrapper = _this.generalMethods.getClosestByClass(btn, "st-account-share-cart");
                    if (single) {
                        single.style.display = "none";
                    }
                    wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.remove("st-account-share-cart--single-open");
                });
            };
            _this.bindSingleShareCartEvents = function(single) {
                var copyBtn = single.querySelector(".st-account-single-share-cart__copy-btn_JS");
                if (copyBtn && sharecart_feature_config_2.shareCartCopyEnabled) {
                    copyBtn.onclick = function() {
                        _this.accountShareCartUtils.copyShareCartLink(copyBtn);
                    };
                }
                var editBtn = single.querySelector(".st-account-single-share-cart__edit-btn_JS");
                if (editBtn && sharecart_feature_config_2.shareCartEditEnabled) {
                    editBtn.onclick = function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            var shareCartId;
                            return __generator(this, function(_a) {
                                switch (_a.label) {
                                  case 0:
                                    shareCartId = single.getAttribute("data-share-cart-id") || "";
                                    this.closeSingleShareCartMenus();
                                    return [ 4, this.openEditNameModal(shareCartId) ];

                                  case 1:
                                    _a.sent();
                                    return [ 2 ];
                                }
                            });
                        });
                    };
                }
                var deleteBtn = single.querySelector(".st-account-single-share-cart__delete-btn_JS");
                if (deleteBtn && sharecart_feature_config_2.shareCartDeleteEnabled) {
                    deleteBtn.onclick = function() {
                        var shareCartId = single.getAttribute("data-share-cart-id") || "";
                        _this.closeSingleShareCartMenus();
                        _this.openDeleteModal(shareCartId);
                    };
                }
                _this.bindSingleShareCartMenuTriggers(single);
                _this.bindSingleShareCartMenuClose(single);
            };
            _this.bindSingleShareCartMenuTriggers = function(scope) {
                var root = scope || document;
                var buttons = root.querySelectorAll(".st-account-single-share-cart__menu-trigger_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__singleShareCartMenuBound) {
                        return;
                    }
                    btn.__singleShareCartMenuBound = true;
                    btn.addEventListener("click", function(event) {
                        event.preventDefault();
                        event.stopPropagation();
                        var menu = _this.generalMethods.getClosestByClass(btn, "st-account-single-share-cart__menu");
                        if (!menu) {
                            return;
                        }
                        var isOpen = menu.classList.contains("is-open");
                        _this.closeSingleShareCartMenus();
                        if (!isOpen) {
                            menu.classList.add("is-open");
                            btn.setAttribute("aria-expanded", "true");
                        }
                    });
                });
            };
            _this.bindSingleShareCartMenuClose = function(scope) {
                var root = scope || document;
                var buttons = root.querySelectorAll(".st-account-single-share-cart__menu-close_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__singleShareCartMenuCloseBound) {
                        return;
                    }
                    btn.__singleShareCartMenuCloseBound = true;
                    btn.addEventListener("click", function(event) {
                        event.preventDefault();
                        event.stopPropagation();
                        _this.closeSingleShareCartMenus();
                    });
                });
            };
            _this.closeSingleShareCartMenus = function() {
                var menus = document.querySelectorAll(".st-account-single-share-cart__menu_JS");
                menus.forEach(function(menuElement) {
                    var menu = menuElement;
                    menu.classList.remove("is-open");
                    var trigger = menu.querySelector(".st-account-single-share-cart__menu-trigger_JS");
                    if (trigger) {
                        trigger.setAttribute("aria-expanded", "false");
                    }
                });
            };
            _this.bindSingleShareCartOutsideClick = function() {
                document.addEventListener("click", function(event) {
                    var target = event.target;
                    if (!target) {
                        return;
                    }
                    var clickedInsideSingleMenu = target.closest(".st-account-single-share-cart__menu_JS");
                    var clickedSingleTrigger = target.closest(".st-account-single-share-cart__menu-trigger_JS");
                    if (!clickedInsideSingleMenu && !clickedSingleTrigger) {
                        _this.closeSingleShareCartMenus();
                    }
                });
            };
            _this.fillSingleShareCart = function(single, shareCart) {
                var titleEl = single.querySelector(".st-account-single-share-cart__title_JS");
                var dateEl = single.querySelector(".st-account-single-share-cart__date_JS");
                var linkUsedEl = single.querySelector(".st-account-single-share-cart__link-used_JS");
                var ordersEl = single.querySelector(".st-account-single-share-cart__orders_JS");
                var partyNameEl = single.querySelector(".st-account-single-share-cart__party-name_JS");
                var subtotalEl = single.querySelector(".st-account-single-share-cart__subtotal_JS");
                var linkEl = single.querySelector(".st-account-single-share-cart__link_JS");
                var totalEl = single.querySelector(".st-account-single-share-cart__total_JS");
                var lineItemsEl = single.querySelector(".st-account-single-share-cart__line-items_JS");
                var copyBtn = single.querySelector(".st-account-single-share-cart__copy-btn_JS");
                var title = _this.accountShareCartUtils.getShareCartTitle(shareCart);
                var date = _this.accountShareCartUtils.formatShareCartDate(shareCart === null || shareCart === void 0 ? void 0 : shareCart.created_at);
                var linkUsed = _this.accountShareCartUtils.getLinkUsedCount(shareCart);
                var ordersCount = _this.accountShareCartUtils.getOrdersCount(shareCart);
                var partyName = _this.accountShareCartUtils.getPartyName(shareCart);
                var publicLink = _this.accountShareCartUtils.shareCartLink((shareCart === null || shareCart === void 0 ? void 0 : shareCart.cart_token) || "", (shareCart === null || shareCart === void 0 ? void 0 : shareCart.share_cart_attributes) || {});
                var total = _this.getShareCartTotal(shareCart);
                var items = _this.normalizeLineItems(shareCart);
                if (titleEl) {
                    titleEl.textContent = title || "";
                }
                if (dateEl) {
                    dateEl.textContent = date || "";
                }
                if (linkUsedEl) {
                    linkUsedEl.textContent = String(linkUsed || "0");
                }
                if (ordersEl) {
                    ordersEl.textContent = String(ordersCount || "0");
                }
                if (partyNameEl) {
                    partyNameEl.textContent = partyName || "-";
                }
                if (subtotalEl) {
                    subtotalEl.textContent = _this.formatMoney(total);
                }
                if (linkEl) {
                    linkEl.textContent = publicLink || "";
                }
                if (copyBtn) {
                    copyBtn.setAttribute("data-share-cart-url", publicLink || "");
                }
                if (totalEl) {
                    totalEl.textContent = _this.formatMoney(total);
                }
                if (lineItemsEl) {
                    lineItemsEl.innerHTML = "";
                    var template_1 = document.getElementById("st-account-single-share-cart-line-item-template");
                    if (template_1 && items.length) {
                        items.forEach(function(item) {
                            var _a;
                            var fragment = ((_a = template_1.content) !== null && _a !== void 0 ? _a : template_1).cloneNode(true);
                            var imageEl = fragment.querySelector(".st-account-single-share-cart-line-item__image_JS");
                            var titleItemEl = fragment.querySelector(".st-account-single-share-cart-line-item__title_JS");
                            var qtyEl = fragment.querySelector(".st-account-single-share-cart-line-item__qty_JS");
                            var priceEl = fragment.querySelector(".st-account-single-share-cart-line-item__price_JS");
                            var totalItemEl = fragment.querySelector(".st-account-single-share-cart-line-item__total_JS");
                            var image = _this.getLineItemImage(item);
                            var itemTitle = _this.getLineItemTitle(item);
                            var qty = _this.getLineItemQty(item);
                            var price = _this.getLineItemPrice(item);
                            var itemTotal = _this.getLineItemTotal(item);
                            if (imageEl) {
                                imageEl.src = image || "";
                                imageEl.alt = itemTitle || "";
                            }
                            if (titleItemEl) {
                                titleItemEl.textContent = itemTitle || "";
                            }
                            if (qtyEl) {
                                qtyEl.textContent = String(qty || 0);
                            }
                            if (priceEl) {
                                priceEl.textContent = _this.formatMoney(price);
                            }
                            if (totalItemEl) {
                                totalItemEl.textContent = _this.formatMoney(itemTotal);
                            }
                            lineItemsEl.appendChild(fragment);
                        });
                    }
                }
            };
            _this.normalizeLineItems = function(shareCart) {
                var _a;
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.line_items)) {
                    return shareCart.line_items;
                }
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.items)) {
                    return shareCart.items;
                }
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.cart_items)) {
                    return shareCart.cart_items;
                }
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.products)) {
                    return shareCart.products;
                }
                if (Array.isArray((_a = shareCart === null || shareCart === void 0 ? void 0 : shareCart.data) === null || _a === void 0 ? void 0 : _a.line_items)) {
                    return shareCart.data.line_items;
                }
                return [];
            };
            _this.getLineItemsForUpdate = function(shareCart) {
                var _a;
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.line_items)) {
                    return shareCart.line_items;
                }
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.items)) {
                    return shareCart.items;
                }
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.cart_items)) {
                    return shareCart.cart_items;
                }
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.products)) {
                    return shareCart.products;
                }
                if (Array.isArray((_a = shareCart === null || shareCart === void 0 ? void 0 : shareCart.data) === null || _a === void 0 ? void 0 : _a.line_items)) {
                    return shareCart.data.line_items;
                }
                return [];
            };
            _this.getLineItemTitle = function(item) {
                var _a, _b, _c;
                return ((_b = (_a = item === null || item === void 0 ? void 0 : item.shopify_details) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.title) || ((_c = item === null || item === void 0 ? void 0 : item.shopify_details) === null || _c === void 0 ? void 0 : _c.displayName) || (item === null || item === void 0 ? void 0 : item.title) || (item === null || item === void 0 ? void 0 : item.product_title) || (item === null || item === void 0 ? void 0 : item.productName) || (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.variant_title) || "";
            };
            _this.getLineItemImage = function(item) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                return ((_g = (_f = (_e = (_d = (_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.shopify_details) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.media) === null || _c === void 0 ? void 0 : _c.nodes) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.preview) === null || _f === void 0 ? void 0 : _f.image) === null || _g === void 0 ? void 0 : _g.url) || ((_k = (_j = (_h = item === null || item === void 0 ? void 0 : item.shopify_details) === null || _h === void 0 ? void 0 : _h.product) === null || _j === void 0 ? void 0 : _j.featuredImage) === null || _k === void 0 ? void 0 : _k.url) || ((_m = (_l = item === null || item === void 0 ? void 0 : item.shopify_details) === null || _l === void 0 ? void 0 : _l.image) === null || _m === void 0 ? void 0 : _m.url) || (item === null || item === void 0 ? void 0 : item.thumbnail) || (item === null || item === void 0 ? void 0 : item.image) || (item === null || item === void 0 ? void 0 : item.image_url) || (item === null || item === void 0 ? void 0 : item.featured_image) || ((_o = item === null || item === void 0 ? void 0 : item.variant) === null || _o === void 0 ? void 0 : _o.image) || ((_p = item === null || item === void 0 ? void 0 : item.product) === null || _p === void 0 ? void 0 : _p.thumbnail) || "";
            };
            _this.getLineItemQty = function(item) {
                return Number((item === null || item === void 0 ? void 0 : item.quantity) || (item === null || item === void 0 ? void 0 : item.qty) || (item === null || item === void 0 ? void 0 : item.count) || 0);
            };
            _this.getLineItemPrice = function(item) {
                var _a;
                return Number((item === null || item === void 0 ? void 0 : item.price) || ((_a = item === null || item === void 0 ? void 0 : item.shopify_details) === null || _a === void 0 ? void 0 : _a.price) || (item === null || item === void 0 ? void 0 : item.unit_price) || (item === null || item === void 0 ? void 0 : item.final_price) || (item === null || item === void 0 ? void 0 : item.amount) || 0);
            };
            _this.getLineItemTotal = function(item) {
                var explicitTotals = [ item === null || item === void 0 ? void 0 : item.total, item === null || item === void 0 ? void 0 : item.line_total, item === null || item === void 0 ? void 0 : item.total_price, item === null || item === void 0 ? void 0 : item.subtotal ];
                for (var _i = 0, explicitTotals_1 = explicitTotals; _i < explicitTotals_1.length; _i++) {
                    var candidate = explicitTotals_1[_i];
                    if (candidate === null || typeof candidate === "undefined" || candidate === "") {
                        continue;
                    }
                    var parsed = Number(candidate);
                    if (!Number.isNaN(parsed) && parsed > 0) {
                        return parsed;
                    }
                }
                return _this.getLineItemPrice(item) * _this.getLineItemQty(item);
            };
            _this.getShareCartTotal = function(shareCart) {
                var items = _this.normalizeLineItems(shareCart);
                if (Array.isArray(items) && items.length) {
                    var itemsTotal = items.reduce(function(sum, item) {
                        return sum + _this.getLineItemTotal(item);
                    }, 0);
                    if (!Number.isNaN(itemsTotal) && itemsTotal > 0) {
                        return itemsTotal;
                    }
                }
                var directTotals = [ shareCart === null || shareCart === void 0 ? void 0 : shareCart.totalPrice, shareCart === null || shareCart === void 0 ? void 0 : shareCart.total_price, shareCart === null || shareCart === void 0 ? void 0 : shareCart.total, shareCart === null || shareCart === void 0 ? void 0 : shareCart.subtotal, shareCart === null || shareCart === void 0 ? void 0 : shareCart.cart_total ];
                for (var _i = 0, directTotals_1 = directTotals; _i < directTotals_1.length; _i++) {
                    var candidate = directTotals_1[_i];
                    if (candidate === null || typeof candidate === "undefined" || candidate === "") {
                        continue;
                    }
                    var parsed = Number(candidate);
                    if (!Number.isNaN(parsed)) {
                        return parsed;
                    }
                }
                return 0;
            };
            _this.toggleSingleShareCartLoading = function(single, show) {
                var loading = single.querySelector(".st-account-single-share-cart__loading");
                if (!loading) {
                    return;
                }
                loading.classList.toggle("st_hidden", !show);
            };
            _this.showSingleShareCartError = function(single, message) {
                var lineItemsEl = single.querySelector(".st-account-single-share-cart__line-items_JS");
                if (lineItemsEl) {
                    lineItemsEl.innerHTML = '<div class="st-account-share-cart__message st-account-share-cart__message--error"><i>'.concat(message, "</i></div>");
                }
            };
            _this.formatMoney = function(value) {
                var amount = Number(value || 0);
                return "$".concat(amount.toFixed(2));
            };
            _this.bindCreateNewCartButton = function() {
                if (!sharecart_feature_config_2.shareCartCreateEnabled) {
                    return;
                }
                var button = document.querySelector(".st-account-share-cart__redirect-to-btn_JS");
                if (!button) {
                    return;
                }
                if (button.__shareCartCreateBound) {
                    return;
                }
                button.__shareCartCreateBound = true;
                button.addEventListener("click", function() {
                    var currentUrl = new URL(window.location.href);
                    var alias = currentUrl.searchParams.get("als");
                    var params = new URLSearchParams();
                    if (alias) {
                        params.set("als", alias);
                    }
                    window.location.href = "".concat(window.location.origin, "/collections/all").concat(params.toString() ? "?".concat(params.toString()) : "");
                });
            };
            _this.bindOutsideClick = function() {
                document.addEventListener("click", function(event) {
                    var target = event.target;
                    if (!target) {
                        return;
                    }
                    var clickedInsideMenu = target.closest(".st-account-share-cart-card__menu_JS");
                    var clickedMenuTrigger = target.closest(".st-account-share-cart-card__menu-trigger_JS");
                    if (!clickedInsideMenu && !clickedMenuTrigger) {
                        _this.accountShareCartUtils.closeAllMenus();
                    }
                });
            };
            _this.bindEditNameModalEvents = function() {
                if (!sharecart_feature_config_2.shareCartEditEnabled) {
                    return;
                }
                if (_this.editNameModalBound) {
                    return;
                }
                _this.editNameModalBound = true;
                document.addEventListener("click", function(event) {
                    return __awaiter(_this, void 0, void 0, function() {
                        var target, cancelBtn, backdrop, saveBtn;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                target = event.target;
                                if (!target) {
                                    return [ 2 ];
                                }
                                cancelBtn = target.closest(".st-account-share-cart-edit-modal__cancel_JS");
                                backdrop = target.closest(".st-account-share-cart-edit-modal__backdrop_JS");
                                saveBtn = target.closest(".st-account-share-cart-edit-modal__save_JS");
                                if (cancelBtn || backdrop) {
                                    event.preventDefault();
                                    this.closeEditNameModal();
                                    return [ 2 ];
                                }
                                if (!saveBtn) return [ 3, 2 ];
                                event.preventDefault();
                                return [ 4, this.handleEditNameSubmit() ];

                              case 1:
                                _a.sent();
                                _a.label = 2;

                              case 2:
                                return [ 2 ];
                            }
                        });
                    });
                });
                document.addEventListener("keydown", function(event) {
                    return __awaiter(_this, void 0, void 0, function() {
                        var modal, target, isInput;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                modal = this.getEditNameModal();
                                if (!modal || !this.isEditNameModalOpen()) {
                                    return [ 2 ];
                                }
                                if (event.key === "Escape") {
                                    event.preventDefault();
                                    this.closeEditNameModal();
                                }
                                if (!(event.key === "Enter")) return [ 3, 2 ];
                                target = event.target;
                                isInput = !!(target === null || target === void 0 ? void 0 : target.closest(".st-account-share-cart-edit-modal__input_JS"));
                                if (!isInput) return [ 3, 2 ];
                                event.preventDefault();
                                return [ 4, this.handleEditNameSubmit() ];

                              case 1:
                                _a.sent();
                                _a.label = 2;

                              case 2:
                                return [ 2 ];
                            }
                        });
                    });
                });
            };
            _this.getEditNameModal = function() {
                var _a;
                return (_a = _this.accountShareCartUtils.getWrapper()) === null || _a === void 0 ? void 0 : _a.querySelector(".st-account-share-cart-edit-modal_JS");
            };
            _this.isEditNameModalOpen = function() {
                var modal = _this.getEditNameModal();
                return !!(modal === null || modal === void 0 ? void 0 : modal.classList.contains("is-visible"));
            };
            _this.openEditNameModal = function(shareCartId) {
                return __awaiter(_this, void 0, void 0, function() {
                    var modal, input, shareCart, currentName, error_5;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            if (!sharecart_feature_config_2.shareCartEditEnabled) {
                                return [ 2 ];
                            }
                            if (!shareCartId) {
                                return [ 2 ];
                            }
                            modal = this.getEditNameModal();
                            if (!modal) {
                                return [ 2 ];
                            }
                            input = modal.querySelector(".st-account-share-cart-edit-modal__input_JS");
                            if (!input) {
                                return [ 2 ];
                            }
                            this.activeEditShareCartId = String(shareCartId);
                            this.setEditNameModalError("");
                            this.setEditNameModalSubmitting(false);
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 3, , 4 ]);
                            return [ 4, this.getShareCartDetailForEdit(shareCartId) ];

                          case 2:
                            shareCart = _a.sent();
                            currentName = this.accountShareCartUtils.getShareCartTitle(shareCart);
                            input.value = currentName || "";
                            modal.classList.add("is-visible");
                            modal.setAttribute("aria-hidden", "false");
                            document.body.classList.add("st-share-cart-modal-open");
                            setTimeout(function() {
                                input.focus();
                                input.setSelectionRange(input.value.length, input.value.length);
                            }, 0);
                            return [ 3, 4 ];

                          case 3:
                            error_5 = _a.sent();
                            console.error("[StAccountShareCart] open edit name modal error:", error_5);
                            return [ 3, 4 ];

                          case 4:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.closeEditNameModal = function(force) {
                if (force === void 0) {
                    force = false;
                }
                if (_this.isSubmittingEditName && !force) {
                    return;
                }
                var modal = _this.getEditNameModal();
                if (!modal) {
                    return;
                }
                var input = modal.querySelector(".st-account-share-cart-edit-modal__input_JS");
                modal.classList.remove("is-visible");
                modal.setAttribute("aria-hidden", "true");
                document.body.classList.remove("st-share-cart-modal-open");
                _this.activeEditShareCartId = "";
                _this.setEditNameModalError("");
                if (input) {
                    input.value = "";
                    input.disabled = false;
                }
            };
            _this.getShareCartDetailForEdit = function(shareCartId) {
                return __awaiter(_this, void 0, void 0, function() {
                    var cacheKey, response, shareCart;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            cacheKey = String(shareCartId);
                            if (this.shareCartDetailsCache[cacheKey]) {
                                return [ 2, this.shareCartDetailsCache[cacheKey] ];
                            }
                            return [ 4, this.fetchShareCartById(shareCartId) ];

                          case 1:
                            response = _a.sent();
                            shareCart = this.normalizeSingleShareCartResponse(response);
                            this.shareCartDetailsCache[cacheKey] = shareCart;
                            return [ 2, shareCart ];
                        }
                    });
                });
            };
            _this.handleEditNameSubmit = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var shareCartId, modal, input, nextName, shareCartNameLength, isValidCartName, shareCart, response, updatedShareCart, error_6;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            if (!sharecart_feature_config_2.shareCartEditEnabled) {
                                return [ 2 ];
                            }
                            if (this.isSubmittingEditName) {
                                return [ 2 ];
                            }
                            shareCartId = this.activeEditShareCartId;
                            modal = this.getEditNameModal();
                            if (!modal || !shareCartId) {
                                return [ 2 ];
                            }
                            input = modal.querySelector(".st-account-share-cart-edit-modal__input_JS");
                            if (!input) {
                                return [ 2 ];
                            }
                            nextName = (input.value || "").trim();
                            shareCartNameLength = window.stTranslations.shareCartNameLength;
                            if (!nextName) {
                                this.setEditNameModalError(this.accountShareCartUtils.getTranslation("cart_name_required"));
                                return [ 2 ];
                            }
                            isValidCartName = /^.{6,}$/.test(nextName);
                            if (!isValidCartName) {
                                this.setEditNameModalError(shareCartNameLength);
                                return [ 2 ];
                            }
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 5, , 6 ]);
                            this.setEditNameModalError("");
                            this.setEditNameModalSubmitting(true);
                            return [ 4, this.getShareCartDetailForEdit(shareCartId) ];

                          case 2:
                            shareCart = _a.sent();
                            return [ 4, this.updateShareCartName(shareCartId, shareCart, nextName) ];

                          case 3:
                            response = _a.sent();
                            updatedShareCart = this.normalizeSingleShareCartResponse(response);
                            this.shareCartDetailsCache[String(shareCartId)] = updatedShareCart;
                            return [ 4, this.fetchAndRenderShareCarts(this.currentPage) ];

                          case 4:
                            _a.sent();
                            this.updateVisibleSingleShareCartAfterEdit(shareCartId, updatedShareCart);
                            this.setEditNameModalSubmitting(false);
                            this.closeEditNameModal(true);
                            return [ 3, 6 ];

                          case 5:
                            error_6 = _a.sent();
                            console.error("[StAccountShareCart] update share cart name error:", error_6);
                            this.setEditNameModalSubmitting(false);
                            this.setEditNameModalError((error_6 === null || error_6 === void 0 ? void 0 : error_6.message) || this.accountShareCartUtils.getTranslation("cart_name_save_failed", "Failed to save cart name."));
                            return [ 3, 6 ];

                          case 6:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.setEditNameModalError = function(message) {
                var modal = _this.getEditNameModal();
                var errorEl = modal === null || modal === void 0 ? void 0 : modal.querySelector(".st-account-share-cart-edit-modal__error_JS");
                if (!errorEl) {
                    return;
                }
                errorEl.textContent = message || "";
                errorEl.classList.toggle("st_hidden", !message);
            };
            _this.setEditNameModalSubmitting = function(isSubmitting) {
                _this.isSubmittingEditName = isSubmitting;
                var modal = _this.getEditNameModal();
                if (!modal) {
                    return;
                }
                var input = modal.querySelector(".st-account-share-cart-edit-modal__input_JS");
                var saveBtn = modal.querySelector(".st-account-share-cart-edit-modal__save_JS");
                var cancelBtn = modal.querySelector(".st-account-share-cart-edit-modal__cancel_JS");
                if (input) {
                    input.disabled = isSubmitting;
                }
                if (saveBtn) {
                    saveBtn.disabled = isSubmitting;
                    saveBtn.textContent = isSubmitting ? _this.accountShareCartUtils.getTranslation("saving", "Saving...") : _this.accountShareCartUtils.getTranslation("save", "Save");
                }
                if (cancelBtn) {
                    cancelBtn.disabled = isSubmitting;
                }
            };
            _this.updateVisibleSingleShareCartAfterEdit = function(shareCartId, updatedShareCart) {
                var wrapper = _this.accountShareCartUtils.getWrapper();
                var single = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(".st-account-single-share-cart_JS");
                if (!single) {
                    return;
                }
                var currentSingleId = single.getAttribute("data-share-cart-id") || "";
                if (currentSingleId && String(currentSingleId) === String(shareCartId)) {
                    _this.fillSingleShareCart(single, updatedShareCart);
                    _this.bindSingleShareCartEvents(single);
                }
            };
            _this.getDeleteModal = function() {
                var _a;
                return (_a = _this.accountShareCartUtils.getWrapper()) === null || _a === void 0 ? void 0 : _a.querySelector(".st-account-share-cart-delete-modal_JS");
            };
            _this.isDeleteModalOpen = function() {
                var modal = _this.getDeleteModal();
                return !!(modal === null || modal === void 0 ? void 0 : modal.classList.contains("is-visible"));
            };
            _this.openDeleteModal = function(shareCartId) {
                if (!sharecart_feature_config_2.shareCartDeleteEnabled) {
                    return;
                }
                if (!shareCartId) {
                    return;
                }
                var modal = _this.getDeleteModal();
                if (!modal) {
                    return;
                }
                _this.activeDeleteShareCartId = String(shareCartId);
                _this.setDeleteModalError("");
                _this.setDeleteModalSubmitting(false);
                modal.classList.add("is-visible");
                modal.setAttribute("aria-hidden", "false");
                document.body.classList.add("st-share-cart-modal-open");
            };
            _this.closeDeleteModal = function(force) {
                if (force === void 0) {
                    force = false;
                }
                if (_this.isSubmittingDeleteShareCart && !force) {
                    return;
                }
                var modal = _this.getDeleteModal();
                if (!modal) {
                    return;
                }
                modal.classList.remove("is-visible");
                modal.setAttribute("aria-hidden", "true");
                document.body.classList.remove("st-share-cart-modal-open");
                _this.activeDeleteShareCartId = "";
                _this.setDeleteModalError("");
            };
            _this.bindDeleteModalEvents = function() {
                if (!sharecart_feature_config_2.shareCartDeleteEnabled) {
                    return;
                }
                if (_this.deleteModalBound) {
                    return;
                }
                _this.deleteModalBound = true;
                document.addEventListener("click", function(event) {
                    return __awaiter(_this, void 0, void 0, function() {
                        var target, cancelBtn, backdrop, confirmBtn;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                target = event.target;
                                if (!target) {
                                    return [ 2 ];
                                }
                                cancelBtn = target.closest(".st-account-share-cart-delete-modal__cancel_JS");
                                backdrop = target.closest(".st-account-share-cart-delete-modal__backdrop_JS");
                                confirmBtn = target.closest(".st-account-share-cart-delete-modal__confirm_JS");
                                if (cancelBtn || backdrop) {
                                    event.preventDefault();
                                    this.closeDeleteModal();
                                    return [ 2 ];
                                }
                                if (!confirmBtn) return [ 3, 2 ];
                                event.preventDefault();
                                return [ 4, this.handleDeleteSubmit() ];

                              case 1:
                                _a.sent();
                                _a.label = 2;

                              case 2:
                                return [ 2 ];
                            }
                        });
                    });
                });
                document.addEventListener("keydown", function(event) {
                    return __awaiter(_this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                if (!this.isDeleteModalOpen()) {
                                    return [ 2 ];
                                }
                                if (event.key === "Escape") {
                                    event.preventDefault();
                                    this.closeDeleteModal();
                                }
                                if (!(event.key === "Enter")) return [ 3, 2 ];
                                event.preventDefault();
                                return [ 4, this.handleDeleteSubmit() ];

                              case 1:
                                _a.sent();
                                _a.label = 2;

                              case 2:
                                return [ 2 ];
                            }
                        });
                    });
                });
            };
            _this.setDeleteModalError = function(message) {
                var modal = _this.getDeleteModal();
                var errorEl = modal === null || modal === void 0 ? void 0 : modal.querySelector(".st-account-share-cart-delete-modal__error_JS");
                if (!errorEl) {
                    return;
                }
                errorEl.textContent = message || "";
                errorEl.classList.toggle("st_hidden", !message);
            };
            _this.setDeleteModalSubmitting = function(isSubmitting) {
                _this.isSubmittingDeleteShareCart = isSubmitting;
                var modal = _this.getDeleteModal();
                if (!modal) {
                    return;
                }
                var confirmBtn = modal.querySelector(".st-account-share-cart-delete-modal__confirm_JS");
                var cancelBtn = modal.querySelector(".st-account-share-cart-delete-modal__cancel_JS");
                var deletingText = window.stTranslations.deleting;
                if (confirmBtn) {
                    confirmBtn.disabled = isSubmitting;
                    confirmBtn.textContent = isSubmitting ? deletingText || "Deleting..." : _this.accountShareCartUtils.getTranslation("yes", "Yes");
                }
                if (cancelBtn) {
                    cancelBtn.disabled = isSubmitting;
                }
            };
            _this.handleDeleteSubmit = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var shareCartId, wrapper, single, currentSingleId, error_7;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            if (!sharecart_feature_config_2.shareCartDeleteEnabled) {
                                return [ 2 ];
                            }
                            if (this.isSubmittingDeleteShareCart) {
                                return [ 2 ];
                            }
                            shareCartId = this.activeDeleteShareCartId;
                            if (!shareCartId) {
                                return [ 2 ];
                            }
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 7, , 8 ]);
                            this.setDeleteModalError("");
                            this.setDeleteModalSubmitting(true);
                            return [ 4, this.deleteShareCart(shareCartId) ];

                          case 2:
                            _a.sent();
                            delete this.shareCartDetailsCache[String(shareCartId)];
                            wrapper = this.accountShareCartUtils.getWrapper();
                            single = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(".st-account-single-share-cart_JS");
                            currentSingleId = (single === null || single === void 0 ? void 0 : single.getAttribute("data-share-cart-id")) || "";
                            if (single && String(currentSingleId) === String(shareCartId)) {
                                single.style.display = "none";
                                wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.remove("st-account-share-cart--single-open");
                            }
                            this.closeDeleteModal(true);
                            if (!(this.currentPage > 1 && this.lastLoadedCount === 1)) return [ 3, 4 ];
                            return [ 4, this.fetchAndRenderShareCarts(this.currentPage - 1) ];

                          case 3:
                            _a.sent();
                            return [ 3, 6 ];

                          case 4:
                            return [ 4, this.fetchAndRenderShareCarts(this.currentPage) ];

                          case 5:
                            _a.sent();
                            _a.label = 6;

                          case 6:
                            return [ 3, 8 ];

                          case 7:
                            error_7 = _a.sent();
                            console.error("[StAccountShareCart] delete share cart error:", error_7);
                            this.setDeleteModalSubmitting(false);
                            this.setDeleteModalError((error_7 === null || error_7 === void 0 ? void 0 : error_7.message) || this.accountShareCartUtils.getTranslation("delete_share_cart_failed", "Failed to delete share cart."));
                            return [ 3, 8 ];

                          case 8:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.goToPage = function(page) {
                return __awaiter(_this, void 0, void 0, function() {
                    var nextPage;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            nextPage = Math.max(1, page);
                            if (nextPage === this.currentPage && nextPage !== 1) {
                                return [ 2 ];
                            }
                            return [ 4, this.fetchAndRenderShareCarts(nextPage) ];

                          case 1:
                            _a.sent();
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.handleMenuCloseClick = function() {
                document.addEventListener("click", function(event) {
                    var target = event.target;
                    var closeBtn = target.closest(".st-account-share-cart-card__menu-close_JS");
                    if (!closeBtn) {
                        return;
                    }
                    var menu = closeBtn.closest(".st-account-share-cart-card__menu_JS");
                    var trigger = menu === null || menu === void 0 ? void 0 : menu.querySelector(".st-account-share-cart-card__menu-trigger_JS");
                    menu === null || menu === void 0 ? void 0 : menu.classList.remove("is-open");
                    trigger === null || trigger === void 0 ? void 0 : trigger.setAttribute("aria-expanded", "false");
                });
            };
            _this.objectFormatting = objectFormatting;
            _this.generalMethods = generalMethods;
            _this.cartComponent = cartComponent;
            _this.accountShareCartUtils = accountShareCartUtils;
            return _this;
        }
        StAccountShareCart.prototype.renderPagination = function() {
            var root = document.querySelector(".st-account-share-cart__pagination_JS") || document.querySelector(".st_pagination");
            if (!root) {
                return;
            }
            root.innerHTML = "";
            var shouldHide = this.currentPage === 1 && !this.hasNextPage;
            if (shouldHide) {
                root.style.display = "none";
                return;
            }
            root.style.display = "";
            var mkBtn = function(label, role, disabled) {
                var buttonElement = document.createElement("button");
                buttonElement.type = "button";
                buttonElement.className = "st_pag-btn";
                buttonElement.setAttribute("data-role", role);
                buttonElement.disabled = disabled;
                buttonElement.textContent = label;
                return buttonElement;
            };
            var first = mkBtn("«", "first", this.currentPage === 1);
            var prev = mkBtn("‹", "prev", this.currentPage === 1);
            var indicator = document.createElement("span");
            indicator.className = "st_pag-indicator";
            indicator.setAttribute("aria-live", "polite");
            indicator.textContent = String(this.currentPage);
            var next = mkBtn("›", "next", !this.hasNextPage);
            root.appendChild(first);
            root.appendChild(prev);
            root.appendChild(indicator);
            root.appendChild(next);
        };
        StAccountShareCart.prototype.bindPaginationHandlers = function() {
            var _this = this;
            if (this.paginationBound) {
                return;
            }
            this.paginationBound = true;
            document.addEventListener("click", function(e) {
                return __awaiter(_this, void 0, void 0, function() {
                    var targetElement, btn, role, _a;
                    return __generator(this, function(_b) {
                        switch (_b.label) {
                          case 0:
                            targetElement = e.target;
                            if (!(targetElement === null || targetElement === void 0 ? void 0 : targetElement.closest)) {
                                return [ 2 ];
                            }
                            btn = targetElement.closest(".st-account-share-cart__pagination_JS .st_pag-btn, .st_pagination .st_pag-btn");
                            if (!btn) {
                                return [ 2 ];
                            }
                            role = btn.getAttribute("data-role");
                            if (!role) {
                                return [ 2 ];
                            }
                            e.preventDefault();
                            _a = role;
                            switch (_a) {
                              case "first":
                                return [ 3, 1 ];

                              case "prev":
                                return [ 3, 3 ];

                              case "next":
                                return [ 3, 5 ];
                            }
                            return [ 3, 8 ];

                          case 1:
                            return [ 4, this.goToPage(1) ];

                          case 2:
                            _b.sent();
                            return [ 3, 8 ];

                          case 3:
                            return [ 4, this.goToPage(this.currentPage - 1) ];

                          case 4:
                            _b.sent();
                            return [ 3, 8 ];

                          case 5:
                            if (!this.hasNextPage) return [ 3, 7 ];
                            return [ 4, this.goToPage(this.currentPage + 1) ];

                          case 6:
                            _b.sent();
                            _b.label = 7;

                          case 7:
                            return [ 3, 8 ];

                          case 8:
                            return [ 2 ];
                        }
                    });
                });
            });
        };
        Object.defineProperty(StAccountShareCart.prototype, "shareCartApiKey", {
            get: function() {
                var shareCartKey = window.shareCartApiKey;
                return shareCartKey;
            },
            enumerable: false,
            configurable: true
        });
        return StAccountShareCart;
    }(st_module_61.StModule);
    exports.StAccountShareCart = StAccountShareCart;
});

define("core/shopify-app/st-modules/cart/cart-enrollment", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_62, _features_config_15) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCartEnrollment = void 0;
    var StCartEnrollment = function(_super) {
        __extends(StCartEnrollment, _super);
        function StCartEnrollment() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StCartEnrollment";
            _this_1.checkoutBtnClassName = "st_cart-checkout_JS";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setCheckoutEventListener();
                });
            };
            return _this_1;
        }
        StCartEnrollment.prototype.setCheckoutEventListener = function() {
            var _this_1 = this;
            var checkoutBtn = document.querySelector(".".concat(this.checkoutBtnClassName));
            if (!checkoutBtn) return;
            var _this = this;
            checkoutBtn.addEventListener("click", function(e) {
                e.preventDefault();
                var cartIncludesEnrollmentItem = false;
                _this_1.ajax.send({
                    endpoint: "/cart.js",
                    method: "GET",
                    contentType: "json",
                    callback: function(res) {
                        try {
                            var cartObj = JSON.parse(res.response);
                            console.log(cartObj);
                            cartIncludesEnrollmentItem = cartObj.items.some(function(item) {
                                return item.sku === _features_config_15.enrollmentItemSku;
                            });
                            if (cartIncludesEnrollmentItem && window.customerShopifyEmail === 0) {
                                window.location.href = "/customer_authentication/login?return_to=/checkout";
                            } else {
                                window.location.href = "/checkout";
                            }
                        } catch (err) {
                            console.log("Cart Api Error: ", err);
                        }
                    }
                });
            });
        };
        return StCartEnrollment;
    }(st_module_62.StModule);
    exports.StCartEnrollment = StCartEnrollment;
});

define("core/shopify-app/st-modules/account/blocks/promo-codes/promo-codes", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_63, notification_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StPromoCodes = void 0;
    var StPromoCodes = function(_super) {
        __extends(StPromoCodes, _super);
        function StPromoCodes(notification) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Account - StPromoCodes";
            _this.promoCodeInputClass = "st_promo-code-edit-input_JS";
            _this.promoCodeCopyInputClass = "st_promo-code-input_JS";
            _this.promoCodeCopyClass = "st_copy-promo-code_JS";
            _this.promoCodeSaveBtnClass = "st_copy-promo-code_save_JS";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.setInputEventListener();
                    _this.setSaveInputEventListener();
                    _this.setCopyInputEventListener();
                    _this.prefillPromoCodeInput();
                });
            };
            _this.notification = notification;
            return _this;
        }
        StPromoCodes.prototype.prefillPromoCodeInput = function() {
            return __awaiter(this, void 0, void 0, function() {
                var inputElement, copyInputElement;
                return __generator(this, function(_a) {
                    switch (_a.label) {
                      case 0:
                        inputElement = document.querySelector(".".concat(this.promoCodeInputClass));
                        copyInputElement = document.querySelector(".".concat(this.promoCodeCopyInputClass));
                        if (!inputElement || !copyInputElement) return [ 2 ];
                        return [ 4, this.getPromoCode(function(res) {
                            console.log(res);
                            inputElement.value = res.data.promoCode;
                            copyInputElement.value = res.data.promoCode;
                        }) ];

                      case 1:
                        return [ 2, _a.sent() ];
                    }
                });
            });
        };
        StPromoCodes.prototype.setInputEventListener = function() {
            var _this = this;
            var inputElement = document.querySelector(".".concat(this.promoCodeInputClass));
            if (!inputElement) return;
            inputElement.addEventListener("input", function(e) {
                var changedText = e.target.value;
                var saveButton = document.querySelector(".".concat(_this.promoCodeSaveBtnClass));
                if (!saveButton) {
                    console.error("[Account] [PromoCodes] Couldn't find save button");
                }
                var inputElementNew = document.querySelector(".".concat(_this.promoCodeInputClass));
                inputElementNew.value = changedText;
            });
        };
        StPromoCodes.prototype.setSaveInputEventListener = function() {
            var _this = this;
            var inputElement = document.querySelector(".".concat(this.promoCodeInputClass));
            if (!inputElement) return;
            var oldPromoCode = inputElement.value;
            var saveButton = document.querySelector(".".concat(this.promoCodeSaveBtnClass));
            if (!saveButton) return;
            var copyButton = document.querySelector(".".concat(this.promoCodeCopyClass));
            if (!copyButton) return;
            saveButton.addEventListener("click", function(e) {
                return __awaiter(_this, void 0, void 0, function() {
                    var inputElement, updatedPromoCode;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            inputElement = document.querySelector(".".concat(this.promoCodeInputClass));
                            if (!inputElement) return [ 2 ];
                            updatedPromoCode = inputElement.value;
                            return [ 4, this.savePromoCodeChange(updatedPromoCode, oldPromoCode) ];

                          case 1:
                            _a.sent();
                            return [ 2 ];
                        }
                    });
                });
            });
        };
        StPromoCodes.prototype.setCopyInputEventListener = function() {
            var _this = this;
            var copyButton = document.querySelector(".".concat(this.promoCodeCopyClass));
            if (!copyButton) return;
            copyButton.addEventListener("click", function(e) {
                var inputElement = document.querySelector(".".concat(_this.promoCodeInputClass));
                if (!inputElement) return;
                navigator.clipboard.writeText(inputElement.value);
                _this.notification.showNotification(notification_9.ENotificationType.success, "Promo code copied to clipboard.");
            });
        };
        StPromoCodes.prototype.getPromoCode = function(responseHandle) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    try {
                        this.ajax.send({
                            endpoint: this.endpoint["webalias"]["getPromoCode"],
                            method: "post",
                            contentType: "json",
                            data: {
                                shopifyCustomerId: window.customerShopifyId
                            },
                            callback: function(response) {
                                try {
                                    var data = JSON.parse(response.response);
                                    responseHandle(data);
                                } catch (error) {
                                    console.log("[Account] [PromoCodes] Failed to get promo code. Error: ", error);
                                    return false;
                                }
                            }
                        });
                    } catch (err) {
                        console.log("[Account] [PromoCodes] Failed to execute get promo code. Error: ", err);
                        return [ 2 ];
                    }
                    return [ 2 ];
                });
            });
        };
        StPromoCodes.prototype.savePromoCodeChange = function(textInput, oldTextInput) {
            return __awaiter(this, void 0, void 0, function() {
                var _this = this;
                return __generator(this, function(_a) {
                    try {
                        this.ajax.send({
                            endpoint: this.endpoint["webalias"]["savePromoCode"],
                            method: "post",
                            contentType: "json",
                            data: {
                                shopifyCustomerId: window.customerShopifyId,
                                newPromoCode: textInput,
                                oldPromoCode: oldTextInput
                            },
                            callback: function(response) {
                                try {
                                    var res = JSON.parse(response.response);
                                    if (res.status === 200) {
                                        var copyInputElement = document.querySelector(".".concat(_this.promoCodeCopyInputClass));
                                        copyInputElement.value = textInput;
                                        _this.notification.showNotification(notification_9.ENotificationType.success, "Promo code successfully saved.");
                                    } else {
                                        _this.notification.showNotification(notification_9.ENotificationType.error, "Promo code failed to save.");
                                    }
                                } catch (error) {
                                    console.log("[Account] [PromoCodes] Failed to save promo code. Error: ", error);
                                    return false;
                                }
                            }
                        });
                    } catch (err) {
                        console.log("[Account] [PromoCodes] Failed to execute save promo code. Error: ", err);
                        return [ 2 ];
                    }
                    return [ 2 ];
                });
            });
        };
        return StPromoCodes;
    }(st_module_63.StModule);
    exports.StPromoCodes = StPromoCodes;
});

define("core/shopify-app/st-modules/sso-landing-after/landing-after-sso", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_static/static" ], function(require, exports, st_module_64, static_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.LandingAfterSso = void 0;
    var LandingAfterSso = function(_super) {
        __extends(LandingAfterSso, _super);
        function LandingAfterSso() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "LandingAfterSso";
            _this.hasRun = false;
            _this.init = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var redirectUrl, alreadySynced, payload, error_8;
                    var _this = this;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            console.log("[LandingAfterSso] init");
                            if (this.hasRun) {
                                console.log("[LandingAfterSso] already executed");
                                return [ 2 ];
                            }
                            this.hasRun = true;
                            redirectUrl = this.getRedirectUrl();
                            console.log("[LandingAfterSso] redirectUrl", redirectUrl);
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 3, , 4 ]);
                            console.log("[LandingAfterSso] trying tokens");
                            return [ 4, this.ajax.tryGetTokens() ];

                          case 2:
                            _a.sent();
                            console.log("[LandingAfterSso] tokens received");
                            alreadySynced = this.isCustomerAlreadySynced();
                            console.log("[LandingAfterSso] already synced", alreadySynced);
                            if (alreadySynced) {
                                console.log("[LandingAfterSso] redirecting immediately");
                                this.redirect(redirectUrl);
                                return [ 2 ];
                            }
                            payload = {
                                email: window.customerShopifyEmail,
                                sponsorsWebAlias: this.ajax.getWebAlias()
                            };
                            console.log("[LandingAfterSso] sending sync request", payload);
                            this.ajax.send({
                                endpoint: this.getNewAccountCheckAndCreateEndpoint(),
                                method: "POST",
                                contentType: "json",
                                data: payload,
                                callback: function(response) {
                                    console.log("[LandingAfterSso] sync response", response);
                                    _this.redirect(redirectUrl);
                                }
                            });
                            return [ 3, 4 ];

                          case 3:
                            error_8 = _a.sent();
                            console.error("[LandingAfterSso] failed", error_8);
                            this.redirect("/account/login?r=".concat(encodeURIComponent(redirectUrl)));
                            return [ 3, 4 ];

                          case 4:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.redirect = function(url) {
                console.log("[LandingAfterSso] redirect", url);
                document.documentElement.classList.remove("st-sso-loading");
                window.location.href = url;
            };
            _this.getRedirectUrl = function() {
                var params = new URLSearchParams(window.location.search);
                var redirectUrl = params.get("r");
                console.log("[LandingAfterSso] query redirect", redirectUrl);
                if (!redirectUrl || !redirectUrl.startsWith("/")) {
                    console.log("[LandingAfterSso] fallback redirect");
                    return "/pages/account";
                }
                return redirectUrl;
            };
            _this.getNewAccountCheckAndCreateEndpoint = function() {
                var endpoint = static_3.StStatic.Instance().obtainStaticEndpoints()["enrollment"]["newAccountCheckAndCreate"];
                console.log("[LandingAfterSso] endpoint", endpoint);
                return endpoint;
            };
            _this.isCustomerAlreadySynced = function() {
                var customer = window.commissionEngineCustomer;
                console.log("[LandingAfterSso] commissionEngineCustomer", customer);
                if (!customer) {
                    console.log("[LandingAfterSso] customer not synced");
                    return false;
                }
                if (typeof customer === "string") {
                    try {
                        var parsed = JSON.parse(customer);
                        console.log("[LandingAfterSso] parsed customer", parsed);
                        return !!(parsed === null || parsed === void 0 ? void 0 : parsed.personalId);
                    } catch (e) {
                        console.error("[LandingAfterSso] parse failed", e);
                        return false;
                    }
                }
                return !!(customer === null || customer === void 0 ? void 0 : customer.personalId);
            };
            return _this;
        }
        return LandingAfterSso;
    }(st_module_64.StModule);
    exports.LandingAfterSso = LandingAfterSso;
});

define("core/shopify-app/st-modules/sso-confirm-sponsor/confirm-sponsor", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_65) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StConfirmSponsor = void 0;
    var StConfirmSponsor = function(_super) {
        __extends(StConfirmSponsor, _super);
        function StConfirmSponsor() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ConfirmSponsor";
            _this.continueSelector = ".st_confirm-sponsor-btn_JS";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    if (_this.isCustomerAlreadySynced()) {
                        window.location.href = _this.getFinalRedirectUrl();
                        return;
                    }
                    _this.bindContinue();
                });
            };
            _this.bindContinue = function() {
                var button = document.querySelector(_this.continueSelector);
                button === null || button === void 0 ? void 0 : button.addEventListener("click", function() {
                    window.location.href = _this.getLandingRedirectUrl();
                });
            };
            _this.getFinalRedirectUrl = function() {
                var params = new URLSearchParams(window.location.search);
                var redirectUrl = params.get("r");
                if (!redirectUrl || !redirectUrl.startsWith("/")) {
                    return "/pages/account";
                }
                return redirectUrl;
            };
            _this.getLandingRedirectUrl = function() {
                return "/pages/landing-after-sso?r=".concat(encodeURIComponent(_this.getFinalRedirectUrl()));
            };
            _this.isCustomerAlreadySynced = function() {
                var _a;
                var customer = window.commissionEngineCustomer;
                if (!customer) return false;
                if (typeof customer === "string") {
                    try {
                        return !!((_a = JSON.parse(customer)) === null || _a === void 0 ? void 0 : _a.customerId);
                    } catch (_b) {
                        return false;
                    }
                }
                return !!(customer === null || customer === void 0 ? void 0 : customer.customerId);
            };
            return _this;
        }
        return StConfirmSponsor;
    }(st_module_65.StModule);
    exports.StConfirmSponsor = StConfirmSponsor;
});

define("_shopify.app.di.container", [ "require", "exports", "core/shopify-app/st-modules/_static/static", "core/shopify-app/st-modules/_guards/guards", "core/shopify-app/st-modules/webalias/webalias", "core/shopify-app/st-modules/account/account", "core/shopify-app/st-modules/enrollment/enrollment", "core/shopify-app/st-modules/_general-methods/browser-history", "core/shopify-app/st-modules/_general-methods/form/cart-manipulation", "core/shopify-app/st-modules/_general-methods/cookies/cookies", "core/shopify-app/st-modules/_general-methods/form/customer-type", "core/shopify-app/st-modules/_general-methods/form/loader", "core/shopify-app/st-modules/_general-methods/general-methods", "core/shopify-app/st-modules/_general-methods/button/button-actions", "core/shopify-app/st-modules/_general-methods/form/form", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/_general-methods/object-formatting", "core/shopify-app/st-modules/_di-container/di.container.public", "core/shopify-app/st-modules/enrollment/page-header/nav/enrollment-nav", "core/shopify-app/st-modules/enrollment/page/enrollment-submit", "core/shopify-app/st-modules/enrollment/_general/enrollment-class-config", "core/shopify-app/st-modules/_general-methods/form/fields/date-input", "core/shopify-app/st-modules/_general-methods/form/form-class-config", "core/shopify-app/st-modules/enrollment/_validation/enrollment-validation", "core/shopify-app/st-modules/enrollment/blocks/review-privacy/enrollment-section-review-privacy", "core/shopify-app/st-modules/enrollment/blocks/account-details/enrollment-section-account-details", "core/shopify-app/st-modules/enrollment/blocks/business-info/enrollment-section-business-details", "core/shopify-app/st-modules/enrollment/_validation/enrollment-validation-setup", "core/shopify-app/st-modules/account/_general/account-class-config", "core/shopify-app/st-modules/webalias/inject-representative-info", "core/shopify-app/st-modules/search-sponsor/search-sponsor", "core/shopify-app/st-modules/search-sponsor/sponsor-search-class-config", "core/shopify-app/st-modules/enrollment/blocks/optional-kits/enrollment-section-optional-kits", "core/shopify-app/st-modules/enrollment/blocks/required-kits/enrollment-section-required-kits", "core/shopify-app/st-modules/enrollment/_general/enrollment-store", "core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review", "core/shopify-app/st-modules/enrollment/page/enrollment-page", "core/shopify-app/st-modules/_general-methods/currency", "core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review-cart", "core/shopify-app/st-modules/_general-methods/form/formatting", "core/shopify-app/st-modules/enrollment/blocks/account-details/account-details-helpers", "core/shopify-app/st-modules/enrollment/blocks/business-info/business-details-helpers", "core/shopify-app/st-modules/webalias/webalias-class-config", "core/shopify-app/st-modules/account/header/nav/account-nav", "core/shopify-app/st-modules/account/header/backoffice-sso/backoffice-sso", "core/shopify-app/st-modules/account/blocks/web-alias-edit/web-alias-edit", "core/shopify-app/st-modules/account/blocks/personal-site/personal-site", "core/shopify-app/st-modules/account/blocks/addresses/addresses", "core/shopify-app/st-modules/account/blocks/personal-info/personal-info", "core/shopify-app/st-modules/account/blocks/order-history/order-history", "core/shopify-app/st-modules/cart/cart", "core/shopify-app/st-modules/main/auto-apply-promo", "core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page", "core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page-class-config", "core/shopify-app/st-modules/search-sponsor/search-sponsor-guard", "core/shopify-app/st-modules/search-sponsor/search-sponsor-service", "core/shopify-app/st-modules/reset-password/reset-password-class-config", "core/shopify-app/st-modules/reset-password/reset-password", "core/shopify-app/st-modules/enrollment/enrollment-cleanup", "core/shopify-app/st-modules/referral/referral", "core/shopify-app/st-modules/account/blocks/coupon-codes/coupon-codes", "core/shopify-app/st-modules/auth/auth", "core/shopify-app/st-modules/share-cart/share-cart-class-config", "core/shopify-app/st-modules/share-cart/share-cart-drawer", "core/shopify-app/st-modules/share-cart/share-cart-landing", "core/shopify-app/st-modules/account/blocks/account-share-cart/account-share-cart-utils", "core/shopify-app/st-modules/account/blocks/account-share-cart/account-share-cart", "core/shopify-app/st-modules/cart/cart-enrollment", "core/shopify-app/st-modules/account/blocks/promo-codes/promo-codes", "core/shopify-app/st-modules/sso-landing-after/landing-after-sso", "core/shopify-app/st-modules/sso-confirm-sponsor/confirm-sponsor" ], function(require, exports, static_4, guards_1, webalias_1, account_1, enrollment_1, browser_history_1, cart_manipulation_1, cookies_1, customer_type_1, loader_1, general_methods_1, button_actions_2, form_1, notification_10, object_formatting_1, di_container_public_1, enrollment_nav_1, enrollment_submit_1, enrollment_class_config_1, date_input_1, form_class_config_1, enrollment_validation_1, enrollment_section_review_privacy_1, enrollment_section_account_details_1, enrollment_section_business_details_1, enrollment_validation_setup_1, account_class_config_1, inject_representative_info_1, search_sponsor_1, sponsor_search_class_config_1, enrollment_section_optional_kits_1, enrollment_section_required_kits_1, enrollment_store_1, enrollment_review_1, enrollment_page_1, currency_2, enrollment_review_cart_1, formatting_1, account_details_helpers_1, business_details_helpers_1, webalias_class_config_1, account_nav_1, backoffice_sso_1, web_alias_edit_1, personal_site_1, addresses_1, personal_info_1, order_history_1, cart_1, auto_apply_promo_1, representative_redirect_page_1, representative_redirect_page_class_config_1, search_sponsor_guard_1, search_sponsor_service_1, reset_password_class_config_1, reset_password_1, enrollment_cleanup_1, referral_1, coupon_codes_1, auth_1, share_cart_class_config_1, share_cart_drawer_1, share_cart_landing_1, account_share_cart_utils_1, account_share_cart_1, cart_enrollment_1, promo_codes_1, landing_after_sso_1, confirm_sponsor_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAppDIConfig = void 0;
    var StAppDIConfig = function() {
        function StAppDIConfig() {
            var _this = this;
            this.className = "AppDIConfig";
            this.init = function() {};
            this.components = function() {
                _this.StStaticComponent = static_4.StStatic.Instance();
                _this.StAuthComponent = new auth_1.StAuth();
                _this.StGuardsComponent = new guards_1.StGuards();
                _this.LandingAfterSsoComponent = new landing_after_sso_1.LandingAfterSso();
                _this.DiContainerPublicComponent = new di_container_public_1.DiContainerPublic();
                _this.StObjectFormattingComponent = new object_formatting_1.StObjectFormatting();
                _this.StBrowserHistoryComponent = new browser_history_1.StBrowserHistory(_this.StObjectFormattingComponent);
                _this.StCartManipulationComponent = new cart_manipulation_1.StCartManipulation();
                _this.StCookiesComponent = new cookies_1.StCookies();
                _this.StCustomerTypeComponent = new customer_type_1.StCustomerType();
                _this.StLoaderComponent = new loader_1.StLoader();
                _this.StButtonActionsComponent = new button_actions_2.StButtonActions();
                _this.StNotificationComponent = new notification_10.StNotification();
                _this.StFormConfigComponent = new form_class_config_1.StFormClassConfig();
                _this.StGeneralMethodsComponent = new general_methods_1.StGeneralMethods();
                _this.StCurrencyComponent = new currency_2.StCurrency();
                _this.StFormattingComponent = new formatting_1.StFormFormatting();
                _this.StAutoApplyPromoComponent = new auto_apply_promo_1.StAutoApplyPromo();
                _this.StCartComponent = new cart_1.StCart();
                _this.StEnrollmentClassConfigComponent = new enrollment_class_config_1.StEnrollmentClassConfig();
                _this.StEnrollmentSectionPrivacyComponent = new enrollment_section_review_privacy_1.StEnrollmentSectionPrivacy(_this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentAccountDetailsHelpersComponent = new account_details_helpers_1.StEnrollmentAccountDetailsHelpers(_this.StFormattingComponent, _this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentBusinessDetailsHelpersComponent = new business_details_helpers_1.StEnrollmentBusinessDetailsHelpers(_this.StFormattingComponent, _this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentSectionAccountDetailsComponent = new enrollment_section_account_details_1.StEnrollmentSectionAccountDetails();
                _this.StEnrollmentSectionBusinessDetailsComponent = new enrollment_section_business_details_1.StEnrollmentSectionBusinessDetails();
                _this.StEnrollmentStoreComponent = new enrollment_store_1.StEnrollmentStore(_this.StEnrollmentClassConfigComponent, _this.StCartComponent);
                _this.StEnrollmentPageComponent = new enrollment_page_1.StEnrollmentPage(_this.StEnrollmentClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StAccountClassConfigComponent = new account_class_config_1.StAccountClassConfig();
                _this.StSearchSponsorClassConfigComponent = new sponsor_search_class_config_1.StSearchSponsorClassConfig();
                _this.StDateInputComponent = new date_input_1.StDateInput(_this.StFormConfigComponent);
                _this.StFormComponent = new form_1.StForm(_this.StFormConfigComponent, _this.StDateInputComponent);
                _this.StWebAliasClassConfigComponent = new webalias_class_config_1.StWebAliasClassConfig();
                _this.StInjectRepresentativeInfoComponent = new inject_representative_info_1.StInjectRepresentativeInfo(_this.StWebAliasClassConfigComponent);
                _this.StSearchSponsorGuardComponent = new search_sponsor_guard_1.StSearchSponsorGuard(_this.StSearchSponsorClassConfigComponent, _this.StBrowserHistoryComponent, _this.StObjectFormattingComponent, _this.StGeneralMethodsComponent, _this.StCartComponent);
                _this.StAccountPersonalSiteComponent = new personal_site_1.StAccountPersonalSite(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StShareCartLandingComponent = new share_cart_landing_1.StShareCartLanding(_this.StObjectFormattingComponent, _this.StCartComponent);
                _this.StWebAliasComponent = new webalias_1.StWebAlias(_this.StWebAliasClassConfigComponent, _this.StBrowserHistoryComponent, _this.StObjectFormattingComponent, _this.StCookiesComponent, _this.StCustomerTypeComponent, _this.StGeneralMethodsComponent, _this.StInjectRepresentativeInfoComponent, _this.StCartComponent, _this.StSearchSponsorGuardComponent, _this.StAccountPersonalSiteComponent, _this.StShareCartLandingComponent);
                _this.StShareCartClassConfigComponent = new share_cart_class_config_1.StShareCartClassConfig();
                _this.StShareCartDrawerComponent = new share_cart_drawer_1.StShareCartDrawer(_this.StShareCartClassConfigComponent, _this.StGeneralMethodsComponent, _this.StCartComponent, _this.StObjectFormattingComponent, _this.StNotificationComponent);
                _this.StShareCartUtilsComponent = new account_share_cart_utils_1.StAccountShareCartUtils(_this.StGeneralMethodsComponent, _this.StObjectFormattingComponent);
                _this.StAccountShareCartComponent = new account_share_cart_1.StAccountShareCart(_this.StObjectFormattingComponent, _this.StGeneralMethodsComponent, _this.StCartComponent, _this.StShareCartUtilsComponent);
                _this.StSearchSponsorService = new search_sponsor_service_1.StSearchSponsorService();
                _this.StSearchSponsorComponent = new search_sponsor_1.StSearchSponsor(_this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StBrowserHistoryComponent, _this.StSearchSponsorClassConfigComponent, _this.StCookiesComponent, _this.StCartComponent, _this.StSearchSponsorService);
                _this.StConfirmSponsorComponent = new confirm_sponsor_1.StConfirmSponsor();
                _this.StEnrollmentValidationComponent = new enrollment_validation_1.StEnrollmentValidation(_this.StEnrollmentClassConfigComponent, _this.StNotificationComponent, _this.StEnrollmentPageComponent);
                _this.StEnrollmentValidationSetupComponent = new enrollment_validation_setup_1.StEnrollmentValidationSetup(_this.StEnrollmentValidationComponent, _this.StEnrollmentSectionPrivacyComponent, _this.StEnrollmentSectionAccountDetailsComponent, _this.StEnrollmentSectionBusinessDetailsComponent);
                _this.StEnrollmentReviewCartComponent = new enrollment_review_cart_1.StEnrollmentReviewCart(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StCurrencyComponent);
                _this.StEnrollmentOptionalKitsComponent = new enrollment_section_optional_kits_1.StEnrollmentOptionalKits(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StEnrollmentReviewCartComponent);
                _this.StEnrollmentRequiredKitsComponent = new enrollment_section_required_kits_1.StEnrollmentRequiredKits(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StEnrollmentReviewCartComponent);
                _this.StEnrollmentReviewComponent = new enrollment_review_1.StEnrollmentReview(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StGeneralMethodsComponent, _this.StEnrollmentPageComponent, _this.StCurrencyComponent, _this.StFormComponent, _this.StEnrollmentReviewCartComponent);
                _this.StEnrollmentActionsComponent = new enrollment_submit_1.StEnrollmentActions(_this.StEnrollmentClassConfigComponent, _this.StNotificationComponent);
                _this.StEnrollmentNavComponent = new enrollment_nav_1.StEnrollmentNav(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentActionsComponent, _this.StEnrollmentOptionalKitsComponent, _this.StEnrollmentRequiredKitsComponent, _this.StEnrollmentStoreComponent, _this.StFormComponent, _this.StButtonActionsComponent, _this.StEnrollmentValidationComponent, _this.StEnrollmentValidationSetupComponent, _this.StNotificationComponent, _this.StEnrollmentReviewComponent, _this.StEnrollmentPageComponent);
                _this.StEnrollmentComponent = new enrollment_1.StEnrollment(_this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentCleanupComponent = new enrollment_cleanup_1.StEnrollmentCleanup(_this.StCartComponent);
                _this.StAccountNavComponent = new account_nav_1.StAccountNav(_this.StAccountClassConfigComponent, _this.StObjectFormattingComponent, _this.StBrowserHistoryComponent, _this.StGeneralMethodsComponent);
                _this.StBackofficeSSOComponent = new backoffice_sso_1.StBackofficeSSO(_this.StAccountClassConfigComponent, _this.StNotificationComponent);
                _this.StAccountWebAliasEditComponent = new web_alias_edit_1.StAccountWebAliasEdit(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StFormComponent, _this.StFormattingComponent);
                _this.StAccountAddressesComponent = new addresses_1.StAccountAddresses(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StAccountPersonalInfoComponent = new personal_info_1.StAccountPersonalInfo(_this.StAccountClassConfigComponent, _this.StFormComponent, _this.StFormattingComponent, _this.StButtonActionsComponent, _this.StNotificationComponent, _this.StGeneralMethodsComponent);
                _this.StAccountOrderHistoryComponent = new order_history_1.StAccountOrderHistory(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StAccountComponent = new account_1.StAccount(_this.StFormComponent);
                _this.StResetPasswordClassConfigComponent = new reset_password_class_config_1.StResetPasswordClassConfig();
                _this.StResetPasswordComponent = new reset_password_1.StResetPassword(_this.StFormComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StResetPasswordClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StRepresentativeRedirectClassConfigComponent = new representative_redirect_page_class_config_1.StRepresentativeRedirectClassConfig();
                _this.StRepresentativeRedirectComponent = new representative_redirect_page_1.StRepresentativeRedirectPage(_this.StRepresentativeRedirectClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StReferralComponent = new referral_1.StReferral(_this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StNotificationComponent);
                _this.StCouponCodesComponent = new coupon_codes_1.StCouponCodes();
                _this.StCartEnrollment = new cart_enrollment_1.StCartEnrollment();
                _this.StAccountPromoCodesComponent = new promo_codes_1.StPromoCodes(_this.StNotificationComponent);
            };
            this.hierarchy = function(appName) {
                var hierarchy = [ _this.DiContainerPublicComponent, _this.StStaticComponent, _this.StGuardsComponent ];
                switch (appName) {
                  case "main":
                    hierarchy = hierarchy.concat([ _this.StAuthComponent, _this.StCartComponent, _this.StCartEnrollment, _this.StAutoApplyPromoComponent, _this.StWebAliasComponent, _this.StSearchSponsorGuardComponent, _this.StSearchSponsorComponent, _this.StReferralComponent, _this.StShareCartClassConfigComponent, _this.StShareCartDrawerComponent, _this.StShareCartLandingComponent ]);
                    break;

                  case "account":
                    hierarchy = hierarchy.concat([ _this.StWebAliasComponent, _this.StAccountComponent, _this.StAccountNavComponent, _this.StBackofficeSSOComponent, _this.StAccountWebAliasEditComponent, _this.StAccountPersonalSiteComponent, _this.StAccountAddressesComponent, _this.StAccountPersonalInfoComponent, _this.StAccountOrderHistoryComponent, _this.StCouponCodesComponent, _this.StAccountShareCartComponent, _this.StAccountPromoCodesComponent ]);
                    break;

                  case "reset-password":
                    hierarchy = hierarchy.concat([ _this.StResetPasswordComponent ]);
                    break;

                  case "enrollment":
                    hierarchy = hierarchy.concat([ _this.StEnrollmentComponent, _this.StEnrollmentReviewComponent, _this.StEnrollmentNavComponent, _this.StEnrollmentAccountDetailsHelpersComponent, _this.StEnrollmentBusinessDetailsHelpersComponent ]);
                    break;

                  case "checkout":
                    hierarchy = hierarchy.concat([]);
                    break;

                  case "representative-redirect-page":
                    hierarchy = hierarchy.concat([ _this.StRepresentativeRedirectComponent, _this.StRepresentativeRedirectClassConfigComponent, _this.StGeneralMethodsComponent ]);
                    break;

                  case "enrollment-thank-you":
                    hierarchy = hierarchy.concat([]);
                    break;

                  case "landing-after-sso":
                    hierarchy = hierarchy.concat([ _this.LandingAfterSsoComponent ]);
                    break;

                  case "confirm-sponsor":
                    hierarchy = hierarchy.concat([ _this.StSearchSponsorComponent, _this.StSearchSponsorGuardComponent, _this.StConfirmSponsorComponent ]);
                    break;

                  default:
                    console.error("Unrecognized app provided to st-app. App name: " + appName);
                }
                return hierarchy;
            };
            this.components();
        }
        Object.defineProperty(StAppDIConfig, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StAppDIConfig;
    }();
    exports.StAppDIConfig = StAppDIConfig;
});

define("core/shopify-app/st-modules/_di-container/di.container", [ "require", "exports", "_shopify.app.di.container", "core/shopify-app/st-modules/_di-container/di.container.setup" ], function(require, exports, _shopify_app_di_container_1, di_container_setup_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDIContainer = void 0;
    var StDIContainer = function() {
        function StDIContainer() {
            this.className = "DI";
        }
        StDIContainer.run = function(appName) {
            new di_container_setup_1.StDIContainerSetup(appName, _shopify_app_di_container_1.StAppDIConfig);
        };
        return StDIContainer;
    }();
    exports.StDIContainer = StDIContainer;
});

define("core/shopify-app/st-modules/_general-methods/init-retry", [ "require", "exports", "core/shopify-app/st-modules/_static/static" ], function(require, exports, static_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInitRetry = void 0;
    var StInitRetry = function() {
        function StInitRetry() {
            var _this_1 = this;
            this.className = "InitRetry";
            this.recursiveInitRetry = 0;
            this.timeout = 200;
            this.init = function() {};
            this.initWithCondition = function(params) {
                var _this = _this_1;
                var def = {
                    conditionGeneratorParams: [],
                    callbackParams: [],
                    noOfRetries: 6
                };
                var completeParams = __assign(__assign({}, def), params);
                var initCondition = completeParams.conditionGenerator.apply(_this, completeParams.conditionGeneratorParams);
                if (initCondition) {
                    completeParams.callback.apply(_this, completeParams.callbackParams);
                } else {
                    setTimeout(function() {
                        if (_this.recursiveInitRetry < completeParams.noOfRetries) {
                            _this.recursiveInitRetry++;
                            _this.initWithCondition(completeParams);
                        }
                    }, _this_1.timeout);
                }
            };
            this.endpoint = static_5.StStatic.Instance().obtainStaticEndpoints();
        }
        StInitRetry.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        return StInitRetry;
    }();
    exports.StInitRetry = StInitRetry;
});

define("core/shopify-app/st-modules/_general-methods/shopify-ajax", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_66) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShopifyAjax = void 0;
    var StShopifyAjax = function(_super) {
        __extends(StShopifyAjax, _super);
        function StShopifyAjax() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ShopifyAjax";
            _this.updateCartAttributes = function(attributes, callback, callbackParams) {
                if (callback === void 0) {
                    callback = function() {};
                }
                if (callbackParams === void 0) {
                    callbackParams = [];
                }
                if (!!attributes) {
                    var fnReference_1 = _this;
                    var request_2 = new XMLHttpRequest();
                    request_2.open("POST", "/cart/update.js", true);
                    request_2.withCredentials = true;
                    request_2.setRequestHeader("Content-Type", "application/json");
                    request_2.onreadystatechange = function() {
                        if (request_2.readyState === 4) {
                            try {
                                var resp = JSON.parse(request_2.response);
                                callbackParams.unshift(resp);
                                callback.apply(fnReference_1, callbackParams);
                            } catch (e) {
                                console.error(e);
                                console.error("Failed to update shopify cart attributes!");
                            }
                        }
                    };
                    request_2.send(JSON.stringify({
                        attributes: attributes
                    }));
                }
            };
            return _this;
        }
        return StShopifyAjax;
    }(st_module_66.StModule);
    exports.StShopifyAjax = StShopifyAjax;
});

define("core/shopify-app/st-modules/enrollment/enrollment-cleanup-checkout", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_67) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentCleanupCheckout = void 0;
    var StEnrollmentCleanupCheckout = function(_super) {
        __extends(StEnrollmentCleanupCheckout, _super);
        function StEnrollmentCleanupCheckout(enrollmentCleanup) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StEnrollmentCleanupCheckout";
            _this.init = function() {
                _this.enrollmentCleanup.clearCartAttributes();
            };
            _this.enrollmentCleanup = enrollmentCleanup;
            return _this;
        }
        return StEnrollmentCleanupCheckout;
    }(st_module_67.StModule);
    exports.StEnrollmentCleanupCheckout = StEnrollmentCleanupCheckout;
});

(function() {
    "use strict";
    class StApp extends HTMLElement {
        static get observedAttributes() {
            return [ "app" ];
        }
        constructor() {
            super();
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if (name === "app" && oldValue !== newValue) {
                this.initApp(newValue);
            }
        }
        initApp(appName) {
            require([ "core/shopify-app/st-modules/_di-container/di.container" ], function(module) {
                module.StDIContainer.run(appName);
            });
        }
    }
    customElements.define("st-app", StApp);
})();

window.define = null;